<template>
  <div ref="dynamicContent" id="app" class="component-container" :class="{ 'external-showing-cart': isExternal && cartVisible, 'external-no-prices': isExternal && !showPrices }">
    <div v-show="cartVisible" class="cartComponent">
            <Cart ref="cartComponent"/>
          </div>
    <!-- Error Popup -->
      <div v-if="error" class="error-popup-overlay">
        <div class="error-popup">
          <p>{{ errorMessage }}</p>
          <button @click="clearError">Schließen</button>
        </div>
      </div>
      <div class="configurator-header">
        <div class="logo-container">
          <img :src="isExternal ? '/m_s_logo.svg' : 'https://sander-gruppe.eu/wp-content/uploads/2019/07/ms-logo.png'" alt="M+S" class="logo" @click="goBack">
        </div>
        <div class="flex-down">
          <div class="component-container-header">
              Position anlegen
          </div>
          <div v-if="selectedProject" class="component-container-header">
                Projekt: {{ selectedProject.name }}
          </div>
        </div>
      </div>
      <div v-if="isSelectedProjectReadOnly" class="project-readonly-banner" role="status">
        <i class="fa fa-lock"></i>
        <div>
          <strong>Projekt gesperrt</strong>
          <span>{{ projectReadOnlyMessage }}</span>
        </div>
      </div>
      <div class="left-right-container">
        <div class="product-search-filter-area">
          <section class="product-search-filters" aria-label="Produktsuche eingrenzen">
            <div class="product-search-filters-header">
              <div class="product-search-filters-heading">
                <svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true">
                  <path d="M4 6h16M7 12h10M10 18h4" stroke-linecap="round" />
                </svg>
                <strong>Produktbereiche</strong>
                <span class="product-search-filter-status" role="status">{{ productSearchFilterStatus }}</span>
              </div>
              <button type="button" class="product-search-filter-reset" :disabled="activeProductFilters.length === 0" @click="resetProductFilters">
                Zurücksetzen
              </button>
            </div>
            <div class="product-search-filter-buttons" role="group" aria-label="Produktbereiche auswählen">
              <button
                v-for="filter in availableProductSearchFilters"
                :key="filter.key"
                type="button"
                class="product-search-filter"
                :class="{ 'is-active': activeProductFilters.includes(filter.key) }"
                :aria-pressed="activeProductFilters.includes(filter.key)"
                :data-product-filter="filter.key"
                @click="toggleProductFilter(filter.key)"
              >
                <span class="product-search-filter-indicator" aria-hidden="true">{{ activeProductFilters.includes(filter.key) ? '✓' : '+' }}</span>
                {{ filter.label }}
              </button>
            </div>
            <p class="product-search-filter-hint">Mehrfachauswahl möglich</p>
          </section>
        </div>
        <div class="right">
        <div class="upper-area" @keydown="handleConfiguratorEnter">
          <div v-if="selectedProject" class="category">
            <div>
              <!-- <h2>Bezeichnung der Position</h2> -->
              <div class="container">
                <div class="input-container">
                  <input id="article-input-text" type="text" class="input container-input-text" disabled="disabled" :value="formattedPosition" maxlength="5">
                  <div class="container-input-label">Pos.:</div>
                </div>
                <div class="input-container">
                  <input id="article-input-text" autocomplete="off" ref="positionInput" type="text" class="input container-input-text" v-model="positionBezeichnung" v-room-designation placeholder="Namen eingeben" @focus="selectPositionContent"  maxlength="7" :disabled="isSelectedProjectReadOnly" :class="{ 'position-exists': positionExists }">
                  <div class="container-input-label">Raum:</div>
                  <InfoTooltip text="Geben Sie hier die Raumnummer oder -bezeichnung ein." />
                  <!-- ErrorTooltip muss einmal verwendet werden, ansonsten meckert lint. ErrorTooltip wird bei den dynamischen Feldern benötigt. -->
                  <ErrorTooltip v-if="false"/>
                </div>
                <div class="input-container">
                  <input 
                    id="anzahl" 
                    class="input container-input-text"
                    type="text"
                    inputmode="numeric"
                    autocomplete="off"
                    :value="formattedAnzahl"
                    @input="handleAnzahlInput"
                    @blur="commitAnzahlChange"
                    :disabled="isSelectedProjectReadOnly"
                  />
                  <div class="container-input-label">Anzahl:</div>
                </div>
              </div>
            </div>
          </div>
          <div class="category">
            <div>
              <div class="container">
                <div class="input-container">
                  <input id="article-input-text" autocomplete="off" ref="searchInput" type="text" class="input container-input-text" v-model="searchTextArticle" placeholder="Suche..." role="combobox" aria-autocomplete="list" aria-controls="search-results" :aria-expanded="isProductSearchOpen && filterAllArticleKeywords.length > 0" @input="onSearchInput" @change="changeArticleByText" @focus="selectInputContent" @blur="closeProductSearch" @keydown="navigateSearchResults" :disabled="isSelectedProjectReadOnly">
                  <div class="container-input-label">Produkt:</div>
                  <InfoTooltip v-if="fittingDescriptionHtml != ''" :text=fittingDescriptionHtml />       
                  <ul v-show="isProductSearchOpen && filterAllArticleKeywords.length > 0" id="search-results" ref="searchResults" role="listbox" aria-label="Produkte">
                    <li v-for="(articleKeyword, index) in filterAllArticleKeywords" :key="articleKeyword" role="option" :aria-selected="index === highlightedIndex" :class="{ highlighted: index === highlightedIndex }" @mousedown.prevent @click="selectArticle(articleKeyword)">
                      {{ articleKeyword }}
                    </li>
                  </ul>
                  <div v-if="isProductSearchOpen && activeProductFilters.length > 0 && filterAllArticleKeywords.length === 0" class="product-search-empty" role="status">
                    Keine Treffer in den ausgewählten Bereichen.
                  </div>
              </div>
            </div>
            </div>
          </div>
          <!-- <div id="fitting-description" v-if="selectedArticle != null" v-html="fittingDescriptionHtml"></div> -->
          <div 
          :id='"s_"+step.id' 
          :class="{ 
            'category' : step.inner_position == 0,
            'inner-category' : step.inner_position != 0,
            'additional-option' : isAdditionalOptionStep(step),
            'mandatory-field' : step.is_mandatory == 1,
          }" 
          v-for="(step, index) in filteredStepItems" 
          :key="index"
          :style="step.type == 3 || step.isHiddenByRule ? {visibility: 'hidden', height: '0px'} : {}"
          >
            <div class="category-index" style="visibility: hidden;">{{ index }}</div>
            <div class="step-id" style="visibility: hidden;">{{ step.id }}</div>
            <div class="step-type" style="visibility: hidden;">{{ step.type }}</div>
            <div class="category-title" :style="step.inner_position != 0 ? {visibility: 'hidden', height: '0px', padding: '0px'} : {}">
              {{ getStepName(step) }}
            </div>
            <div :class="{
              'category-content' : step.inner_position == 0,
              'inner-category-content' : step.inner_position != 0
            }" 
            ><DynamicRenderer :templateString="getStepTemplate(step)" /></div>
          </div>
          <div class="category">
              <div class="container">
                <div class="input-container">
                  <textarea type="text" v-model="notizen" placeholder="Ihre Notizen zur Position..." rows="5" cols="40" maxlength="200" :readonly="isSelectedProjectReadOnly"></textarea>
                  <div v-if="showPrices" class="note-price-information">*Achtung, eventuell ergeben sich durch Ihre Notiz Preisänderungen</div>
                  <div class="character-count">{{ notizen != null ? notizen.length : 0 }}/200 Zeichen</div>
                </div>
              </div>
          </div>
        </div>
        <confirmation-dialog 
          v-if="showDeleteConfirmation" 
          :message="'Möchten Sie diese Position wirklich löschen?'" 
          @confirm="deletePosition"
          @cancel="cancelDelete"
        />
        <!-- <div class="button-container navigation-button-container">
          <button v-for="savedArticle in savedArticles" :key="savedArticle" @click="loadSavedArticle(savedArticle)">Pos. {{ savedArticle.position_bezeichnung }}</button>
        </div> -->
      </div>
        <div class="left">
          <div v-if="selectedArticle != null" class="article-picture-container">
            <div class="carousel">
              <img :src="currentImageSrc" alt="Baureihen-Bild" id="fitting-image" @click="openImagePopup" @error="handleProductImageError">
              <div class="carousel-buttons">
                <button @click="prevImage" class="carousel-button">‹ Vorheriges Bild</button>
                <button @click="nextImage" class="carousel-button">Nächstes Bild ›</button>
              </div>
              <div class="montage-link" v-if="montageLinkAvailable">
                <button @click="openMontageLink">Montageanleitung öffnen</button>
              </div>
            </div>
          </div>
          <div v-if="showPrices || selectedArticle != null || visibleAddedItems.length > 0" class="configured-article-container">
            <div class="added-items">
              <div v-if="selectedArticle != null" v-html="fittingNameHtml"> </div>
              <ul>
                <li v-for="item in visibleAddedItems" :key="item.id">
                  <div class="added-items-name">{{ item.name }}:</div><div class="added-items-seperator"></div><div class="added-items-value">{{ formatAddedItemValue(item) }}</div>
                </li>
              </ul>
            </div>
            <div v-if="showPrices" class="price-display">
              <div id="price-single-price">{{ isExternal ? 'Listenpreis:' : 'Ihr Einzelpreis:' }}</div>
              <div id="price-container">
                <div id="price-container-price" :class="{ 'calculating': isCalculatingPrice }">
                  <span v-if="isCalculatingPrice" class="price-calculating">Berechnung...</span>
                  <span v-else-if="rasterDimensionError">Preis auf Anfrage</span>
                  <span v-else>{{ price > (getAccessoryElement() ? 0 : 1) ? formatPriceValue(price) : "Preis auf Anfrage" }}</span>
                </div>
                <div v-if="!isCalculatingPrice" id="price-container-mwst">zzgl. MwSt.</div>
              </div>
              <div v-if="priceWithTeuerungszuschlag !== null" class="price-with-tz">
                <span class="price-with-tz-amount">{{ formatPriceValue(priceWithTeuerungszuschlag) }}</span>
                <span>inkl. TZ, zzgl. MwSt.</span>
              </div>
            </div>
          </div>
          <div class="button-container">
              <button
                id="button-save-in-cart"
                class="button-with-icon"
                :disabled="isSelectedProjectReadOnly || (isExternal && isLoading)"
                :title="isSelectedProjectReadOnly ? projectReadOnlyMessage : ''"
                @click="saveOrUpdate()"
              >
                <img class="icon-in-button" :src="floppyIcon" alt="Icon" />
                In den Warenkorb / speichern
              </button>
              <!-- <button @click="saveASJSON(false)">Neue Position speichern</button>
              <button @click="saveASJSON(true)">Position überschreiben</button> -->
            </div>
            <div class="button-container navigation-button-container">
              <button class="button-with-icon" @click="clearFields">
                <img class="icon-in-button" :src="trashIcon" alt="Icon" />
                Felder leeren
              </button>
              <button v-if="!isExternal" class="button-with-icon" @click="goBack">
                <img class="icon-in-button" :src="houseIcon" alt="Icon" />
                Zum Dashboard
              </button>
              <button class="button-with-icon" @click="toggleCart">
                <img class="icon-in-button" :src="cartIcon" alt="Icon" />
                Zum Warenkorb
              </button>
            </div>
        </div>
    </div>
    <div v-if="isLoading" class="loading-overlay">
      <div class="spinner"></div>
    </div>
    <div v-if="showImagePopup" class="image-popup-overlay">
      <div class="image-popup">
        <button class="close-button" @click="closeImagePopup">✖</button>
        <div
          ref="imagePopupViewport"
          class="image-popup-viewport"
          :class="{
            'is-zoomed': isImagePannable,
            'is-overflow-x': isImageOverflowX,
            'is-overflow-y': isImageOverflowY,
            'is-dragging': isImageDragging
          }"
          @pointerdown="startImagePan"
          @pointermove="panImage"
          @pointerup="endImagePan"
          @pointercancel="endImagePan"
          @lostpointercapture="endImagePan"
          @wheel.capture.stop.prevent="handleImageWheel"
        >
          <img :src="currentImageSrc"
          @error="handleProductImageError"
          alt="Vergrößertes Bild"
          ref="imagePopupImage"
          draggable="false"
          :class="{'zoomed-image': true, 'fullscreen': isImageZoomed}"
          :style="imagePopupImageStyle"
          @load="updateImagePopupBaseSize">
        </div>
        <div class="image-zoom-controls">
          <button
            class="image-zoom-button"
            type="button"
            aria-label="Zoom verkleinern"
            @click="decreaseImageZoom"
          >
            <i class="fa-solid fa-magnifying-glass-minus"></i>
          </button>
          <input
            :value="imageZoom"
            class="image-zoom-slider"
            type="range"
            min="100"
            max="240"
            step="1"
            aria-label="Zoom"
            @input="handleImageZoomInput"
          >
          <button
            class="image-zoom-button"
            type="button"
            aria-label="Zoom vergrößern"
            @click="increaseImageZoom"
          >
            <i class="fa-solid fa-magnifying-glass-plus"></i>
          </button>
          <span class="image-zoom-value">{{ imageZoom }}%</span>
        </div>
        <div class="image-popup-navigation">
          <button class="image-popup-nav-button" type="button" @click="prevImage">
            <i class="fa-solid fa-chevron-left"></i>
            <span>Vorheriges Bild</span>
          </button>
          <button class="image-popup-nav-button" type="button" @click="nextImage">
            <span>Nächstes Bild</span>
            <i class="fa-solid fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </div>
    <LegalFooter v-if="!isExternal" />
  </div>
</template>

<script>
import api from '@/api/client';
import { createInternalConfiguratorApi } from '@/configurator/ConfiguratorApi';
import { CONFIGURATOR_CONTEXT, EXTERNAL, requiresUnsupportedPowderFee, integrationErrorMessage } from '@/configurator/ConfiguratorContext';
import { formatInteger, formatPrice, normalizePositiveInteger } from '@/utils/numberFormat';
import { getKaempferLinksXLFolder, getSlidingDirectionFolder, shouldUseXLhochK29 } from '@/utils/imagePriority';
import { expandDimensionItems, formatAuflagenValue, formatWinkelBuerstenProfilValue } from '@/utils/configurationItems';
import { PRODUCT_SEARCH_FILTERS } from '@/utils/productSearchFilters';
import { productImageFallback, handleProductImageError, getProductImageFolder } from '@/utils/productImage';
import Cart from './WarenkorbComponent.vue';
import ConfirmationDialog from './ConfirmationDialog.vue';
import InfoTooltip from './InfoTooltip.vue';
import ErrorTooltip from './ErrorTooltip.vue';
import DynamicRenderer from './DynamicRenderer.vue';
import LegalFooter from './LegalFooter.vue';
import roomDesignation from '@/directives/roomDesignation';

// Statische Assets als Imports, damit Tests und Build ohne require() auskommen
import floppyIcon from '@/assets/dashboard/floppy-disk-solid-white.svg';
import trashIcon from '@/assets/dashboard/trash-solid-dark-grey.svg';
import houseIcon from '@/assets/dashboard/house-solid-dark-grey.svg';
import cartIcon from '@/assets/dashboard/cart-shopping-solid-dark-grey.svg';

const TEMPORARY_RAL_PRICE_REQUEST_ARTICLE_IDS = new Set([26, 27, 28]);
const RAL_NACH_WAHL_OPTION_VALUE = '28';
const MAX_KAEMPFER_MASS = 1500;
const KAEMPFER_DIMENSION_SELECTOR = 'input.x_value, input.y_value, input[class*="_b_value"], input[class*="_h_value"]';
const RASTER_DIMENSION_ERROR = 'Diese Kombination aus Breite und Höhe ist nicht möglich.';

export default {
  directives: { roomDesignation },
  inject: { getConfiguratorContext: { from: CONFIGURATOR_CONTEXT, default: null } },
  components: {
    Cart,
    ConfirmationDialog,
    InfoTooltip,
    ErrorTooltip,
    DynamicRenderer,
    LegalFooter
  },
  data() {
    return {
      // statische Assets für Buttons/Fußzeile
      floppyIcon,
      trashIcon,
      houseIcon,
      cartIcon,
       // ... Ihre bisherigen Daten ...
       // Für das Speicher der Daten in einer JSON
       savedValues: [

       ],
       addedItems: [
        // Beispiel für hinzugefügte Artikel
        // {id: 1, name: "Beschlagsgruppe", value: "100"},
        // {id: 2, name: "Größenangaben", value: "2000mm x 1000mm"},
        // {id: 3, name: "ms Standard-Farben", value: "RAL 9016 matt"},
        // ... weitere Artikel ...
      ],
      // Debouncing und Race Condition Prevention
      isCalculatingPrice: false,
      isStulpSyncing: false,
      articleLists: [],
      allArticleKeywords: [],
      productSearchFilters: PRODUCT_SEARCH_FILTERS,
      activeProductFilters: [],
      isProductSearchOpen: false,
      stepRules: [],
      stepLists: [],
      stepPrices: [],
      chargePrices: [],
      ralFarben: [],
      selectedRalHex: null,
      currentRalPricing: null,
      ralLookupPowderOverride: false,
      priceLists: [],
      priceListPriceElements: [],
      prices: [],
      fittingPropertyList: [],
      searchTextArticle: '',
      fittingNameHtml: '',
      fittingDescriptionHtml: '',
      fittingImageSrc: 'http://87.106.159.180/img/100.jpg',
      images: [],  // Hier speichern wir die Bilder der aktuellen Baureihe
      currentImageIndex: 0,
      selectedStepId: 0,
      selectedPrice: null,
      selectedArticle: null,
      isArticleRefreshed: false,
      maxHeight: 100,
      price: 0.0,
      teuerungszuschlagRate: null,
      xValue: '',
      yValue: '',
      configurationJSON: '',
      positionBezeichnung: '',
      position: 1,
      selectedProject: null,
      savedArticles: [],
      selectedArticleName: '',
      selectedArticleId: -1,
      productRefreshed: false,
      anzahl: 1,
      notizen: '',
      cartVisible: false,
      highlightedIndex: -1,
      positionExists: false,
      error: false,
      errorMessage: '',
      isLoading: false,
      showDeleteConfirmation: false,
      showImagePopup: false,
      imagePopupPageOverflow: null,
      imageZoom: 100,
      imageBaseWidth: 0,
      imageBaseHeight: 0,
      imageViewportWidth: 0,
      imageViewportHeight: 0,
      isImageDragging: false,
      imagePanStartX: 0,
      imagePanStartY: 0,
      imagePanStartScrollLeft: 0,
      imagePanStartScrollTop: 0,
      positionIsEdited: false,
      montageLinkAvailable: false,
      montageLinkUrl: '',
      maxArticleWidth: null,
      maxArticleHeight: null,
      minArticleWidth: null,
      minArticleHeight: null,
      minDimensionValue: 300,
      isXLVariant: false,
      isHeightGreaterThanWidth: false,
      isHeightForKaempfer: false,
      isWidthForKaempfer: false,
      lastImageLoadConfig: null,
      imageLoadDebounce: null, 
      priceRequestAbortController: null,
      ramBOverridden: false,
      ramBOverrideValue: null,
      ramBStandardValue: null,
      ramHOverridden: false,
      ramHOverrideValue: null,
      ramHStandardValue: null,
      zamBOverridden: false,
      zamBOverrideValue: null,
      zamBStandardValue: null,
      zamHOverridden: false,
      zamHOverrideValue: null,
      zamHStandardValue: null,
      isAlternativePosition: false,
      // --- Request-/Rechen-Drosselung ---
      calcTimerId: null,
      calcCooldownMs: 520,           // etwas längere Debounce gegen Request-Bursts
      lastCalcFinishedAt: 0,         // Cooldown gegen Doppel-Trigger (blur/change)
      rebindPending: false,          // MutationObserver-Coalescing
      // Preis-Request-Koordinierung / Memoisierung
      inFlightPriceKey: null,
      inFlightPricePromise: null,
      lastPriceKey: null,
      lastPriceValue: null,
      rasterDimensionError: '',
      minApiIntervalMs: 500,         // Mindestabstand zwischen API-Calls (strenger gegen 429)
      lastApiCallAt: 0,
      xlToggleCooldownMs: 600,
      xlBlockUntil: 0,

      // Image-Request-Drosselung / -Abbruch
      imageRequestAbortController: null,
      inFlightImagesKey: null,
      inFlightImagesPromise: null,
      imagesMinIntervalMs: 600,
      priorityFolderExtras: '',
      lastImagesCallAt: 0,
    };
  },
  watch: {
    teuerungszuschlagCompanyId: {
      immediate: true,
      async handler(companyId, previousCompanyId, onCleanup) {
        this.teuerungszuschlagRate = null;
        if (!companyId) return;

        let cancelled = false;
        onCleanup(() => { cancelled = true; });
        try {
          const response = await api.get(`/api/discounts/unternehmen/${companyId}`);
          if (cancelled) return;

          const surcharge = response.data.find(item => item.type == 1 && item.kuerzel === 'TZ');
          const rate = parseFloat(String(surcharge?.rabatt ?? 0).replace(',', '.'));
          this.teuerungszuschlagRate = Number.isFinite(rate) ? rate : 0;
        } catch (error) {
          if (!cancelled) console.error('Fehler beim Abrufen des Teuerungszuschlags:', error);
        }
      },
    },
    selectedArticle(newArticle) {
      if (newArticle) {
        this.loadImagesForArticle();
        this.checkMontageLink();
      }
    }
  },
  methods: {
    handleProductImageError,
    actorParams() {
      return {};
    },
    userNameWithEmail(user, fallbackName = 'Benutzer') {
      const name = String(user?.name || '').trim() || fallbackName;
      const email = String(user?.email || '').trim();
      return email ? `${name} (${email})` : name;
    },
    ensureProjectEditable() {
      if (!this.isSelectedProjectReadOnly) {
        return true;
      }

      this.showError(this.projectReadOnlyMessage);
      return false;
    },
    formatPriceValue(value) {
      return formatPrice(value);
    },
    formatIntegerValue(value) {
      return formatInteger(value);
    },
    getConfiguratorNavigationFields(container) {
      // Die Feldreihenfolge im Formular entspricht links/rechts, dann der nächsten Zeile.
      return Array.from(container.querySelectorAll('input, select, textarea')).filter(field => {
        if (field.matches(':disabled, [readonly], [type="hidden"], [type="button"], [type="submit"], [type="reset"], [type="file"]')
          || field.tabIndex < 0 || !this.isElementVisible(field)) return false;

        for (let element = field; element && container.contains(element); element = element.parentElement) {
          const style = window.getComputedStyle(element);
          if (element.hidden || element.hasAttribute('inert')
            || style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse') return false;
        }
        return true;
      });
    },
    focusNextConfiguratorField(field) {
      const container = field?.closest('.upper-area');
      if (!container) return;

      const fields = this.getConfiguratorNavigationFields(container);
      const index = fields.indexOf(field);
      const nextField = index >= 0 ? fields[index + 1] : null;
      nextField?.focus();
      nextField?.select?.();
    },
    async handleConfiguratorEnter(event) {
      const field = event.target;
      if (event.key !== 'Enter' || event.isComposing || event.keyCode === 229 || event.repeat
        || event.ctrlKey || event.altKey || event.metaKey || event.shiftKey
        || !field?.matches('input, select') || field === this.$refs.searchInput) return;

      const container = event.currentTarget;
      if (!this.getConfiguratorNavigationFields(container).includes(field)) return;

      event.preventDefault();
      // Bestehende Maßberechnungen und abhängige Felder vor dem Fokuswechsel aktualisieren.
      field.dispatchEvent(new Event('change', { bubbles: true }));
      await this.$nextTick();
      if (document.activeElement !== field) return;

      this.focusNextConfiguratorField(field);
    },
    validateMinValue(inputEl) {
      if (!inputEl) return true;
      const min = this.getMinDimensionValue(inputEl);
      const tooltip = inputEl.parentElement?.querySelector('.error-tooltip-container');
      const val = parseFloat((inputEl.value || '').replace(',', '.'));
      const hasValue = inputEl.value != null && inputEl.value.trim() !== '';
      const tooSmall = hasValue && !Number.isNaN(val) && val < min;

      inputEl.classList.toggle('out-of-bounds-error', tooSmall);
      if (tooltip) tooltip.classList.toggle('hidden-visibility', !tooSmall);
      return !tooSmall;
    },
    getMinDimensionValue(inputEl) {
      let configuredMin = inputEl?.dataset?.minValue;
      if (inputEl?.dataset?.minWithWings
        && this.$refs.dynamicContent?.querySelector('.f_l_value')
        && this.$refs.dynamicContent?.querySelector('.f_r_value')) {
        configuredMin = inputEl.dataset.minWithWings;
      }
      if (configuredMin != null && configuredMin !== '' && Number.isFinite(Number(configuredMin))) {
        return Number(configuredMin);
      }
      let articleMin = null;

      if (inputEl?.matches('.x_value, .wing_r_value')) {
        articleMin = this.minArticleWidth;
      } else if (inputEl?.classList?.contains('y_value')) {
        articleMin = this.minArticleHeight;
      }

      if (articleMin !== null && articleMin !== undefined && articleMin !== '') {
        const parsedArticleMin = Number(articleMin);
        if (Number.isFinite(parsedArticleMin)) {
          return parsedArticleMin;
        }
      }

      return this.minDimensionValue ?? 300;
    },
    getMinHeightDimensionValue() {
      if (this.minArticleHeight !== null && this.minArticleHeight !== undefined && this.minArticleHeight !== '') {
        const parsedArticleMin = Number(this.minArticleHeight);
        if (Number.isFinite(parsedArticleMin)) {
          return parsedArticleMin;
        }
      }

      return this.minDimensionValue ?? 300;
    },
    getMaxDimensionValue(inputEl, axis) {
      let limit = inputEl?.dataset?.maxValue;
      if (inputEl?.dataset?.maxWithWings
        && this.$refs.dynamicContent?.querySelector('.f_l_value')
        && this.$refs.dynamicContent?.querySelector('.f_r_value')) {
        limit = inputEl.dataset.maxWithWings;
      }
      if (limit == null || limit === '') {
        limit = axis === 'height' ? this.maxArticleHeight : this.maxArticleWidth;
      }
      if (limit == null || limit === '') return null;
      const value = Number(limit);
      return Number.isFinite(value) ? value : null;
    },
    validateConfiguredDimensionLimits() {
      this.updatePlisseeRailNotice();
      let valid = true;
      this.$refs.dynamicContent?.querySelectorAll('input[data-min-value], input[data-max-value], input.min_value.wing_l_value, input.min_value.wing_r_value').forEach(input => {
        const step = input.closest('[id^="s_"]');
        const hiddenByRule = step && this.filteredStepItems.find(item => `s_${item.id}` === step.id)?.isHiddenByRule;
        if (hiddenByRule || this.isStepHidden(step || input)) {
          this.setDimensionInputError(input, false);
          return;
        }

        const value = this.getNumericInputValue(input);
        const max = input.hasAttribute('data-max-value') ? this.getMaxDimensionValue(input) : null;
        const tooSmall = value !== null && input.classList.contains('min_value')
          && value < this.getMinDimensionValue(input);
        const tooLarge = value !== null && max !== null && value > max;
        const totalWidth = input.hasAttribute('data-width-height-factor')
          ? this.getNumericInputValue(this.$refs.dynamicContent.querySelector('.stulp_width')) : null;
        const invalidProportion = totalWidth !== null && value !== null
          && totalWidth >= value * Number(input.dataset.widthHeightFactor) - Number(input.dataset.widthHeightDeduction);
        const invalidNumber = input.matches('.pendel-auflage-value, .stulp-profile-clearance') && input.value.trim() !== '' && value === null;
        this.setDimensionInputError(input, tooSmall || tooLarge || invalidProportion || invalidNumber);
        if (tooSmall || tooLarge || invalidProportion || invalidNumber) valid = false;
      });
      return valid;
    },
    getNumericInputValue(inputEl) {
      const raw = (inputEl?.value ?? '').toString().trim().replace(',', '.');
      if (raw === '') {
        return null;
      }

      const value = Number(raw);
      return Number.isFinite(value) ? value : null;
    },
    getAggregateInputSum(inputElements) {
      if (!Array.isArray(inputElements) || inputElements.length === 0) {
        return null;
      }

      const values = inputElements.map(input => this.getNumericInputValue(input));
      if (values.some(value => value === null)) {
        return null;
      }

      return values.reduce((sum, value) => sum + value, 0);
    },
    setDimensionInputError(inputEl, hasError) {
      if (!inputEl) {
        return;
      }

      const tooltip = inputEl.parentElement?.querySelector('.error-tooltip-container');
      inputEl.classList.toggle('out-of-bounds-error', hasError);
      if (tooltip) {
        tooltip.classList.toggle('hidden-visibility', !hasError);
      }
    },
    setRasterDimensionError(inputs, hasError) {
      inputs.filter(Boolean).forEach(input => {
        const wasBlocked = input.classList.contains('raster-dimension-error');
        input.classList.toggle('raster-dimension-error', hasError);
        if (hasError || wasBlocked) this.setDimensionInputError(input, hasError);
      });
      const blocked = this.$refs.dynamicContent?.querySelector('.raster-dimension-error')
        || inputs.some(input => input?.classList.contains('raster-dimension-error'));
      this.rasterDimensionError = blocked ? RASTER_DIMENSION_ERROR : '';
    },
    clearRasterDimensionErrors() {
      this.setRasterDimensionError(Array.from(
        this.$refs.dynamicContent?.querySelectorAll('.raster-dimension-error') || []
      ), false);
    },
    setAggregateDimensionError(inputElements, hasError) {
      inputElements.forEach(input => this.setDimensionInputError(input, hasError));
    },
    validateAggregateHeightValue(inputElements, yValue) {
      if (!Array.isArray(inputElements) || inputElements.length === 0 || yValue === null) {
        return true;
      }

      const tooSmall = yValue < this.getMinHeightDimensionValue();
      let tooLarge = false;
      if (this.maxArticleHeight !== null && this.maxArticleHeight !== undefined && this.maxArticleHeight !== '') {
        const maxHeight = Number(this.maxArticleHeight);
        tooLarge = Number.isFinite(maxHeight) && yValue > maxHeight;
      }

      this.setAggregateDimensionError(inputElements, tooSmall || tooLarge);
      return !tooSmall;
    },
    getPriceWidthInput(inputElement) {
      if (![10, 11, 12].includes(Number(this.selectedArticle))
        || !inputElement?.matches('.wing_l_value, .wing_r_value')) {
        return inputElement;
      }

      const stepElement = inputElement.closest('[id^="s_"]');
      const leftInput = stepElement?.querySelector('.wing_l_value');
      const rightInput = stepElement?.querySelector('.wing_r_value');
      if (!leftInput || !rightInput) return inputElement;

      const leftWidth = this.getNumericInputValue(leftInput);
      const rightWidth = this.getNumericInputValue(rightInput);
      // Unvollständige Maße dürfen nicht durch den jeweils anderen Flügel ersetzt werden.
      if (leftWidth === null) return leftInput;
      if (rightWidth === null) return rightInput;

      // PG 450: Das Preisgitter gilt für das gesamte Element anhand des größeren Flügels.
      return rightWidth > leftWidth ? rightInput : leftInput;
    },
    getPriceDimensionElements(parentElement) {
      const aggregateYInputs = Array.from(parentElement?.querySelectorAll('[data-price-y-sum]') || []);

      return {
        xInputElement: this.getPriceWidthInput(parentElement?.querySelector('[data-price-x-value]') || parentElement?.querySelector('.x_value')),
        yInputElement: aggregateYInputs[0] || parentElement?.querySelector('.y_value'),
        aggregateYInputs,
      };
    },
    getDimensionSummaryInputs(containerElement) {
      return Array.from(containerElement?.querySelectorAll('[data-dimension-summary-index]') || [])
        .sort((a, b) => {
          const aIndex = Number(a.dataset.dimensionSummaryIndex ?? 0);
          const bIndex = Number(b.dataset.dimensionSummaryIndex ?? 0);
          return aIndex - bIndex;
        });
    },
    buildDimensionSummaryDisplayValue(inputElements) {
      if (!Array.isArray(inputElements) || inputElements.length === 0) {
        return '';
      }

      const values = inputElements.map(input => this.normalizeDimensionValue(input.value.trim() || input.dataset.defaultValue || ''));
      if (values.some(value => value === '')) {
        return '';
      }

      if (inputElements.every(input => input.dataset.dimensionSummaryLabel)) {
        return values.map((value, index) => `${inputElements[index].dataset.dimensionSummaryLabel}: ${value}mm`).join(' / ');
      }

      return values.map(value => `${value}mm`).join(' x ');
    },
    restoreDimensionSummaryDisplayValue(inputElements, rawValue, applyValue) {
      if (!Array.isArray(inputElements) || inputElements.length === 0 || typeof applyValue !== 'function') {
        return false;
      }

      const labeled = inputElements.every(input => input.dataset.dimensionSummaryLabel);
      const values = String(rawValue || '')
        .split(labeled ? /\s+\/\s+/ : /\s+x\s+/i)
        .map(value => this.normalizeDimensionValue(labeled ? value.replace(/^[^:]+:\s*/, '') : value));

      if (values.length !== inputElements.length || values.some(value => value === '')) {
        return false;
      }

      inputElements.forEach((input, index) => applyValue(input,
        values[index] === input.dataset.defaultValue ? '' : values[index]));
      return true;
    },
    makePriceKey(x, y, preislistenId) {
        return `${preislistenId}|${x}|${y}`;
    },
    schedulePriceCalc(reason = 'generic', delay = this.calcCooldownMs) {
      reason;
      // (1) laufende Debounce abbrechen
      if (this.calcTimerId) { clearTimeout(this.calcTimerId); this.calcTimerId = null; }

      // (2) neue Berechnung planen
      this.calcTimerId = setTimeout(async () => {
        this.calcTimerId = null;
        await this.calculatePriceFromScratchSafe(); // nutzt deinen bestehenden Safe-Wrapper
        this.refreshConfiguredArticle();            // UI-Refresh nur NACH fertiger Berechnung
        this.lastCalcFinishedAt = Date.now();
      }, delay);
    },
    scheduleCommittedPriceCalc() {
      const now = Date.now();
      const sinceLast = now - this.lastCalcFinishedAt;
      const delay = sinceLast < 250 ? 250 : 0; // kurze Entzerrung
      this.schedulePriceCalc('committed', delay);
    },
    computeStandardRamB() {
      if (this.$refs.dynamicContent?.querySelector('[data-pendel-auflagen]')) {
        return this.getPendelZamValue('B');
      }
      const calculatedRamField = this.$refs.dynamicContent?.querySelector('.rm_b_value[data-zam-formula]');
      const zamWidthField = this.$refs.dynamicContent?.querySelector('.zam_b_value');
      if (calculatedRamField && zamWidthField) {
        return this.evaluateZamRamFormula(zamWidthField.value, calculatedRamField.dataset.zamFormula);
      }

      const lmbField = this.$refs.dynamicContent?.querySelector('.lm_b_value');
      const rmbAddField = this.$refs.dynamicContent?.querySelector('.rm_b_add_value');
      const lmbNumberValue = lmbField ? parseFloat(lmbField.value) : NaN;
      const addNumberValue = rmbAddField ? parseFloat((rmbAddField.textContent || rmbAddField.value || '').trim()) : NaN;


      if (!isNaN(lmbNumberValue) && !isNaN(addNumberValue)) {
        return lmbNumberValue + addNumberValue;
      }
      return null;
    },
    computeStandardRamH() {
      if (this.$refs.dynamicContent?.querySelector('[data-pendel-auflagen]')) {
        return this.getPendelZamValue('H');
      }
      const calculatedRamField = this.$refs.dynamicContent?.querySelector('.rm_h_value[data-zam-formula]');
      const zamHeightField = this.$refs.dynamicContent?.querySelector('.zam_h_value');
      if (calculatedRamField && zamHeightField) {
        return this.evaluateZamRamFormula(zamHeightField.value, calculatedRamField.dataset.zamFormula);
      }

      const lmhField = this.$refs.dynamicContent?.querySelector('.lm_h_value');
      const rmhAddField = this.$refs.dynamicContent?.querySelector('.rm_h_add_value');
      const lmhNumberValue = lmhField ? parseFloat(lmhField.value) : NaN;
      const addNumberValue = rmhAddField ? parseFloat((rmhAddField.textContent || rmhAddField.value || '').trim()) : NaN;


      if (!isNaN(lmhNumberValue) && !isNaN(addNumberValue)) {
        return lmhNumberValue + addNumberValue;
      }
      return null;
    },
    ensureRamWarningElement(inputEl, key) {
      if (!inputEl) return null;

      let container = inputEl.closest('.input-container') || inputEl.parentElement;
      if (!container) container = inputEl.parentElement;

      // je Feldtyp (B/H) exakt eine Box
      let warn = container.querySelector(`.ram-warning[data-for="${key}"]`);
      if (!warn) {
        warn = document.createElement('div');
        warn.className = 'ram-warning';
        warn.setAttribute('role', 'alert');
        warn.setAttribute('aria-live', 'polite');
        warn.dataset.for = key;
        warn.innerHTML = `
          <span class="ram-warning-icon">⚠️</span>
          <span class="ram-warning-text"></span>
        `;
        container.appendChild(warn);
      }
      return warn;
    },
    showRamDeviation({ kind, show, stdValue, curValue }) {
      // kind: 'B' oder 'H'
      const fieldSelector = kind === 'B' ? '.rm_b_value' : '.rm_h_value';
      const input = this.$refs.dynamicContent?.querySelector(fieldSelector);
      const warn = this.ensureRamWarningElement(input, kind);
      if (!warn) return;

      if (!show) {
        warn.style.display = 'none';        // <— kein Platz, wenn aus
        warn.querySelector('.ram-warning-text').textContent = '';

        if (input) {
          input.classList.remove('input-error', 'out-of-bounds-error');
        }
        return;
      }

      // Texte kompakt & verständlich
      const stdTxt = (stdValue != null && !isNaN(stdValue)) ? `${stdValue} mm` : '–';
      const curTxt = (curValue != null && !isNaN(curValue)) ? `${curValue} mm` : '–';

      warn.querySelector('.ram-warning-text').textContent =
        `Abweichung vom Standardmaß: Soll ${stdTxt}, aktuell ${curTxt}.`;

      warn.style.display = 'block';         // <— sichtbar, belegt Platz
    },
    handleRamBManualChange(e) {
      const input = e?.target || this.$refs.dynamicContent?.querySelector('.rm_b_value');
      if (!input) return;

      const val = parseFloat(input.value);
      const std = this.computeStandardRamB();
      this.ramBStandardValue = std;

      const diff = (std != null && !isNaN(val)) ? Math.abs(val - std) : null;
      const show = diff != null && diff >= 0.0001;

      this.showRamDeviation({ kind: 'B', show, stdValue: std, curValue: val });
      this.schedulePriceCalc('ram-input');
    },
    handleRamHManualChange(e) {
      const input = e?.target || this.$refs.dynamicContent?.querySelector('.rm_h_value');
      if (!input) return;

      const val = parseFloat(input.value);
      const std = this.computeStandardRamH();
      this.ramHStandardValue = std;

      const diff = (std != null && !isNaN(val)) ? Math.abs(val - std) : null;
      const show = diff != null && diff >= 0.0001;

      this.showRamDeviation({ kind: 'H', show, stdValue: std, curValue: val });
      this.schedulePriceCalc('ram-input');
    },
    bindSMASSInputListeners() {
      const smInputs = this.$refs.dynamicContent.querySelectorAll('.sm_value');
      smInputs.forEach(input => {
        input.removeEventListener('change', this.calculateSMASSInput);
        input.addEventListener('change', this.calculateSMASSInput);
      });
    },
    bindSMASSSelectBoxListeners() {
      const grInputs = this.$refs.dynamicContent.querySelectorAll('.gr_value');
      grInputs.forEach(input => {
        input.removeEventListener('change', this.calculateSMASSSelectBox);
        input.addEventListener('change', this.calculateSMASSSelectBox);
      });
    },
    bindDichtbandSMASSListeners() {
      const root = this.$refs.dynamicContent;
      if (!root) return;

      const smassInput = root.querySelector('.s_mass_dichtb_smass');
      const dichtbandSelect = root.querySelector('.s_mass_dichtb_value');

      if (smassInput) {
        smassInput.removeEventListener('focus', this.rememberDichtbandSMASSFocusValue);
        smassInput.removeEventListener('input', this.markDichtbandSMASSDirty);
        smassInput.removeEventListener('change', this.handleDichtbandSMASSCommit);
        smassInput.removeEventListener('blur', this.handleDichtbandSMASSCommit);
        smassInput.removeEventListener('keydown', this.handleDichtbandSMASSKeydown);

        smassInput.addEventListener('focus', this.rememberDichtbandSMASSFocusValue);
        smassInput.addEventListener('input', this.markDichtbandSMASSDirty);
        smassInput.addEventListener('change', this.handleDichtbandSMASSCommit);
        smassInput.addEventListener('blur', this.handleDichtbandSMASSCommit);
        smassInput.addEventListener('keydown', this.handleDichtbandSMASSKeydown);
      }

      if (dichtbandSelect) {
        dichtbandSelect.removeEventListener('change', this.handleDichtbandSelectChange);
        dichtbandSelect.addEventListener('change', this.handleDichtbandSelectChange);
      }

      this.initializeDichtbandSMASSState();
    },
    getDichtbandSMASSElements() {
      const root = this.$refs.dynamicContent;
      if (!root) return null;

      const input = root.querySelector('.s_mass_dichtb_smass');
      const select = root.querySelector('.s_mass_dichtb_value');
      if (!input || !select) return null;

      return { input, select };
    },
    parseDichtbandAddition(select) {
      if (!select) return 0;

      const option = select.options && select.selectedIndex >= 0
        ? select.options[select.selectedIndex]
        : null;
      const raw = `${option?.value ?? select.value ?? ''} ${option?.text ?? option?.innerHTML ?? ''}`.trim();
      if (!raw || raw.toLowerCase().includes('ohne')) return 0;

      const match = raw.replace(',', '.').match(/-?\d+(?:\.\d+)?/);
      const value = match ? parseFloat(match[0]) : 0;
      return Number.isFinite(value) ? value : 0;
    },
    parseDichtbandNumber(value) {
      const raw = (value ?? '').toString().trim().replace(',', '.');
      if (raw === '') return null;

      const parsed = parseFloat(raw);
      return Number.isFinite(parsed) ? parsed : null;
    },
    formatDichtbandNumber(value) {
      if (!Number.isFinite(value)) return '';

      const rounded = Math.round((value + Number.EPSILON) * 1000) / 1000;
      return String(rounded);
    },
    initializeDichtbandSMASSState() {
      const elements = this.getDichtbandSMASSElements();
      if (!elements) return;

      const { input, select } = elements;
      const currentValue = this.parseDichtbandNumber(input.value);
      if (!Number.isFinite(currentValue)) return;

      const addition = this.parseDichtbandAddition(select);
      const shouldReinitialize = input.dataset.dichtbandBaseValue === undefined || this.isLoading;
      if (!shouldReinitialize) return;

      const baseValue = currentValue - addition;
      input.dataset.dichtbandBaseValue = this.formatDichtbandNumber(baseValue);
      input.dataset.dichtbandAddition = this.formatDichtbandNumber(addition);
      input.dataset.dichtbandAppliedValue = this.formatDichtbandNumber(currentValue);
      input.dataset.dichtbandDirty = '0';
    },
    rememberDichtbandSMASSFocusValue(event) {
      const input = event?.target;
      if (!input) return;

      input.dataset.dichtbandFocusValue = input.value ?? '';
      input.dataset.dichtbandDirty = '0';
    },
    markDichtbandSMASSDirty(event) {
      const input = event?.target;
      if (!input) return;

      input.dataset.dichtbandDirty = '1';
    },
    handleDichtbandSelectChange() {
      this.applyDichtbandSMASS({ useInputAsBase: false });
    },
    handleDichtbandSMASSCommit(event) {
      const input = event?.target;
      if (!input) return;

      if (input.dataset.dichtbandDirty !== '1') {
        this.initializeDichtbandSMASSState();
        return;
      }

      this.applyDichtbandSMASS({ useInputAsBase: true });
    },
    handleDichtbandSMASSKeydown(event) {
      if (event?.key !== 'Enter') return;

      event.preventDefault();
      if (event.target?.dataset?.dichtbandDirty !== '1') return;

      this.applyDichtbandSMASS({ useInputAsBase: true });
    },
    applyDichtbandSMASS({ useInputAsBase = false } = {}) {
      const elements = this.getDichtbandSMASSElements();
      if (!elements) return;

      const { input, select } = elements;
      const currentValue = this.parseDichtbandNumber(input.value);
      if (!Number.isFinite(currentValue)) {
        delete input.dataset.dichtbandBaseValue;
        input.dataset.dichtbandDirty = '0';
        return;
      }

      const addition = this.parseDichtbandAddition(select);
      const previousAddition = this.parseDichtbandNumber(input.dataset.dichtbandAddition) ?? 0;

      if (this.isLoading) {
        input.dataset.dichtbandBaseValue = this.formatDichtbandNumber(currentValue - addition);
        input.dataset.dichtbandAddition = this.formatDichtbandNumber(addition);
        input.dataset.dichtbandAppliedValue = this.formatDichtbandNumber(currentValue);
        input.dataset.dichtbandDirty = '0';
        return;
      }

      let baseValue = null;
      if (useInputAsBase || input.dataset.dichtbandDirty === '1') {
        baseValue = currentValue;
      } else {
        baseValue = this.parseDichtbandNumber(input.dataset.dichtbandBaseValue);
        if (!Number.isFinite(baseValue)) {
          baseValue = currentValue - previousAddition;
        }
      }

      const nextValue = baseValue + addition;
      const nextValueText = this.formatDichtbandNumber(nextValue);

      input.value = nextValueText;
      input.dataset.dichtbandBaseValue = this.formatDichtbandNumber(baseValue);
      input.dataset.dichtbandAddition = this.formatDichtbandNumber(addition);
      input.dataset.dichtbandAppliedValue = nextValueText;
      input.dataset.dichtbandDirty = '0';

      this.scheduleCommittedPriceCalc();
      this.refreshConfiguredArticle();
    },
    bindRAMInputListeners() {
      if (!this.$refs.dynamicContent) {
        return;
      }

      const inputSelectors = [
      '.lm_b_value',
      '.lm_h_value',
      '.rm_b_value', // RAM Breite
      '.rm_h_value',
      '.rm_b_add_value',
      '.rm_h_add_value',
      '.zam_b_value',
      '.zam_h_value',
      ];
      inputSelectors.forEach(selector => {
      const inputs = this.$refs.dynamicContent.querySelectorAll(selector);
        inputs.forEach(input => {
          input.removeEventListener('input', this.calculateRAM);
          input.removeEventListener('change', this.calculateRAM);

          if (selector === '.zam_b_value' || selector === '.zam_h_value') {
            input.removeEventListener('input', this.calculateRAMFromZAM);
            input.removeEventListener('change', this.calculateRAMFromZAM);
            input.addEventListener('input', this.calculateRAMFromZAM);
            input.addEventListener('change', this.calculateRAMFromZAM);
          // Für RAM Breite eigener Handler (Override)
          } else if (selector === '.rm_b_value') {
            input.removeEventListener('input', this.handleRamBManualChange);
            input.removeEventListener('change', this.handleRamBManualChange);
            input.addEventListener('input', this.handleRamBManualChange);
            input.addEventListener('change', this.handleRamBManualChange);
          } else if (selector === '.rm_h_value') {
            input.removeEventListener('input', this.handleRamHManualChange);
            input.removeEventListener('change', this.handleRamHManualChange);
            input.addEventListener('input', this.handleRamHManualChange);
            input.addEventListener('change', this.handleRamHManualChange);
          } else {
            input.addEventListener('input', this.calculateRAM);
            input.addEventListener('change', this.calculateRAM);
          }
          }
        );
      });
    },
    evaluateZamRamFormula(rawValue, rawFormula) {
      const sourceValue = parseFloat((rawValue ?? '').toString().trim().replace(',', '.'));
      if (!Number.isFinite(sourceValue)) return null;

      const formula = (rawFormula ?? '').toString().trim().replace(/\s*mm$/i, '');
      const match = formula.match(/^ZAM(?:\s+Höhe)?(?:\s*\/\s*(\d+(?:[.,]\d+)?))?\s*([+-])\s*(\d+(?:[.,]\d+)?)$/i);
      if (!match) return null;

      const divisor = match[1] ? parseFloat(match[1].replace(',', '.')) : 1;
      const adjustment = parseFloat(match[3].replace(',', '.'));
      if (!Number.isFinite(divisor) || divisor === 0 || !Number.isFinite(adjustment)) return null;

      const signedAdjustment = match[2] === '-' ? -adjustment : adjustment;
      return sourceValue / divisor + signedAdjustment;
    },
    calculateRAMFromZAM(event = null) {
      const root = this.$refs.dynamicContent;
      if (!root) return;

      const changedSource = event?.target?.classList?.contains('zam_h_value')
        ? 'height'
        : event?.target?.classList?.contains('zam_b_value')
          ? 'width'
          : null;
      const sourceFields = {
        width: root.querySelector('.zam_b_value'),
        height: root.querySelector('.zam_h_value'),
      };
      let updated = false;

      root.querySelectorAll('[data-zam-formula]').forEach(output => {
        const sourceName = output.dataset.zamSource === 'height' ? 'height' : 'width';
        if (changedSource && changedSource !== sourceName) return;
        const source = sourceFields[sourceName];
        const value = this.evaluateZamRamFormula(source?.value, output.dataset.zamFormula);
        output.value = Number.isFinite(value) ? this.formatDichtbandNumber(value) : '';
        output.classList.remove('input-error', 'out-of-bounds-error');
        updated = true;
      });

      // PG 450 verwendet die ZAM-Höhe direkt, ohne ein berechnetes RAM-Höhenfeld.
      if (updated || event?.target?.matches('.zam_h_value[data-price-y-sum]')) {
        this.schedulePriceCalc('zam-ram-auto');
      }
    },
    getStulpWidthInputs() {
      const root = this.$refs.dynamicContent;
      return {
        stulpInput: root?.querySelector('.stulp_width, .zam_b_value'),
        leftInput: root?.querySelector('.f_l_value, .gangfluegel_value, .wing_l_value'),
        rightInput: root?.querySelector('.f_r_value, .standfluegel_value, .wing_r_value'),
      };
    },
    updatePlisseeRailNotice() {
      const root = this.$refs.dynamicContent;
      const width = this.getNumericInputValue(root?.querySelector('.stulp_width'));
      root?.querySelectorAll('[data-plissee-rail-note]').forEach(notice => {
        notice.hidden = width === null || width <= Number(notice.dataset.plisseeRailNote);
      });
    },
    getStulpTotalWidth() {
      const { stulpInput, leftInput, rightInput } = this.getStulpWidthInputs();
      const width = this.getNumericInputValue(stulpInput);
      if (width === null || width < 0) return null;
      if (!leftInput?.matches('.wing_l_value')) return width;

      // PG 450: Die Summe der RAM-Flügel ergibt sich aus den ZAM-Formeln.
      // Bei 455 beispielsweise: 2 * (ZAM / 4 + 35).
      const leftWidth = this.evaluateZamRamFormula(width, leftInput.dataset.zamFormula);
      const rightWidth = this.evaluateZamRamFormula(width, rightInput?.dataset.zamFormula);
      if (leftWidth === null || rightWidth === null) return null;

      return leftWidth + rightWidth;
    },
    bindStulpListeners() {
      this.updatePlisseeRailNotice();
      const { stulpInput, leftInput, rightInput } = this.getStulpWidthInputs();
      if (!(stulpInput && leftInput)) return;

      const attach = (el, handler) => {
        if (!el) return;
        el.removeEventListener('input', handler);
        el.removeEventListener('change', handler);
        el.addEventListener('input', handler);
        el.addEventListener('change', handler);
      };

      if (!rightInput && leftInput.matches('.gangfluegel_value')) {
        attach(stulpInput, this.validateGangfluegelBreite);
        attach(leftInput, this.validateGangfluegelBreite);
        this.validateGangfluegelBreite();
        return;
      }
      if (!rightInput) return;

      if (leftInput.closest('[data-independent-wing-widths]')) {
        attach(stulpInput, this.handleIndependentWingWidthChange);
        attach(leftInput, this.handleIndependentWingWidthChange);
        attach(rightInput, this.handleIndependentWingWidthChange);
        return;
      }

      attach(stulpInput, this.handleStulpWidthInput);
      attach(leftInput, this.handleFLInput);
      attach(rightInput, this.handleFRInput);
    },
    handleIndependentWingWidthChange() {
      this.validateIndependentWingWidths();
      this.schedulePriceCalc('independent-wing-width');
    },
    validateIndependentWingWidths() {
      const group = this.$refs.dynamicContent?.querySelector('[data-independent-wing-widths]');
      if (!group) return true;

      const totalInput = group.querySelector('.zam_b_value');
      const total = this.getNumericInputValue(totalInput);
      const left = this.getNumericInputValue(group.querySelector('.wing_l_value'));
      const right = this.getNumericInputValue(group.querySelector('.wing_r_value'));
      const invalid = total !== null && left !== null && right !== null
        && (left < 0 || right < 0 || left + right > total);
      this.setDimensionInputError(totalInput, invalid);
      return !invalid;
    },
    validateGangfluegelBreite() {
      const { stulpInput, leftInput, rightInput } = this.getStulpWidthInputs();
      if (!stulpInput || !leftInput?.matches('.gangfluegel_value') || rightInput) return true;

      const totalWidth = this.getNumericInputValue(stulpInput);
      const gangfluegelWidth = this.getNumericInputValue(leftInput);
      let invalid = totalWidth !== null && gangfluegelWidth !== null && gangfluegelWidth > totalWidth;
      if (leftInput.hasAttribute('data-price-wing-split')
        || leftInput.hasAttribute('data-wing-min-width') || leftInput.hasAttribute('data-wing-max-width')) {
        const minWidth = leftInput.dataset.wingMinWidth ?? this.getMinDimensionValue(leftInput);
        const maxWidth = leftInput.dataset.wingMaxWidth ?? this.maxArticleWidth;
        const leftWidth = gangfluegelWidth ?? (totalWidth === null ? null : totalWidth / 2);
        const rightWidth = totalWidth === null || leftWidth === null ? null : totalWidth - leftWidth;
        invalid = invalid || [leftWidth, rightWidth].some(width => width !== null
          && (width < Number(minWidth) || (maxWidth != null && maxWidth !== '' && width > Number(maxWidth))));
      }
      this.setDimensionInputError(leftInput, invalid);
      return !invalid;
    },

    handleStulpWidthInput() {
      if (this.isStulpSyncing) return;
      this.updatePlisseeRailNotice();
      const { stulpInput, leftInput, rightInput } = this.getStulpWidthInputs();
      if (!(stulpInput && leftInput && rightInput)) return;

      const total = this.getStulpTotalWidth();
      if (total == null || total < 0) return;

      this.isStulpSyncing = true;
      leftInput.value = this.formatDichtbandNumber(total / 2);
      rightInput.value = leftInput.value;
      this.isStulpSyncing = false;
      this.schedulePriceCalc('stulp-width');
    },

    handleFLInput(event) {
      if (this.isStulpSyncing) return;
      const { stulpInput, rightInput } = this.getStulpWidthInputs();
      if (!(stulpInput && rightInput)) return;

      const total = this.getStulpTotalWidth();
      if (total == null || total < 0) return;
      let left = this.getNumericInputValue(event?.target);
      if (left == null) return;

      left = Math.min(Math.max(0, left), total);
      const right = total - left;

      this.isStulpSyncing = true;
      if (event?.target && this.getNumericInputValue(event.target) !== left) {
        event.target.value = this.formatDichtbandNumber(left);
      }
      rightInput.value = this.formatDichtbandNumber(right);
      this.isStulpSyncing = false;
      this.schedulePriceCalc('stulp-left');
    },

    handleFRInput(event) {
      if (this.isStulpSyncing) return;
      const { stulpInput, leftInput } = this.getStulpWidthInputs();
      if (!(stulpInput && leftInput)) return;

      const total = this.getStulpTotalWidth();
      if (total == null || total < 0) return;
      let right = this.getNumericInputValue(event?.target);
      if (right == null) return;

      right = Math.min(Math.max(0, right), total);
      const left = total - right;

      this.isStulpSyncing = true;
      if (event?.target && this.getNumericInputValue(event.target) !== right) {
        event.target.value = this.formatDichtbandNumber(right);
      }
      leftInput.value = this.formatDichtbandNumber(left);
      this.isStulpSyncing = false;
      this.schedulePriceCalc('stulp-right');
    },

    bindZAMInputListeners() {
      if (!this.$refs.dynamicContent) {
        return;
      }

      const inputSelectors = [
      '.rm_z_b_value',
      '.rm_z_h_value',
      '.zm_z_b_value', // ZAM Breite
      '.zm_z_h_value',
      '.zm_z_b_add_value',
      '.zm_z_h_add_value',
      '.zm_z_buerste_value',
      '.rm_z_buerste_value',
      'select[data-ram-height-deduction]',
      ];
      inputSelectors.forEach(selector => {
      const inputs = this.$refs.dynamicContent.querySelectorAll(selector);
        inputs.forEach(input => {
          input.removeEventListener('input', this.calculateZAM);
          input.removeEventListener('change', this.calculateZAM);

          if (selector === '.zm_z_b_value') {
            input.removeEventListener('input', this.handleZamBManualChange);
            input.removeEventListener('change', this.handleZamBManualChange);
            input.addEventListener('input', this.handleZamBManualChange);
            input.addEventListener('change', this.handleZamBManualChange);
          } else if (selector === '.zm_z_h_value') {
            input.removeEventListener('input', this.handleZamHManualChange);
            input.removeEventListener('change', this.handleZamHManualChange);
            input.addEventListener('input', this.handleZamHManualChange);
            input.addEventListener('change', this.handleZamHManualChange);
          } else if (selector === '.rm_z_buerste_value') {
            input.removeEventListener('input', this.handleRmZBrushChange);
            input.removeEventListener('change', this.handleRmZBrushChange);
            input.addEventListener('input', this.handleRmZBrushChange);
            input.addEventListener('change', this.handleRmZBrushChange);
          } else if (selector === 'select[data-ram-height-deduction]') {
            input.removeEventListener('input', this.handleRamHeightDeductionChange);
            input.removeEventListener('change', this.handleRamHeightDeductionChange);
            input.addEventListener('input', this.handleRamHeightDeductionChange);
            input.addEventListener('change', this.handleRamHeightDeductionChange);
          } else {
            input.addEventListener('input', this.calculateZAM);
            input.addEventListener('change', this.calculateZAM);
          }
          }
        );
      });
    },
    handleImageZoomInput(event) {
      this.setImageZoom(Number(event?.target?.value), { keepCenter: true });
    },
    handleImageWheel(event) {
      event?.preventDefault?.();
      event?.stopPropagation?.();
      if (!event?.deltaY) return;

      const zoomStep = event.deltaY < 0 ? 10 : -10;
      this.setImageZoom(this.imageZoom + zoomStep, { keepCenter: true });
    },
    setImageZoom(value, { resetScroll = false, keepCenter = false } = {}) {
      const viewport = this.$refs.imagePopupViewport;
      const oldCenter = keepCenter && viewport
        ? {
            x: (viewport.scrollLeft + viewport.clientWidth / 2) / Math.max(viewport.scrollWidth, 1),
            y: (viewport.scrollTop + viewport.clientHeight / 2) / Math.max(viewport.scrollHeight, 1),
          }
        : null;

      const numericValue = Number(value);
      this.imageZoom = Math.min(240, Math.max(100, Number.isFinite(numericValue) ? numericValue : 100));

      this.$nextTick(() => {
        const currentViewport = this.$refs.imagePopupViewport;
        if (!currentViewport) return;

        if (resetScroll) {
          currentViewport.scrollTop = 0;
          currentViewport.scrollLeft = 0;
          return;
        }

        if (!oldCenter) return;

        const maxScrollLeft = Math.max(0, currentViewport.scrollWidth - currentViewport.clientWidth);
        const maxScrollTop = Math.max(0, currentViewport.scrollHeight - currentViewport.clientHeight);

        currentViewport.scrollLeft = Math.min(
          maxScrollLeft,
          Math.max(0, oldCenter.x * currentViewport.scrollWidth - currentViewport.clientWidth / 2)
        );
        currentViewport.scrollTop = Math.min(
          maxScrollTop,
          Math.max(0, oldCenter.y * currentViewport.scrollHeight - currentViewport.clientHeight / 2)
        );
      });
    },
    decreaseImageZoom() {
      this.setImageZoom(this.imageZoom - 10, { keepCenter: true });
    },
    increaseImageZoom() {
      this.setImageZoom(this.imageZoom + 10, { keepCenter: true });
    },
    openImagePopup() {
      this.showImagePopup = true;
      this.imageZoom = 100;
      this.lockPageScrollForImagePopup();
      this.$nextTick(() => {
        this.updateImagePopupBaseSize();
        this.resetImagePopupScroll();
      });
    },
    closeImagePopup() {
      this.showImagePopup = false;
      this.imageZoom = 100;
      this.endImagePan();
      this.unlockPageScrollForImagePopup();
    },
    lockPageScrollForImagePopup() {
      if (typeof document === 'undefined' || this.imagePopupPageOverflow) return;

      this.imagePopupPageOverflow = {
        body: document.body.style.overflow,
        documentElement: document.documentElement.style.overflow,
      };
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    },
    unlockPageScrollForImagePopup() {
      if (typeof document === 'undefined' || !this.imagePopupPageOverflow) return;

      document.body.style.overflow = this.imagePopupPageOverflow.body;
      document.documentElement.style.overflow = this.imagePopupPageOverflow.documentElement;
      this.imagePopupPageOverflow = null;
    },
    resetImagePopupScroll() {
      this.$nextTick(() => {
        const viewport = this.$refs.imagePopupViewport;
        if (!viewport) return;

        viewport.scrollTop = 0;
        viewport.scrollLeft = 0;
      });
    },
    updateImagePopupBaseSize(event = null) {
      const image = event?.target || this.$refs.imagePopupImage;
      const viewport = this.$refs.imagePopupViewport;
      if (!image || !viewport || !image.naturalWidth || !image.naturalHeight) return;

      const viewportWidth = viewport.clientWidth;
      const viewportHeight = viewport.clientHeight;
      if (!viewportWidth || !viewportHeight) return;

      const fitScale = Math.min(
        viewportWidth / image.naturalWidth,
        viewportHeight / image.naturalHeight,
        1
      );

      this.imageBaseWidth = image.naturalWidth * fitScale;
      this.imageBaseHeight = image.naturalHeight * fitScale;
      this.imageViewportWidth = viewportWidth;
      this.imageViewportHeight = viewportHeight;
    },
    startImagePan(event) {
      const viewport = this.$refs.imagePopupViewport;
      if (!viewport) return;
      if (event.button !== undefined && event.button !== 0) return;

      const canScrollHorizontally = viewport.scrollWidth > viewport.clientWidth;
      const canScrollVertically = viewport.scrollHeight > viewport.clientHeight;
      if (!canScrollHorizontally && !canScrollVertically) return;

      this.isImageDragging = true;
      this.imagePanStartX = event.clientX;
      this.imagePanStartY = event.clientY;
      this.imagePanStartScrollLeft = viewport.scrollLeft;
      this.imagePanStartScrollTop = viewport.scrollTop;

      viewport.setPointerCapture?.(event.pointerId);
      event.preventDefault();
    },
    panImage(event) {
      if (!this.isImageDragging) return;

      const viewport = this.$refs.imagePopupViewport;
      if (!viewport) return;

      viewport.scrollLeft = this.imagePanStartScrollLeft - (event.clientX - this.imagePanStartX);
      viewport.scrollTop = this.imagePanStartScrollTop - (event.clientY - this.imagePanStartY);
      event.preventDefault();
    },
    endImagePan() {
      this.isImageDragging = false;
    },
    goBack() {
      this.clearFields();
      if (!this.isExternal) this.$parent.changeMenuState(3, { replaceHistory: true });
    },
    pushConfiguratorHistory(view, options = {}) {
      if (this.isExternal) return;
      this.$parent.pushAppViewHistory?.(view, {
        selectedArticleId: this.selectedArticleId,
        cartVisible: view === 'cart',
      }, options);
    },
    async applyHistoryState(state = {}) {
      if (state.view === 'cart') {
        this.$refs.cartComponent.setSelectedProject(this.selectedProject);
        await this.$refs.cartComponent.setCardItems(this.savedArticles);
        this.cartVisible = true;
      } else if (state.view === 'position') {
        this.cartVisible = false;
      }

      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    setCopyMode() {
      this.positionIsEdited = false;
    },
    async toggleCart(options = {}) {
      const isOpeningCart = !this.cartVisible;
      const shouldManageLoading = isOpeningCart && !this.isLoading;

      if (shouldManageLoading) {
        this.isLoading = true;
        await this.$nextTick();
      }

      try {
        if (isOpeningCart) {
          this.$refs.cartComponent.setSelectedProject(this.selectedProject);
          await this.$refs.cartComponent.setCardItems(this.savedArticles);
          await this.$nextTick();
          if (this.$refs.cartComponent?.refreshCartSumPrice) {
            this.$refs.cartComponent.refreshCartSumPrice();
          }
        }
        this.cartVisible = !this.cartVisible;
        if (!options.skipHistory) {
          this.pushConfiguratorHistory(this.cartVisible ? 'cart' : 'position', options);
        }

        // Nach oben scrollen
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      } finally {
        if (shouldManageLoading) {
          this.isLoading = false;
        }
      }
    },
    async openCartAndFocus(targetId = null, options = {}) {
      this.$refs.cartComponent.setSelectedProject(this.selectedProject);
      this.cartVisible = true;

      await this.$nextTick();
      await this.$nextTick();

      const fallbackId = this.savedArticles.length > 0 ? this.savedArticles[this.savedArticles.length - 1].id : null;
      const effectiveId = targetId ?? fallbackId;

      if (this.$refs.cartComponent?.scrollToItem) {
        this.$refs.cartComponent.scrollToItem(effectiveId);
      }

      if (!options.skipHistory) {
        this.pushConfiguratorHistory('cart', options);
      }
    },
    setPosition(postion) {
      this.position = postion;
    },
    setSelectedProject(project) {
      this.selectedProject = project;
      if (this.$parent?.setSelectedProject) {
        this.$parent.setSelectedProject(project);
      }
    },
    isEmptyAnzahl(value) {
      return value === '' || value === null || value === undefined;
    },
    normalizeAnzahl(value) {
      return normalizePositiveInteger(value, 1);
    },
    handleAnzahlInput(event) {
      const rawValue = event?.target?.value ?? '';
      if (!/\d/.test(String(rawValue))) {
        this.anzahl = '';
        return;
      }

      this.anzahl = this.normalizeAnzahl(rawValue);
    },
    validateAnzahl() {
      if (this.isEmptyAnzahl(this.anzahl)) {
        return;
      }

      this.anzahl = this.normalizeAnzahl(this.anzahl);
    },
    commitAnzahlChange() {
      if (this.isEmptyAnzahl(this.anzahl)) {
        this.anzahl = 1;
        return;
      }

      this.validateAnzahl();
    },
    checkIfPositionExists() {
      return this.savedArticles.some(article => article.position_bezeichnung === this.positionBezeichnung);
    },
    async saveCopiedItemToMain(copiedItem) {
      if (this.isExternal) return;
      if (!this.ensureProjectEditable()) {
        return;
      }

      // TODO: Ausbauen wird nicht mehr benutzt
      this.isLoading = true;
      await api.post('/api/gespeicherteartikel', { 
        position_bezeichnung: copiedItem.positionBez,
        artikel_json: JSON.stringify(copiedItem),
        anzahl: this.normalizeAnzahl(copiedItem.amount),
        notizen: copiedItem.notes,
        projekt_id: this.selectedProject.id,
        ...this.actorParams(),
      })
      .then(() => {
          this.refreshSavedArticles();
          // this.$refs.cartComponent.setCardItems(this.savedArticles);
          this.isLoading = false;
      })
      .catch(error => {
          this.isLoading = false;
          console.error('Es gab einen Fehler beim Kopieren des Artikels: ', error);
      });
    },
    async resetCopiedItem() {
      // Das kopierte Item wird zurückgesetzt, da es nicht direkt in der Datenbank gespeichert werden soll.
      this.positionBezeichnung = "";
    },
    openFromCard(itemToOpen, options = {}) {
      if (!this.ensureProjectEditable()) {
        return;
      }

      this.selectedArticleId = itemToOpen.id;
      this.positionBezeichnung = itemToOpen.positionBez;
      this.anzahl = this.normalizeAnzahl(itemToOpen.amount);
      this.notizen = itemToOpen.notes;
      this.articleSearchText = itemToOpen.articleSearchText;
      this.positionIsEdited = true;
      this.loadConfiguredArticleFromJSON(JSON.stringify(itemToOpen));
      if (!options.skipHistory) {
        this.pushConfiguratorHistory('position');
      }
    },
    loadSavedArticle(savedArticle, options = {}) {
      if (!this.ensureProjectEditable()) {
        return;
      }

      this.selectedArticleId = savedArticle.id;
      this.positionBezeichnung = savedArticle.position_bezeichnung;
      this.anzahl = this.normalizeAnzahl(savedArticle.anzahl);
      this.notizen = savedArticle.notizen;
      this.positionIsEdited = true;
      this.loadConfiguredArticleFromJSON(savedArticle.artikel_json);
      this.loadImagesForArticle();
      if (!options.skipHistory) {
        this.pushConfiguratorHistory('position');
      }
    },
    async checkMontageLink() {
      if (this.isExternal) {
        this.montageLinkAvailable = false;
        this.montageLinkUrl = '';
        return;
      }
      try {
        const safeName = getProductImageFolder(this.selectedArticleName);
        const res = await api.get(`/api/montage/${safeName}`, {
          validateStatus: s => s === 200 || s === 404 // 404 nicht als "Error" behandeln
        });

        if (res.status === 200) {
          this.montageLinkAvailable = true;
          this.montageLinkUrl = res.data.content.trim(); // Inhalt in Variable schreiben
        } else {
          this.montageLinkAvailable = false;
          this.montageLinkUrl = '';
        }
      } catch (e) {
        console.error('Fehler beim Laden der Montage-Datei:', e);
        this.montageLinkAvailable = false;
        this.montageLinkUrl = '';
      }
    },
    openMontageLink() {
      window.open(this.montageLinkUrl, '_blank');
    },
    clearFields() {
      this.closeProductSearch();
      this.clearRasterDimensionErrors();
      
      // Cleanup geplanter Calc-Timer
      if (this.calcTimerId) {
        clearTimeout(this.calcTimerId);
        this.calcTimerId = null;
      }
      this.isCalculatingPrice = false;
      
      // Leere alle Textfelder
      this.$refs.dynamicContent.querySelectorAll('input[type="text"]').forEach(input => {
        input.value = '';
        // Entferne alle Error-Klassen
        input.classList.remove('input-error', 'out-of-bounds-error');
      });

      // Setze alle Selectboxen auf den ersten Wert zurück
      this.$refs.dynamicContent.querySelectorAll('select').forEach(select => {
        select.selectedIndex = 0;
      });

      // Verstecke alle Error-Tooltip-Container
      this.$refs.dynamicContent.querySelectorAll('.error-tooltip-container').forEach(container => {
        container.style.visibility = 'hidden';
      });

      // Optionale: andere Felder leeren oder zurücksetzen
      this.ramBOverridden = false;
      this.ramBOverrideValue = null;
      this.ramBStandardValue = null;
      this.ramHOverridden = false;
      this.ramHOverrideValue = null;
      this.ramHStandardValue = null;
      this.addedItems = [];
      this.price = 0.0;
      this.positionBezeichnung = '';
      this.searchTextArticle = '';
      this.selectedArticle = null;
      this.selectedPrice = null;
      this.minArticleWidth = null;
      this.minArticleHeight = null;
      this.maxArticleWidth = null;
      this.maxArticleHeight = null;
      this.notizen = '';
      this.anzahl = 1;
      this.selectedArticleId = -1;
      this.positionIsEdited = false;
      this.isAlternativePosition = false;

      const rmb = this.$refs.dynamicContent?.querySelector('.rm_b_value');
      const warn = rmb ? (rmb.closest('.input-container') || rmb.parentElement)?.querySelector('.ramb-warning') : null;
      if (warn) warn.classList.add('hidden-visibility');

      const rmh = this.$refs.dynamicContent?.querySelector('.rm_h_value');
      const warnH = rmh ? (rmh.closest('.input-container') || rmh.parentElement)?.querySelector('.ramh-warning') : null;
      if (warnH) warnH.classList.add('hidden-visibility');

      this.applyStulpVariantAvailability();

      // Event-Listener erneut setzen
      this.refreshEventListener();
    },
    async additionalCheckBoxLogic(e) {
      const target = e.target;
      this.handleInputOverrideCheckboxChange(e);
      if (target?.matches?.('input[type="checkbox"][data-info-target]')) {
        this.updateInputOverrideInfoTargets(target, target.checked);
      }

      const classList = Array.from(target.classList);
      const isXLCheckbox = classList.some(cls => cls.toLowerCase().includes('xl'));
      
      if (isXLCheckbox) {
        const allXLCheckboxes = this.$refs.dynamicContent.querySelectorAll('input[type="checkbox"]');
        const setCheckboxState = (checkbox, isEnabled) => {
          checkbox.disabled = !isEnabled;
          checkbox.style.opacity = isEnabled ? '1' : '0.5';
          const parentLabel = checkbox.closest('label');
          if (parentLabel) {
            parentLabel.style.opacity = isEnabled ? '1' : '0.5';
            parentLabel.style.pointerEvents = isEnabled ? 'auto' : 'none';
          }
        };

        this.isXLVariant = target.checked === true;
        this.lastImageLoadConfig = null;
        this.debouncedImageLoad();
        
        // XL-Checkbox Mutual Exclusion Logic
        if (target.checked) {
          // Suche alle anderen XL-Checkboxen und deaktiviere sie
          allXLCheckboxes.forEach(checkbox => {
            const checkboxClasses = Array.from(checkbox.classList);
            const isOtherXLCheckbox = checkboxClasses.some(cls => cls.toLowerCase().includes('xl'));
            
            // Wenn es eine andere XL-Checkbox ist (nicht die gerade angeklickte)
            if (isOtherXLCheckbox && checkbox !== target) {
              checkbox.checked = false;
              setCheckboxState(checkbox, false);
            }
          });
          setCheckboxState(target, true);
        } else {
          // Wenn die Checkbox deaktiviert wird, alle anderen XL-Checkboxen wieder aktivieren
          allXLCheckboxes.forEach(checkbox => {
            const checkboxClasses = Array.from(checkbox.classList);
            const isOtherXLCheckbox = checkboxClasses.some(cls => cls.toLowerCase().includes('xl'));
            
            if (isOtherXLCheckbox) {
              setCheckboxState(checkbox, true);
            }
          });
        }
        
        // XL-Input-Feld Logik für die aktuelle Checkbox
        const parentStep = target.closest('[id^="s_"]'); // Findet das übergeordnete Step-Element
        if (parentStep) {
          const xValueInput = parentStep.querySelector('.x_value');
          if (xValueInput) {
            if (target.checked) {
              // Checkbox aktiviert: Input deaktivieren und XL-Text setzen
              if (xValueInput.dataset.originalValue === undefined) {
                xValueInput.dataset.originalValue = xValueInput.value || ''; // Ursprünglichen Wert speichern
              }
              xValueInput.value = 'XL-Profil statt Kämpfer';
              xValueInput.disabled = true;
              xValueInput.style.backgroundColor = '#f5f5f5';
              xValueInput.style.color = '#666';
              
              // Change-Event manuell auslösen
              const changeEvent = new Event('change', { bubbles: true });
              xValueInput.dispatchEvent(changeEvent);
              
              // Input-Event ebenfalls auslösen für Live-Updates
              const inputEvent = new Event('input', { bubbles: true });
              xValueInput.dispatchEvent(inputEvent);
            } else {
              // Checkbox deaktiviert: Input wieder aktivieren und ursprünglichen Wert wiederherstellen
              xValueInput.disabled = false;
              xValueInput.style.backgroundColor = '';
              xValueInput.style.color = '';
              xValueInput.value = '';
              delete xValueInput.dataset.originalValue;
              
              // Change-Event manuell auslösen
              const changeEvent = new Event('change', { bubbles: true });
              xValueInput.dispatchEvent(changeEvent);
              
              // Input-Event ebenfalls auslösen für Live-Updates
              const inputEvent = new Event('input', { bubbles: true });
              xValueInput.dispatchEvent(inputEvent);
            }
          }
        }
        
        // Kämpfer-Sichtbarkeit nach XL-Checkbox-Änderung aktualisieren
        setTimeout(() => this.setKaempferVisibilityXLVersion(), 100);
      }
    },
    getInputOverrideCheckboxes(root = this.$refs.dynamicContent) {
      if (!root) return [];

      return Array.from(root.querySelectorAll('input[type="checkbox"][data-disable-target][data-disabled-value]'));
    },
    getInputOverrideInfoCheckboxes(root = this.$refs.dynamicContent) {
      if (!root) return [];

      return Array.from(root.querySelectorAll('input[type="checkbox"][data-info-target]'));
    },
    getInputOverrideTarget(checkbox) {
      const selector = checkbox?.dataset?.disableTarget;
      if (!selector) return null;

      const root = checkbox.closest('.container') || checkbox.closest('[id^="s_"]') || this.$refs.dynamicContent;
      return root?.querySelector(selector) || null;
    },
    getInputOverrideRoot(checkbox) {
      return checkbox?.closest('.container') || checkbox?.closest('[id^="s_"]') || this.$refs.dynamicContent;
    },
    getInputOverrideInfoTargets(checkbox) {
      const selector = checkbox?.dataset?.infoTarget;
      if (!selector) return [];

      const root = this.getInputOverrideRoot(checkbox);
      return root ? Array.from(root.querySelectorAll(selector)) : [];
    },
    getSelectedArticleKeyword() {
      const rawArticleText = (this.searchTextArticle || this.selectedArticleName || '').toString();
      return rawArticleText.split(' - ')[0].trim();
    },
    isPg500Montageprofil() {
      const keyword = this.getSelectedArticleKeyword().normalize('NFKC').replace(/[\u2010-\u2015]/g, '-');
      return /^(500|525)\s*\/\s*35\d(?:\.\d+)?-M/i.test(keyword);
    },
    getStepName(step) {
      return Number(step.id) === 696 && this.isPg500Montageprofil() ? 'ZAM Maß' : step.name;
    },
    isAdditionalOptionStep(step) {
      const name = String(step.name || '').trim();
      return /^Befestigung(?:svariante)?\s+(links|rechts|oben|unten)\b/i.test(name)
        || ([26, 27, 28].includes(Number(step.artikel_id ?? this.selectedArticle))
          && Number(step.inner_position) > 0
          && /^Montagerahmen (Seiten?|Lage)$/i.test(name))
        || (Number(step.inner_position) > 0
          && /^(Auflagen|RAL-(Nummer|Name)|Glanzgrad|Pulvernummer|Folie|Foliennummer|Winkel-Bürsten-Profil)$/i.test(name));
    },
    getStepTemplate(step) {
      if (!this.isPg500Montageprofil()) return step.html;
      if (Number(step.id) === 696) {
        return step.html
          .replace('Breite ohne Beschläge:</div>', 'ZAM Breite:</div>')
          .replace('>Höhe:</div>', '>ZAM Höhe:</div>')
          .replaceAll('Maße ohne Beschläge und Bürsten.', 'ZAM Maße inklusive Scharniere und Montageprofil.')
          .replace(" style='padding-left: 52% !important;'", '');
      }
      if (Number(step.id) === 697) {
        return step.html.replace('die Breite ohne Beschläge nicht überschreiten', 'die ZAM Breite nicht überschreiten');
      }
      return step.html;
    },
    buildAnalogVariantName(articleKeyword = this.getSelectedArticleKeyword()) {
      const rawKeyword = (articleKeyword || '').toString().trim();
      if (!rawKeyword) return 'xxx.1';

      const parts = rawKeyword.split(' / ').map(part => part.trim());
      const mainPart = parts[0].replace(/^(\d+)(?!\.1)(?=-|$)/, '$1.1');
      return [mainPart, ...parts.slice(1)].filter(Boolean).join(' / ');
    },
    buildInputOverrideInfoText(checkbox) {
      const template = checkbox?.dataset?.infoTemplate || 'Analog zu der {variant} Variante';
      return template.replace('{variant}', this.buildAnalogVariantName());
    },
    isInputOverrideInfoAlwaysVisible(checkbox) {
      return (checkbox?.dataset?.infoAlwaysVisible || '').toLowerCase() === 'true';
    },
    shouldRenderInputOverrideInfoHtml(target) {
      return (target?.dataset?.infoHtml || '').toLowerCase() === 'true';
    },
    sanitizeInputOverrideInfoHtml(value) {
      const template = document.createElement('template');
      template.innerHTML = value;
      const allowedTags = new Set(['STRONG', 'B']);

      Array.from(template.content.querySelectorAll('*')).forEach(element => {
        if (!allowedTags.has(element.tagName)) {
          element.replaceWith(document.createTextNode(element.textContent || ''));
          return;
        }

        Array.from(element.attributes).forEach(attribute => element.removeAttribute(attribute.name));
      });

      return template.innerHTML;
    },
    setInputOverrideInfoTargetValue(target, value) {
      if (!target) return;

      if (this.shouldRenderInputOverrideInfoHtml(target)) {
        target.innerHTML = this.sanitizeInputOverrideInfoHtml(value);
      } else if ('value' in target) {
        target.value = value;
      } else {
        target.textContent = value;
      }
    },
    updateInputOverrideInfoTargets(checkbox, isActive) {
      const infoTargets = this.getInputOverrideInfoTargets(checkbox);
      if (!infoTargets.length) return;

      const shouldShow = isActive || this.isInputOverrideInfoAlwaysVisible(checkbox);
      const infoText = shouldShow ? this.buildInputOverrideInfoText(checkbox) : '';
      infoTargets.forEach(target => {
        const container = target.closest('.input-container') || target;
        this.setInputOverrideInfoTargetValue(target, infoText);

        container.style.display = shouldShow ? '' : 'none';
        container.hidden = !shouldShow;
        container.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      });
    },
    dispatchInputOverrideTargetEvents(target) {
      if (!target) return;

      target.dispatchEvent(new Event('change', { bubbles: true }));
      target.dispatchEvent(new Event('input', { bubbles: true }));
    },
    applyInputOverrideCheckbox(checkbox, shouldDispatch = true, forcedActiveState = null) {
      const target = this.getInputOverrideTarget(checkbox);
      const overrideValue = (checkbox?.dataset?.disabledValue || '').trim();
      if (!checkbox || !target || !overrideValue) return;

      const targetValue = (target.value || '').trim();
      const isActive = forcedActiveState !== null
        ? forcedActiveState
        : checkbox.checked || targetValue === overrideValue;

      if (isActive) {
        checkbox.checked = true;
        if (target.dataset.inputOverrideOriginalValue === undefined && targetValue !== overrideValue) {
          target.dataset.inputOverrideOriginalValue = target.value || '';
        }
        target.value = overrideValue;
        target.disabled = true;
        target.style.backgroundColor = '#f5f5f5';
        target.style.color = '#666';
        target.setAttribute('aria-disabled', 'true');
      } else {
        target.disabled = false;
        target.style.backgroundColor = '';
        target.style.color = '';
        target.removeAttribute('aria-disabled');

        if ((target.value || '').trim() === overrideValue) {
          target.value = target.dataset.inputOverrideOriginalValue || '';
        }
        delete target.dataset.inputOverrideOriginalValue;
      }

      this.updateInputOverrideInfoTargets(checkbox, isActive);

      if (shouldDispatch) {
        this.dispatchInputOverrideTargetEvents(target);
      }
    },
    applyInputOverrideCheckboxes(options = {}) {
      const shouldDispatch = options.dispatch === true;
      const overrideCheckboxes = this.getInputOverrideCheckboxes();
      const handledCheckboxes = new Set(overrideCheckboxes);

      overrideCheckboxes.forEach(checkbox => {
        this.applyInputOverrideCheckbox(checkbox, shouldDispatch);
      });

      this.getInputOverrideInfoCheckboxes()
        .filter(checkbox => !handledCheckboxes.has(checkbox))
        .forEach(checkbox => {
          this.updateInputOverrideInfoTargets(checkbox, checkbox.checked);
        });
    },
    handleInputOverrideCheckboxChange(event) {
      const target = event?.target;
      if (!target?.matches?.('input[type="checkbox"][data-disable-target][data-disabled-value]')) {
        return;
      }

      this.applyInputOverrideCheckbox(target, true, target.checked);
    },
    async refreshSavedArticles(options = {}) {
      try {
        const project = await this.configuratorApi.loadProject();
        if (this.isExternal) this.selectedProject = project;
        this.savedArticles = project.positions;
        if (options.syncCart !== false && this.$refs.cartComponent?.setCardItems) {
          await this.$refs.cartComponent.setCardItems(this.savedArticles);
        }
        return true;  // Promise wird hier aufgelöst
      } catch (error) {
        if (this.isExternal) this.showError(integrationErrorMessage(error));
        else console.error('Fehler beim Laden der gespeicherten Artikel: ', error);
        return false;  // Promise wird hier abgelehnt
      }
    },
    async synchronizePowderFees() {
      if (this.isExternal) {
        if (this.savedArticles.some(position => requiresUnsupportedPowderFee(JSON.parse(position.artikel_json)))) {
          this.showError('Diese Konfiguration benötigt eine Pulverpauschale. Dieser Sonderfall ist in der Demo noch nicht unterstützt; bitte eine Standardoberfläche wählen.');
        }
        return;
      }
      const desiredFees = new Map();
      const existingFees = [];

      (this.savedArticles || []).forEach(savedArticle => {
        let config;
        try {
          config = JSON.parse(savedArticle.artikel_json);
        } catch {
          return;
        }

        if (config.type === 'powder_fee') {
          existingFees.push({ savedArticle, config });
          return;
        }

        const pricing = config.ralPricing;
        if (pricing?.key && pricing.powderFee !== null && pricing.powderFee !== ''
          && Number.isFinite(Number(pricing.powderFee))) {
          desiredFees.set(pricing.key, pricing);
        }
      });

      const keptKeys = new Set();
      let changed = false;
      for (const fee of existingFees) {
        const key = fee.config.powderFeeKey;
        if (!desiredFees.has(key) || keptKeys.has(key)) {
          await api.delete(`/api/gespeicherteartikel/${fee.savedArticle.id}`, {
            data: this.actorParams(),
          });
          changed = true;
        } else {
          keptKeys.add(key);
        }
      }

      for (const [key, pricing] of desiredFees) {
        if (keptKeys.has(key)) continue;
        const feeValue = Number(pricing.powderFee);
        const config = {
          type: 'powder_fee',
          isSummaryAdjustment: true,
          powderFeeKey: key,
          text: `Pulverpauschale RAL ${pricing.ralCode} / ${pricing.manufacturerArticleNumber}`,
          calculationType: 'amount',
          value: feeValue,
          percentValue: null,
          amountValue: feeValue,
        };
        await api.post('/api/gespeicherteartikel', {
          position_bezeichnung: 'Pulverpauschale',
          artikel_json: JSON.stringify(config),
          anzahl: 1,
          notizen: '',
          projekt_id: this.selectedProject.id,
          ...this.actorParams(),
        });
        changed = true;
      }

      if (changed) {
        await this.refreshSavedArticles({ syncCart: false });
      }
    },
    async refreshProject() {
      this.productRefreshed = true;
      this.selectedProject = this.isExternal ? this.configuratorContext.project : this.$parent.getSelectedProject();
      this.position = 1;
      this.cartVisible = false;
      this.isLoading = true;
      try {
        const success = await this.refreshSavedArticles({ syncCart: false });
        if (success && this.savedArticles.length > 0) {
          await this.toggleCart();  // Warenkorb öffnen, wenn mindestens ein Artikel vorhanden ist
        } else {
          this.pushConfiguratorHistory('position');
        }
      } finally {
        this.isLoading = false;
      }
    },
    toggle(event) {
      let parentCollapsing = false;
      const clickedElement = event.target;
      const parentCategory = clickedElement.closest('.category');
      if (!parentCategory) return;
      
      const content = parentCategory.querySelector('.category-content');
      if (!content) return;

      if (content.style.maxHeight === '0px' || !content.style.maxHeight) {
        content.style.maxHeight = `${content.scrollHeight}px`;
        parentCollapsing = false;
      } else {
        content.style.maxHeight = '0px';
        parentCollapsing = true;
      }

      // Prüfe alle inner-categories, ob der nächststehende 
      // Die logik von oben muss hier umgekehrt werden, da die Category jetzt hier die style elmente besitzt
      let nextSibling = parentCategory.nextElementSibling;
      while(nextSibling && nextSibling.matches('.inner-category')) {
        if (parentCollapsing) {
          nextSibling.classList.add('collapsed');
        }
        else {
          nextSibling.classList.remove('collapsed');
        }
        nextSibling = nextSibling.nextElementSibling; 
      }
    },
    parseSMassDisplayValue(displayValue) {
      if (!displayValue || typeof displayValue !== 'string') {
        return { s: null, groupText: null, smk: null, fa: null };
      }

      const text = displayValue.trim();
      const re = /^\s*(\d+)\s*mm(?:\s*\(([^)]+)\))?(?:\s+(\d+)\s*mm)?(?:\s+(\d+)\s*mm)?\s*$/i;
      const m = text.match(re);

      if (!m) {
        return { s: null, groupText: null, smk: null, fa: null };
      }

      const [, s, groupText, smk, fa] = m;

      return {
        s: s != null ? Number(s) : null,
        groupText: groupText || null,
        smk: smk != null ? Number(smk) : null,
        fa: fa != null ? Number(fa) : null,
      };
    },
    parseFluegelDisplayValue(displayValue) {
      const nums = Array.from(String(displayValue || '').matchAll(/(\d+(?:[.,]\d+)?)/g)).map(m => m[1].replace(',', '.'));
      if (nums.length === 0) {
        return { left: null, right: null, height: null };
      }

      const left = nums[0] ?? null;
      let height = null;
      let right = null;

      if (nums.length === 2) {
        right = nums[1];
      } else if (nums.length >= 3) {
        height = nums[1] ?? null;
        right = nums[2] ?? nums[1] ?? null;
      }

      if (!height && nums.length >= 4) {
        height = nums[1] ?? null;
      }

      return { left, right, height };
    },
    normalizeDimensionValue(val) {
      return (val ?? '').toString().replace(/mm/ig, '').replace(/,/g, '.').trim();
    },
    getReferenceHeightValue() {
      const zamPriceHeight = this.$refs.dynamicContent?.querySelector('.zam_h_value[data-price-y-sum]');
      if (zamPriceHeight) {
        return this.normalizeDimensionValue(zamPriceHeight.value) || null;
      }

      const dimItem = this.addedItems?.find(it => {
        const n = (it.name || '').toLowerCase();
        return n.includes('maß') && !n.includes('s-maß');
      });
      if (dimItem && typeof dimItem.value === 'string') {
        const parsedDim = this.parseFluegelDisplayValue(dimItem.value);
        if (parsedDim?.right) {
          return this.normalizeDimensionValue(parsedDim.right);
        }
      }

      const root = this.$refs.dynamicContent;
      if (root) {
        const heightEl = root.querySelector('.y_value.min_value') || root.querySelector('.y_value');
        const raw = heightEl ? (heightEl.value || heightEl.textContent || '').trim() : '';
        if (raw) {
          return this.normalizeDimensionValue(raw);
        }
      }

      return null;
    },
    getAddedItemRawValue(item) {
      return item?.value !== null && item?.value !== undefined && item.value.toString().trim() !== ''
        ? item.value
        : (item?.emptyValue != null ? item.emptyValue : item?.value);
    },
    shouldHideAddedItem(item) {
      const rawValue = this.getAddedItemRawValue(item);
      const normalizedValue = String(rawValue ?? '').trim().toLowerCase();
      return normalizedValue === '' || normalizedValue === 'ohne';
    },
    formatGriffkaempferHoeheValue(item, rawValue) {
      const name = (item?.name || '').toLowerCase();
      const value = String(rawValue || '').trim();

      if (!name.includes('kämpfer') || !name.includes('höhe') || !value || value.toLowerCase().includes('v. uk ram')) {
        return null;
      }

      const numericValue = Number(value.replace(/mm/ig, '').replace(',', '.').trim());
      if (Number.isNaN(numericValue)) {
        return null;
      }

      return `${this.normalizeDimensionValue(value)}mm v. UK RAM`;
    },
    formatEndrasterwunschhoeheValue(item, rawValue) {
      const name = (item?.name || '').toLowerCase();
      const value = String(rawValue || '').trim();

      if (name !== 'endrasterwunschhöhe' || !value || value.toLowerCase().includes('v. unten')) {
        return null;
      }

      const numericValue = Number(value.replace(/mm/ig, '').replace(',', '.').trim());
      if (Number.isNaN(numericValue)) {
        return null;
      }

      return `${this.normalizeDimensionValue(value)}mm v. unten`;
    },
    formatLabeledLineValue(rawValue) {
      if (typeof rawValue !== 'string' || !/(^|\s)Seite\s+\d+\s*:/i.test(rawValue)) {
        return null;
      }

      const parts = rawValue
        .split(/\s+\/\s+|\n+/)
        .map(part => part.trim())
        .filter(Boolean);

      if (parts.length < 2 || !parts.every(part => /^Seite\s+\d+\s*:/i.test(part))) {
        return null;
      }

      return parts.join('\n');
    },
    formatAddedItemValue(item) {
      if (typeof item.value === 'number') {
        return this.formatPriceValue(item.value);
      }

      const rawValue = this.getAddedItemRawValue(item);
      const formattedWinkelBuerstenProfil = formatWinkelBuerstenProfilValue(item, rawValue);
      if (formattedWinkelBuerstenProfil !== null) return formattedWinkelBuerstenProfil;
      const formattedAuflagen = formatAuflagenValue(item, rawValue);
      if (formattedAuflagen !== null) return formattedAuflagen;
      const ralColorName = String(item?.ralColorName || '').trim();
      if ((item?.name || '').toLowerCase().includes('ral') && ralColorName) {
        return `${rawValue} – ${ralColorName}`;
      }

      if (item.name === 'S-Maß' && typeof rawValue === 'string') {
        const parsed = this.parseSMassDisplayValue(rawValue);

        if (parsed && parsed.smk != null && parsed.groupText) {
          const groupNumber = parsed.groupText.replace(/[^0-9]/g, '');
          return `S-Maß (Klammer) ${parsed.smk}mm aus Gr. ${groupNumber}`;
        }
      }

      const formattedLabeledLineValue = this.formatLabeledLineValue(rawValue);
      if (formattedLabeledLineValue) {
        return formattedLabeledLineValue;
      }

      const formattedGriffkaempferHoehe = this.formatGriffkaempferHoeheValue(item, rawValue);
      if (formattedGriffkaempferHoehe) {
        return formattedGriffkaempferHoehe;
      }

      const formattedEndrasterwunschhoehe = this.formatEndrasterwunschhoeheValue(item, rawValue);
      if (formattedEndrasterwunschhoehe) {
        return formattedEndrasterwunschhoehe;
      }

      if ((item.name || '').toLowerCase() === 'flügel' && typeof rawValue === 'string') {
        const parsed = this.parseFluegelDisplayValue(rawValue);
        const heightRaw = this.getReferenceHeightValue() || parsed.height;
        const height = heightRaw ? this.normalizeDimensionValue(heightRaw) : null;
        const left = parsed.left ? this.normalizeDimensionValue(parsed.left) : null;
        const right = parsed.right ? this.normalizeDimensionValue(parsed.right) : null;

        if (left && right && height) {
          return `Flügel 1: ${left}mm x ${height}mm
Flügel 2: ${right}mm x ${height}mm`;
        }
        if (left && height) {
          return `Flügel 1: ${left}mm x ${height}mm`;
        }
        if (left && right) {
          return `Flügel 1: ${left}mm
Flügel 2: ${right}mm`;
        }
        return rawValue;
      }

      return rawValue;
    },
    showError(message) {
      this.errorMessage = message;
      this.error = true;
    },
    clearError() {
      this.error = false;
      this.errorMessage = '';
    },
    loadTest() {
      this.loadConfiguredArticleFromJSON("{\"articleId\":1,\"articleSearchText\":\"103 - Rahmen-C ohne Beschlag\",\"items\":[{\"id\":1,\"name\":\"Maße\",\"value\":\"1500mm x 1000mm\"},{\"id\":37,\"name\":\"Kämpfer von rechts\",\"value\":\"50mm\"},{\"id\":6,\"name\":\"Oberfläche\",\"value\":\"RAL 9016\"},{\"id\":4,\"name\":\"Aufdopplung\",\"value\":\"umlaufend\"},{\"id\":9,\"name\":\"Gewebe\",\"value\":\"Fiberglas grau\"}],\"price\":170.39999999999998}");
    },
    async saveOrUpdate() {
      if (!this.ensureProjectEditable()) {
        return;
      }

      // Prevent multiple save operations
      if (this.isCalculatingPrice) {
        setTimeout(() => this.saveOrUpdate(), 100);
        return;
      }

      const mandatoryFields = this.$refs.dynamicContent.querySelectorAll('.mandatory-field');

      mandatoryFields.forEach(field => {
        // Gehe hoch bis zur Kategorie
        let parentCategory = field.parentElement;
        while (parentCategory && (!parentCategory.classList.contains('category') && !parentCategory.classList.contains('inner-category'))) {
          parentCategory = parentCategory.parentElement;
        }

        if (parentCategory) {
          const style = window.getComputedStyle(parentCategory);
          const isVisible = style.visibility !== 'hidden';

          if (isVisible) {
            // Prüfen ob das Input-Feld leer ist
            if (field.value.trim() === '') {
              field.classList.add('input-error');
            } else {
              field.classList.remove('input-error');
            }
          }
        }
      });
      this.calculateSMASS();
      this.validateKaempferMasse();
      this.validateGangfluegelBreite();
      this.validateConfiguredDimensionLimits();
      this.validateIndependentWingWidths();
      this.validateAccessoryLength(true);
      const fieldsWithInputErrors = this.$refs.dynamicContent.querySelectorAll('.input-error');
      if (fieldsWithInputErrors.length > 0) {
        return;
      }

      // Check the current inputs, including edits made before the debounced calculation ran.
      if (this.selectedPrice != null) {
        const content = this.$refs.dynamicContent;
        const articleId = this.selectedArticle;
        const inputValues = Array.from(content.querySelectorAll('input')).map(input => input.value);
        if (this.calcTimerId) {
          clearTimeout(this.calcTimerId);
          this.calcTimerId = null;
        }
        await this.calculatePriceFromScratchSafe();
        if (this.$refs.dynamicContent !== content || this.selectedArticle !== articleId
          || !this.ensureProjectEditable()
          || Array.from(content.querySelectorAll('input')).some((input, index) => input.value !== inputValues[index])) return;
      }
      if (this.rasterDimensionError) return;

      // Zusätzliche Prüfung für Felder mit einem Inhalt der zu groß ist (Für Höhe/Breite Felder)
      const fieldsWithErrors = this.$refs.dynamicContent.querySelectorAll('.out-of-bounds-error');
      if (fieldsWithErrors.length > 0) {
        return;
      }

      this.commitAnzahlChange();

      if (this.selectedArticle != null) {
        await this.saveASJSON(this.positionIsEdited);
      }
    },
    async saveASJSON(override) {
      if (!this.ensureProjectEditable()) {
        return;
      }

      this.isLoading = true;  
      this.positionExists = false;
      this.commitAnzahlChange();
      this.configurationJSON = this.getConfigurationAsJSON();
      if (this.isExternal && requiresUnsupportedPowderFee(JSON.parse(this.configurationJSON))) {
        this.isLoading = false;
        this.showError('Diese Konfiguration benötigt eine Pulverpauschale. Sie kann in dieser Demo noch nicht gespeichert werden. Bitte eine Standardoberfläche wählen.');
        return;
      }
      let targetId = override ? this.selectedArticleId : null;

      try {
        if (!override) {
          const response = await this.configuratorApi.createPosition({
            position_bezeichnung: this.positionBezeichnung,
            artikel_json: this.configurationJSON,
            anzahl: this.anzahl,
            notizen: this.notizen,
            projekt_id: this.selectedProject.id,
            ...this.actorParams(),
          });
          if (response?.data?.id != null) {
            targetId = response.data.id;
          }
          this.clearFields();
        } else {
          await this.configuratorApi.updatePosition(this.selectedArticleId, {
            position_bezeichnung: this.positionBezeichnung, 
            artikel_json: this.configurationJSON, 
            anzahl: this.anzahl, 
            notizen: this.notizen,
            projekt_id: this.selectedProject.id,
            ...this.actorParams(),
          });
        }

        await this.refreshSavedArticles({ syncCart: false });
        await this.synchronizePowderFees();
        await this.refreshSavedArticles();

        if (!targetId && this.savedArticles.length > 0) {
          targetId = this.savedArticles[this.savedArticles.length - 1].id;
        }

        await this.openCartAndFocus(targetId);
      } catch (error) {
        if (error.response?.data?.errors?.dimensions) this.showError(RASTER_DIMENSION_ERROR);
        else if (this.isExternal) await this.showIntegrationWriteError(error);
        else console.error('Es gab einen Fehler beim Speichern der Position: ', error);
      } finally {
        this.isLoading = false;
      }
    },
    confirmDeletePosition() {
      if (!this.ensureProjectEditable()) {
        return;
      }

      if (this.selectedArticleId >= 0) {
        this.showDeleteConfirmation = true;
      }
    },
    cancelDelete() {
      this.showDeleteConfirmation = false;
    },
    deletePosition() {
      if (!this.ensureProjectEditable()) {
        this.showDeleteConfirmation = false;
        return;
      }

      this.showDeleteConfirmation = false;
      this.isLoading = true;
      this.deletePositionWithID(this.selectedArticleId);
    },
    deletePositionWithID(articleId) {
      if (!this.ensureProjectEditable()) {
        this.isLoading = false;
        return;
      }

      return this.configuratorApi.deletePosition(articleId)
      .then(async () => {
          await this.refreshSavedArticles({ syncCart: false });
          await this.synchronizePowderFees();
          await this.refreshSavedArticles();
          this.clearFields();
          this.isLoading = false;
      })
      .catch(error => {
          if (this.isExternal) return this.showIntegrationWriteError(error);
          console.error('Es gab einen Fehler beim löschen der Position: ', error);
      }).finally(() => { this.isLoading = false; });
    },
    async showIntegrationWriteError(error) {
      this.selectedProject = this.configuratorContext.project;
      this.savedArticles = this.selectedProject.positions || [];
      await this.$refs.cartComponent?.setCardItems(this.savedArticles);
      this.showError(integrationErrorMessage(error));
    },
    getConfigurationAsJSON() {
      const article = Array.isArray(this.articleLists)
        ? this.articleLists.find(a => a.id == this.selectedArticle)
        : null;
      const discountPosition = article ? article.discount_position : null;
      const accessory = this.getAccessoryElement();

      return JSON.stringify({
        articleId: this.selectedArticle,
        articleDiscountPosition: discountPosition,
        ...(accessory ? {
          articleDiscountable: accessory.dataset.accessoryDiscountable !== '0',
        } : {}),
        articleSearchText: this.searchTextArticle,
        items: this.addedItems,
        price: this.price,
        priorityFolders: this.buildPriorityParam(),
        isAlternativePosition: this.isAlternativePosition,
        ralPricing: accessory ? null : this.currentRalPricing
      });
    },
    resolveSavedArticleSearchText(searchText, articleId) {
      const savedText = String(searchText ?? '');
      const normalize = value => String(value ?? '')
        .normalize('NFKC')
        .replace(/[\u2010-\u2015]/g, '-')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
      const normalizedText = normalize(savedText);
      if (!normalizedText) return savedText;

      const keywords = this.articleLists
        .filter(article => articleId == null || String(article.id) === String(articleId))
        .flatMap(article => String(article.keywords ?? '').split(';'))
        .filter(keyword => keyword.trim());
      const exactMatches = keywords.filter(keyword => normalize(keyword) === normalizedText);
      if (exactMatches.length === 1) return exactMatches[0];

      // Die Kennung vor " - " bleibt bei einer umbenannten Beschreibung bestehen.
      const variant = normalizedText.split(' - ')[0].trim();
      const variantMatches = keywords.filter(keyword => normalize(keyword).split(' - ')[0].trim() === variant);
      return variantMatches.length === 1 ? variantMatches[0] : savedText;
    },
    async loadConfiguredArticleFromJSON(jsonString) {
      this.isLoading = true;
      try {
        const config = JSON.parse(jsonString);
        this.isAlternativePosition = config.isAlternativePosition === true
          || config.isAlternativePosition === 1
          || config.isAlternativePosition === '1'
          || config.isAlternativePosition === 'true'
          || config.alternativePosition === true
          || config.alternativePosition === 1
          || config.alternativePosition === '1'
          || config.alternativePosition === 'true';

        // Setze den ausgewählten Artikel
        this.selectedArticle = config.articleId;
        this.searchTextArticle = this.resolveSavedArticleSearchText(config.articleSearchText, config.articleId);
        await this.changeArticleByText({ ignoreProductFilters: true, articleId: config.articleId });

        // Fülle die `addedItems` mit den Werten aus der JSON-Konfiguration
        this.addedItems = config.items.map(item => ({
          id: item.id,
          name: item.name,
          value: item.value,
          hex: item.hex || null,
          ...(item.ralColorName != null ? { ralColorName: item.ralColorName } : {}),
          ...(item.zamWidthValue != null ? { zamWidthValue: item.zamWidthValue } : {}),
          ...(item.zamHeightValue != null ? { zamHeightValue: item.zamHeightValue } : {})
        }));

        // Setze den Preis
        this.price = config.price;

        // Wait for DOM to be ready and then update UI
        await this.$nextTick();
        
        // Wait a bit more for all dynamic content to be rendered
        await new Promise(resolve => setTimeout(resolve, 500));
        
        // Ensure event listeners are properly set up
        this.refreshEventListener();
        
        // Load UI values
        await this.refreshUIAfterLoad();
        
        // Submit form to recalculate and refresh
        await this.submitForm();
        
        // Do a second pass to ensure everything is set correctly
        await new Promise(resolve => setTimeout(resolve, 300));
        await this.refreshUIAfterLoad();
      } catch (error) {
        console.error('Error loading configuration:', error);
        this.showError('Fehler beim Laden der Konfiguration: ' + error.message);
      } finally {
        this.isLoading = false;
      }
    },
    setLoading(isLoading) {
      this.isLoading = isLoading;
    },
    // Helper method to wait for DOM elements to be available
    async waitForElement(selector, maxAttempts = 10) {
      let attempts = 0;
      while (attempts < maxAttempts) {
        const element = document.querySelector(selector);
        if (element) {
          return element;
        }
        await new Promise(resolve => setTimeout(resolve, 100));
        attempts++;
      }
      console.warn(`Element with selector '${selector}' not found after ${maxAttempts} attempts`);
      return null;
    },
    async refreshUIAfterLoad() {
      // Warten, bis DOM aktualisiert ist
      await this.$nextTick();
      await new Promise(resolve => setTimeout(resolve, 100));

      // kleine Helper nur lokal in dieser Methode
      const fireInputAndChange = (el, value) => {
        if (!el) return;
        el.value = value != null ? String(value) : '';
        const inputEvent = new Event('input', { bubbles: true });
        const changeEvent = new Event('change', { bubbles: true });
        el.dispatchEvent(inputEvent);
        el.dispatchEvent(changeEvent);
      };

      // Alle gespeicherten Items wieder ins UI schreiben
      for (const item of this.addedItems) {
        const stepDiv = await this.waitForElement(`#s_${item.id}`);
        if (!stepDiv) {
          console.warn(`Step div with ID s_${item.id} not found`);
          continue;
        }

        let categoryContentElement =
          stepDiv.querySelector(".category-content") ||
          stepDiv.querySelector(".inner-category-content");
        if (!categoryContentElement) {
          console.warn(`Category content element not found for step ID ${item.id}`);
          continue;
        }

        // Maßschritte können ZAM und RAM in getrennten Container-Zeilen enthalten.
        const containerElement = categoryContentElement;
        if (!containerElement.querySelector('.container')) {
          console.warn(`Container element not found for step ID ${item.id}`);
          continue;
        }

        const emptyValueElement = containerElement.querySelector(".empty_value");
        if (emptyValueElement != null) {
          item.emptyValue = emptyValueElement.value || emptyValueElement.textContent || emptyValueElement.innerHTML;
        }

        // ========= 1) SPEZIALFALL S-Maß / FA-Maß =========
        const smValueEl  = containerElement.querySelector(".sm_value");
        const grValueEl  = containerElement.querySelector(".gr_value");
        const smkValueEl = containerElement.querySelector(".smk_value");
        const famValueEl = containerElement.querySelector(".fam_value");

        if (smValueEl || grValueEl || smkValueEl || famValueEl) {
          const { s, groupText, smk, fa } = this.parseSMassDisplayValue(item.value);

          // S-Maß
          if (smValueEl && s != null && !Number.isNaN(s)) {
            fireInputAndChange(smValueEl, s);
          }

          // Größengruppe anhand Text (Gr.1 / Gr. 1)
          if (grValueEl && groupText) {
            const wanted = groupText.replace(/\s+/g, "").toLowerCase(); // "gr.1"
            const opts = Array.from(grValueEl.options || []);
            const idx = opts.findIndex(opt => {
              const txt = (opt.text || opt.innerHTML || "")
                .replace(/\s+/g, "")
                .toLowerCase();
              return txt === wanted;
            });
            if (idx >= 0) {
              grValueEl.selectedIndex = idx;
              const changeEvent = new Event("change", { bubbles: true });
              grValueEl.dispatchEvent(changeEvent);
            }
          }

          // S-Maß (Klammer)
          if (smkValueEl && smk != null && !Number.isNaN(smk)) {
            fireInputAndChange(smkValueEl, smk);
          }

          // FA-Maß
          if (famValueEl && fa != null && !Number.isNaN(fa)) {
            fireInputAndChange(famValueEl, fa);
          }

          // Dieser Step ist komplett behandelt
          continue;
        }

        // ========= 2) Standard-Fälle wie bisher =========
        let xValueElement = containerElement.querySelector(".x_value");
        let yValueElement = containerElement.querySelector(".y_value");
        let sValueElement = containerElement.querySelector(".s_value"); // nur falls du irgendwo wirklich .s_value benutzt
        let iValueElement = containerElement.querySelector(".i_value");
        const stepSelects = this.getStepSelects(containerElement);
        const dimensionSummaryInputs = this.getDimensionSummaryInputs(containerElement);

        // Zuerst ZAM wiederherstellen, danach gespeicherte RAM-/Flügelkorrekturen.
        const zamWidthElement = containerElement.querySelector('.zam_b_value');
        const zamHeightElement = containerElement.querySelector('.zam_h_value');
        if (zamWidthElement && item.zamWidthValue != null) {
          fireInputAndChange(zamWidthElement, item.zamWidthValue);
        }
        if (zamHeightElement && item.zamHeightValue != null) {
          fireInputAndChange(zamHeightElement, item.zamHeightValue);
        }

        const isFluegelItem = (item.name || '').toLowerCase() === 'flügel';
        // Alte PG-500/300-Konfigurationen enthalten noch beide Flügel; nur den Gangflügel übernehmen.
        if (isFluegelItem && xValueElement != null
          && (yValueElement != null || xValueElement.matches('.gangfluegel_value'))) {
          const parsed = this.parseFluegelDisplayValue(item.value);
          if (parsed.left != null) {
            fireInputAndChange(xValueElement, parsed.left);
          }
          if (parsed.right != null) {
            fireInputAndChange(yValueElement, parsed.right);
          }
          continue;
        }

        if (dimensionSummaryInputs.length > 0 && this.restoreDimensionSummaryDisplayValue(dimensionSummaryInputs, item.value, fireInputAndChange)) {
          continue;
        }

        // 2a) Mehrere Selectboxen in einem Schritt, z.B. Montagerahmen-Seiten
        if (stepSelects.length > 1) {
          this.restoreMultiSelectDisplayValue(stepSelects, item.value);
          continue;
        }
        // 2b) X/Y -> "123mm x 456mm"
        else if (xValueElement != null && yValueElement != null) {
          if (item.value && typeof item.value === "string") {
            let values = item.value.split(' x ');
            if (values.length === 2) {
              const xVal = values[0].replace('mm', '').trim();
              const yVal = values[1].replace('mm', '').trim();

              fireInputAndChange(xValueElement, xVal);
              fireInputAndChange(yValueElement, yVal);
            }
          }
        }
        // 2c) Selectbox
        else if (sValueElement != null) {
          // Vorhandene Zubehörpositionen können noch den früheren Aufpreishinweis enthalten.
          const savedValue = sValueElement.matches('.accessory_surface_value')
            ? String(item.value || '').replace(/^RAL nach Wahl\s*\(\+35\s*%\s*aufpreis\)$/i, 'RAL nach Wahl')
            : (item.value || '');
          for (let option of sValueElement.options) {
            if ((option.innerHTML || option.text).trim() === savedValue.trim()) {
              sValueElement.selectedIndex = option.index;
              const changeEvent = new Event('change', { bubbles: true });
              sValueElement.dispatchEvent(changeEvent);
              break;
            }
          }
        }
        // 2d) Einfaches Inputfeld
        else if (iValueElement != null) {
          const value = iValueElement.dataset.valueUnit === 'm'
            ? String(item.value || '').replace(/\s*m\s*$/i, '').trim()
            : item.value;
          fireInputAndChange(iValueElement, value);
        }
        // 2e) Nur x_value
        else if (xValueElement != null) {
          const xVal = (item.value || '').replace('mm', '').trim();
          fireInputAndChange(xValueElement, xVal);
        }
      }

      this.applyStulpVariantAvailability();
      this.applyInputOverrideCheckboxes();
      this.calculatePendelAuflagen();

      // XL / Kämpfer Nachpflege
      this.initializeDichtbandSMASSState();
      setTimeout(() => this.manageXLInputFields(), 150);
      setTimeout(() => this.checkAndManageXLCheckboxes(), 200);
    },
    
    // Methode zur Verwaltung der XL-Input-Felder beim Laden
    manageXLInputFields() {
      if (!this.$refs.dynamicContent) return;
      
      const allXLCheckboxes = this.$refs.dynamicContent.querySelectorAll('input[type="checkbox"]');
      let anyXLActive = false;
      allXLCheckboxes.forEach(checkbox => {
        const checkboxClasses = Array.from(checkbox.classList);
        const isXLCheckbox = checkboxClasses.some(cls => cls.toLowerCase().includes('xl'));
        
        if (isXLCheckbox) {
          const parentStep = checkbox.closest('[id^="s_"]');
          const xValueInput = parentStep ? parentStep.querySelector('.x_value') : null;
          const hasXLText = xValueInput && xValueInput.value.trim() === 'XL-Profil statt Kämpfer';

          // Wenn die Konfiguration bereits den XL-Text enthält, Checkbox aktivieren
          if (hasXLText && !checkbox.checked) {
            checkbox.checked = true;
          }

          // Wenn Checkbox aktiv oder XL-Text vorhanden: Feld sperren und Text setzen
          if (checkbox.checked || hasXLText) {
            anyXLActive = true;
            if (xValueInput) {
              if (xValueInput.dataset.originalValue === undefined && !hasXLText) {
                xValueInput.dataset.originalValue = xValueInput.value || '';
              }
              xValueInput.value = 'XL-Profil statt Kämpfer';
              xValueInput.disabled = true;
              xValueInput.style.backgroundColor = '#f5f5f5';
              xValueInput.style.color = '#666';

              const changeEvent = new Event('change', { bubbles: true });
              xValueInput.dispatchEvent(changeEvent);
              const inputEvent = new Event('input', { bubbles: true });
              xValueInput.dispatchEvent(inputEvent);
            }
          } else if (xValueInput && xValueInput.value.trim() === 'XL-Profil statt Kämpfer') {
            // Falls Text noch steht, aber Checkbox nicht aktiv: aufräumen
            xValueInput.disabled = false;
            xValueInput.style.backgroundColor = '';
            xValueInput.style.color = '';
            xValueInput.value = '';
            delete xValueInput.dataset.originalValue;
            const changeEvent = new Event('change', { bubbles: true });
            xValueInput.dispatchEvent(changeEvent);
            const inputEvent = new Event('input', { bubbles: true });
            xValueInput.dispatchEvent(inputEvent);
          }
        }
      });

      this.isXLVariant = anyXLActive;
      this.validateGangfluegelBreite();
      // Exklusivität nachziehen, falls mehrere XL-Checkboxen aktiv waren
      setTimeout(() => this.checkAndManageXLCheckboxes(), 50);
    },
    async submitForm() {
      this.calculatePriceFromScratch();
      this.refreshConfiguredArticle();
    },
    async refreshConfiguredArticle() {
      this.updateStulpBrushProfileDefaults();
      this.addedItems = [];
      var categoryTitleElement = null;
      var categoryContentElement = null;
      var innerCategoryContentElement = null;
      var containerElement = null;
      var sValueElement = null;
      var xValueElement = null;
      var yValueElement = null;
      var iValueElement = null;
      var filteredStepListItems = this.filteredStepItems;
      var tmpAddedItem = {id: -1, name: "FEHLER", value: ""};
      for (let i = 0; i < filteredStepListItems.length; ++i) {
        var stepDiv = document.getElementById("s_"+filteredStepListItems[i].id);
        if (stepDiv != null) {
          if (stepDiv.style.visibility === 'hidden') {
            // Hier passiert weiterhin nichts
          }
          else {
            categoryTitleElement = stepDiv.querySelector(".category-title");
            categoryContentElement = stepDiv.querySelector(".category-content");
            innerCategoryContentElement = stepDiv.querySelector(".inner-category-content");
            tmpAddedItem = {id: filteredStepListItems[i].id, name: "Beschlagsgruppe", value: ""};
            // tmpAddedItem = {id: filteredStepListItems[i].id, name: "Beschlagsgruppe", value: ""};
            tmpAddedItem.name = categoryTitleElement.textContent;

            if (categoryContentElement == null) {
              categoryContentElement = innerCategoryContentElement;
            }

            if (categoryContentElement != null) {
              // Alle Maßzeilen des Schritts auswerten, auch berechnete RAM-Felder.
              containerElement = categoryContentElement;
              if (containerElement.querySelector('.container') != null) {
                // Zuerst steps die aus 2 Feldern bestehen prüfen
                xValueElement = containerElement.querySelector(".x_value");
                sValueElement = containerElement.querySelector(".s_value");
                iValueElement = containerElement.querySelector(".i_value");

                var emptyValueElement = containerElement.querySelector(".empty_value");
                if (emptyValueElement != null) {
                  tmpAddedItem.emptyValue = emptyValueElement.innerHTML;
                }

                /**
                 * SPEZIALFALL S-Maß / FA-Maß
                 * sm_value   = S-Maß
                 * gr_value   = Größengruppe (z.B. "Gr. 1")
                 * smk_value  = S-Maß (Klammer)
                 * fam_value  = FA-Maß
                 */
                const smValueEl  = containerElement.querySelector(".sm_value");
                const grValueEl  = containerElement.querySelector(".gr_value");
                const smkValueEl = containerElement.querySelector(".smk_value");
                const famValueEl = containerElement.querySelector(".fam_value");
                const stepSelects = this.getStepSelects(containerElement);
                const dimensionSummaryInputs = this.getDimensionSummaryInputs(containerElement);

                const zamWidthElement = containerElement.querySelector('.zam_b_value');
                const zamHeightElement = containerElement.querySelector('.zam_h_value');
                const ramWidthElement = containerElement.querySelector('.rm_b_value');
                if (zamWidthElement && zamHeightElement && (ramWidthElement || containerElement.querySelector('.wing_l_value'))) {
                  tmpAddedItem.zamWidthValue = this.normalizeDimensionValue(zamWidthElement.value);
                  tmpAddedItem.zamHeightValue = this.normalizeDimensionValue(zamHeightElement.value);
                  if (ramWidthElement) {
                    tmpAddedItem.name = 'RAM Maß';
                  }
                }

                if (dimensionSummaryInputs.length > 0) {
                  tmpAddedItem.value = this.buildDimensionSummaryDisplayValue(dimensionSummaryInputs);
                }
                else if (stepSelects.length > 1) {
                  tmpAddedItem.value = this.buildMultiSelectDisplayValue(stepSelects);
                }
                else if (smValueEl && grValueEl && smkValueEl && famValueEl) {
                  const parts = [];

                  const sVal = (smValueEl.value || "").trim();
                  if (sVal) parts.push(`${sVal}mm`);

                  const grText =
                    grValueEl.options && grValueEl.selectedIndex >= 0
                      ? (grValueEl.options[grValueEl.selectedIndex].text || "").trim()
                      : "";

                  if (grText) {
                    const cleanedGr = grText.replace(/\s+/g, ''); // "Gr. 1" -> "Gr.1"
                    parts.push(`(${cleanedGr})`);
                  }

                  const smkVal = (smkValueEl.value || "").trim();
                  if (smkVal) parts.push(`${smkVal}mm`);

                  const famVal = (famValueEl.value || "").trim();
                  if (famVal) parts.push(`${famVal}mm`);

                  tmpAddedItem.value = parts.join(" ");
                }
                // Standard-Fälle wie bisher:
                else if (xValueElement != null) {
                  yValueElement = containerElement.querySelector(".y_value");
                  const isFluegelStep = (tmpAddedItem.name || '').toLowerCase().includes('flügel');

                  if (isFluegelStep && yValueElement != null) {
                    const left = this.normalizeDimensionValue(xValueElement.value);
                    const right = this.normalizeDimensionValue(yValueElement.value);
                    const height = this.getReferenceHeightValue();
                    if (left && right && height) {
                      tmpAddedItem.value = `${left}mm x ${height}mm / ${right}mm x ${height}mm`;
                    } else if (left && right) {
                      tmpAddedItem.value = `${left}mm x ${right}mm`;
                    } else {
                      tmpAddedItem.value = "";
                    }
                  }
                  else if (yValueElement != null) {
                    if (xValueElement.value !== "" && yValueElement.value !== "") {
                      tmpAddedItem.value = xValueElement.value + "mm x "+yValueElement.value + "mm";
                    }
                    else {
                      tmpAddedItem.value = "";
                    }
                  }
                  else {
                    if (xValueElement.value !== "") {
                      tmpAddedItem.value = !isNaN(Number(xValueElement.value)) ? xValueElement.value + "mm" : "" + xValueElement.value;
                    } 
                    else {
                      tmpAddedItem.value = "";
                    }
                  }
                }
                // Dropdown
                else if (sValueElement != null) {
                  tmpAddedItem.value = this.getSelectOptionDisplayText(this.getSelectedOption(sValueElement));
                }
                // Andere Input-Texte
                else if (iValueElement != null) {
                  tmpAddedItem.value = ""+iValueElement.value;
                  if (iValueElement.dataset.valueUnit === 'm' && tmpAddedItem.value.trim()) {
                    tmpAddedItem.value = `${tmpAddedItem.value.trim()} m`;
                  }
                }
              }
            }
            if (tmpAddedItem.id > -1 ) {
              if ((tmpAddedItem.name || '').toLowerCase().includes('ral')) {
                tmpAddedItem.hex = this.selectedRalHex || null;
                const ralColorName = String(this.getRalColorNameField()?.value || '').trim();
                if (ralColorName) {
                  tmpAddedItem.ralColorName = ralColorName;
                }
              }
              this.addedItems.push(tmpAddedItem);
            }
          }
        }
      }  
    },
    isStepHidden(stepDiv) {
      if (!stepDiv) return true;

      const s = getComputedStyle(stepDiv);
      if (s.visibility === 'hidden' || s.display === 'none') return true;

      return false;
    },
    hasVisibleNoPriceValue(stepDiv) {
      if (!stepDiv || this.isStepHidden(stepDiv)) {
        return false;
      }

      const noPriceValueElement = stepDiv.querySelector('.no_price_value');
      if (noPriceValueElement == null || noPriceValueElement.value.trim() === '') {
        return false;
      }

      return true;
    },

    getSelectedRalCode() {
      const isVisible = (el) => {
        if (!el) return false;
        const style = window.getComputedStyle(el);
        if (style.display === 'none' || style.visibility === 'hidden') return false;
        if (el.offsetParent === null && style.position !== 'fixed') return false;
        return true;
      };

      const content = this.$refs.dynamicContent;
      if (content) {
        const rnField = content.querySelector('.rn_value');
        if (isVisible(rnField)) {
          const raw = String(rnField.value || '').trim();
          if (raw) return raw;
        }
      }

      return null;
    },
    normalizeRalCode(code = '') {
      return String(code || '').replace(/\s+/g, '').toUpperCase().replace(/^RAL/, '');
    },
    getRalProductGroup() {
      const articleId = Number(this.selectedArticle);
      const articleName = String(this.searchTextArticle || '').toLowerCase();

      if ([21, 22, 23, 24].includes(articleId) || articleName.includes('800') || articleName.includes('lisa')) {
        return '800_lisa';
      }
      if (articleName.includes('900') || articleName.includes('vsp')) {
        return '900_vsp';
      }
      if ([26, 27, 28].includes(articleId) || articleName.includes('p45') || articleName.includes('p-rollo')) {
        return 'p45';
      }
      return '100_700_p20';
    },
    getPowderNumberField() {
      const content = this.$refs.dynamicContent;
      if (!content) return null;

      const fields = Array.from(content.querySelectorAll('.no_price_value, input.i_value:not(.rn_value)'));
      const isVisible = field => {
        const style = window.getComputedStyle(field);
        return style.display !== 'none'
          && style.visibility !== 'hidden'
          && (this.isElementVisible(field) || style.position === 'fixed');
      };
      const powderField = fields.find(field => {
        if (!isVisible(field)) return false;
        const label = this.getConfiguratorFieldLabel(field);
        return label.includes('pulver') || label.includes('herstellerartikelnummer');
      });
      if (powderField) return powderField;

      // In älteren Schrittdefinitionen heißt das Pulverfeld nur
      // "no_price_value". Wenn genau ein solches Feld sichtbar ist, ist die
      // Zuordnung trotzdem eindeutig.
      const fallbackFields = fields.filter(field =>
        field.classList.contains('no_price_value') && isVisible(field)
      );
      return fallbackFields.length === 1 ? fallbackFields[0] : null;
    },
    getVisiblePowderNumber() {
      return String(this.getPowderNumberField()?.value || '').trim();
    },
    ensureRalColorNameFields() {
      const content = this.$refs.dynamicContent;
      if (!content) return;

      content.querySelectorAll('.rn_value').forEach(ralField => {
        const container = ralField.closest('.input-container');
        if (!container) return;

        let fields = container.querySelector('.ral-value-fields');
        if (!fields) {
          fields = document.createElement('div');
          fields.className = 'ral-value-fields';
          ralField.parentNode.insertBefore(fields, ralField);
          fields.appendChild(ralField);
        }

        if (!fields.querySelector('.ral-color-name-value')) {
          const colorNameField = document.createElement('input');
          colorNameField.className = 'input ral-color-name-value';
          colorNameField.type = 'text';
          colorNameField.readOnly = true;
          colorNameField.tabIndex = -1;
          colorNameField.setAttribute('aria-label', 'RAL-Farbname');
          colorNameField.setAttribute('aria-readonly', 'true');
          fields.appendChild(colorNameField);
        }

        let swatch = container.querySelector('.ral-show-color');
        if (!swatch) {
          swatch = document.createElement('div');
          swatch.className = 'ral-show-color';
          swatch.setAttribute('aria-label', 'RAL-Farbvorschau');
        }
        if (swatch.parentElement !== fields) {
          fields.appendChild(swatch);
        }
      });
    },
    getRalColorNameField() {
      this.ensureRalColorNameFields();
      return this.$refs.dynamicContent?.querySelector('.ral-color-name-value') || null;
    },
    applyRalColorName(entry) {
      const field = this.getRalColorNameField();
      if (!field) return;

      field.value = String(entry?.farbname || '').trim();
    },
    getRalGlossField() {
      const content = this.$refs.dynamicContent;
      if (!content) return null;

      return Array.from(content.querySelectorAll('select.select')).find(field => {
        if (!this.getConfiguratorFieldLabel(field).includes('glanzgrad')) return false;
        const style = window.getComputedStyle(field);
        return style.display !== 'none' && style.visibility !== 'hidden'
          && (this.isElementVisible(field) || style.position === 'fixed');
      }) || null;
    },
    normalizeRalGloss(value = '') {
      const normalized = String(value || '')
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]/gi, '')
        .toLowerCase();

      if (normalized.includes('metallic')) return 'metallic';
      if (normalized.includes('feinstruktur')) return 'feinstruktur';
      if (normalized.includes('eloxiert')) return 'eloxiert';
      if (normalized.includes('seide')) return 'seidenglaenzend';
      if (normalized.includes('matt')) return 'matt';
      return normalized;
    },
    getSelectedRalGloss() {
      const field = this.getRalGlossField();
      if (!field) return '';

      const option = this.getSelectedOption(field);
      return this.normalizeRalGloss(this.getSelectOptionDisplayText(option) || option?.value || field.value);
    },
    ralEntryMatchesGloss(entry, gloss = this.getSelectedRalGloss()) {
      if (!gloss) return true;
      return [entry?.glanzgrad, entry?.oberflaeche].some(value => this.normalizeRalGloss(value) === gloss);
    },
    pickPreferredRalEntry(entries, basePrice = 0) {
      const group = this.getRalProductGroup();
      const pricedEntries = entries
        .map(entry => ({
          entry,
          totalCost: this.getRalEntryTotalCost(entry, basePrice, group),
        }))
        .filter(candidate => candidate.totalCost !== null);

      if (!pricedEntries.length) {
        return entries[0] || null;
      }

      return pricedEntries.reduce((cheapest, candidate) => (
        candidate.totalCost < cheapest.totalCost ? candidate : cheapest
      )).entry;
    },
    applyRalEntry(entry, { updateRalCode = false, updateGloss = false } = {}) {
      if (updateRalCode && entry) {
        const ralField = this.$refs.dynamicContent?.querySelector('.rn_value');
        if (ralField) ralField.value = String(entry?.ral_code || '').trim();
      }

      const entryGloss = entry?.glanzgrad || entry?.oberflaeche;
      if (updateGloss && entryGloss) {
        const glossField = this.getRalGlossField();
        const normalizedGloss = this.normalizeRalGloss(entryGloss);
        const option = Array.from(glossField?.options || []).find(candidate => (
          this.normalizeRalGloss(this.getSelectOptionDisplayText(candidate) || candidate.value) === normalizedGloss
        ));
        if (option) glossField.value = option.value;
      }

      this.selectedRalHex = entry?.hex || null;
      this.applyRalColorName(entry);
      this.applyRalSwatch(this.selectedRalHex);
      return entry || null;
    },
    handleRalLookupFieldChange(event) {
      if (!this.isRalNachWahlSelected()) return;

      const field = event?.target;
      if (field === this.getPowderNumberField()) {
        this.ralLookupPowderOverride = true;
        const powderNumber = String(field.value || '').trim().toLowerCase();
        if (!powderNumber) {
          return;
        }

        const candidates = (this.ralFarben || []).filter(entry => (
          String(entry.herstellerartikelnummer || '').trim().toLowerCase() === powderNumber
        ));
        const entry = this.pickPreferredRalEntry(candidates);
        this.applyRalEntry(entry, {
          updateRalCode: true,
          updateGloss: true,
        });
        return;
      }

      if (field?.classList?.contains('rn_value') || field === this.getRalGlossField()) {
        this.ralLookupPowderOverride = false;
        this.applyRalEntry(this.getMatchingRalEntry());
      }
    },
    shouldUsePowderLookup(ralCode = this.getSelectedRalCode(), powderNumber = this.getVisiblePowderNumber()) {
      return Boolean(powderNumber && (this.ralLookupPowderOverride || !ralCode));
    },
    getMatchingRalEntry(basePrice = 0) {
      if (!this.isRalNachWahlSelected()) return null;
      const ralCode = this.getSelectedRalCode();
      const powderNumber = this.getVisiblePowderNumber().toLowerCase();
      const usePowderLookup = this.shouldUsePowderLookup(ralCode, powderNumber);

      if (usePowderLookup) {
        let candidates = (this.ralFarben || []).filter(entry => (
          String(entry.herstellerartikelnummer || '').trim().toLowerCase() === powderNumber
        ));

        // Wurde zusätzlich eine RAL-Nummer gewählt, müssen weiterhin alle
        // Angaben gemeinsam zum Datensatz passen. Ohne RAL-Nummer reicht die
        // eindeutige Pulvernummer als Suchschlüssel aus.
        if (ralCode) {
          const normalizedCode = this.normalizeRalCode(ralCode);
          candidates = candidates.filter(color => (
            this.normalizeRalCode(color.ral_code) === normalizedCode
            && this.ralEntryMatchesGloss(color)
          ));
        }

        return this.pickPreferredRalEntry(candidates, basePrice);
      }

      if (!ralCode) return null;

      const normalizedCode = this.normalizeRalCode(ralCode);
      const candidates = (this.ralFarben || []).filter(color => (
        this.normalizeRalCode(color.ral_code) === normalizedCode
        && this.ralEntryMatchesGloss(color)
      ));

      return this.pickPreferredRalEntry(candidates, basePrice);
    },
    parseRalAmount(rawValue) {
      const match = String(rawValue || '').trim().match(/-?[0-9]+(?:[.,][0-9]+)?/);
      if (!match) return null;
      const value = Number(match[0].replace(',', '.'));
      return Number.isFinite(value) && value >= 0 ? value : null;
    },
    getRalEntrySurcharge(entry, basePrice, group = this.getRalProductGroup()) {
      const raw = String(entry?.[`preisklasse_${group}`] || '').trim();
      const powderFee = this.parseRalAmount(entry?.[`pulverpauschale_${group}`]);
      if (!raw) {
        return powderFee !== null ? 0 : null;
      }

      const lower = raw.toLowerCase();
      if (lower.includes('standard')) {
        return 0;
      }
      if (lower.includes('anfrage')) {
        return powderFee !== null ? 0 : null;
      }

      const normalizedBasePrice = Number.isFinite(Number(basePrice)) ? Number(basePrice) : 0;
      let surcharge = 0;
      let hasCalculatedPrice = false;

      const percentMatch = lower.match(/([0-9]+(?:[.,][0-9]+)?)\s*%/);
      if (percentMatch) {
        surcharge += normalizedBasePrice * (parseFloat(percentMatch[1].replace(',', '.')) / 100);
        hasCalculatedPrice = true;
      } else {
        // Die Farbdatei liefert prozentuale Aufpreise teilweise als Faktor:
        // "0.35" bedeutet +35 %, "0.45" entsprechend +45 %.
        const factorMatch = lower.match(/^\s*([0-9]+(?:[.,][0-9]+)?)\s*$/);
        if (factorMatch) {
          surcharge += normalizedBasePrice * parseFloat(factorMatch[1].replace(',', '.'));
          hasCalculatedPrice = true;
        }
      }

      const plusMatch = lower.match(/\+\s*([0-9]+(?:[.,][0-9]+)?)/);
      const euroFallback = !plusMatch ? lower.match(/([0-9]+(?:[.,][0-9]+)?)\s*€/u) : null;
      const plusSource = plusMatch || euroFallback;
      if (plusSource) {
        surcharge += parseFloat(plusSource[1].replace(',', '.'));
        hasCalculatedPrice = true;
      }

      return hasCalculatedPrice ? surcharge : null;
    },
    getRalEntryTotalCost(entry, basePrice, group = this.getRalProductGroup()) {
      const surcharge = this.getRalEntrySurcharge(entry, basePrice, group);
      if (surcharge === null) {
        return null;
      }

      const powderFee = this.parseRalAmount(entry?.[`pulverpauschale_${group}`]) || 0;
      return surcharge + powderFee;
    },
    updateSelectedRalSwatch(entry = this.getMatchingRalEntry()) {
      return this.applyRalEntry(entry);
    },
    
    applyRalSurcharge(basePrice) {
      const ralCode = this.getSelectedRalCode();
      const powderNumber = this.getVisiblePowderNumber();
      const hasRalLookupValue = Boolean(ralCode || powderNumber);

      if (!hasRalLookupValue) {
        this.currentRalPricing = null;
        this.selectedRalHex = null;
        this.applyRalColorName(null);
        this.applyRalSwatch(null);
        return true;
      }

      if (!Array.isArray(this.ralFarben) || this.ralFarben.length === 0) {
        this.currentRalPricing = null;
        this.selectedRalHex = null;
        this.applyRalColorName(null);
        this.applyRalSwatch(null);
        this.price = 0;
        return false;
      }

      const entry = this.getMatchingRalEntry(basePrice);
      this.updateSelectedRalSwatch(entry);
      // Eine selbst angegebene Pulvernummer wird immer individuell angefragt.
      // Die automatisch gefundene Standardnummer bleibt nur in ralPricing.
      if (powderNumber || !entry) {
        this.currentRalPricing = null;
        this.price = 0;
        return false;
      }

      const group = this.getRalProductGroup();
      const powderFee = this.parseRalAmount(entry[`pulverpauschale_${group}`]);
      const surcharge = this.getRalEntrySurcharge(entry, basePrice, group);
      if (surcharge === null) {
        this.currentRalPricing = null;
        this.price = 0;
        return false;
      }

      this.currentRalPricing = {
        key: [group, entry.herstellerartikelnummer, this.normalizeRalCode(entry.ral_code)]
          .map(value => String(value || '').trim().toLowerCase())
          .join('|'),
        productGroup: group,
        ralCode: this.normalizeRalCode(entry.ral_code),
        manufacturerArticleNumber: String(entry.herstellerartikelnummer || '').trim(),
        powderFee,
      };
    
      if (surcharge !== 0) {
        this.price += surcharge;
      }
    
      return true;
    },

    applyRalSwatch(hex) {
      const field = this.$refs.dynamicContent?.querySelector('.rn_value');
      if (!field) return;
      this.ensureRalColorNameFields();
      const container = field.closest('.input-container');
      const swatchField = container?.querySelector('.ral-show-color');
      const colorNameField = container?.querySelector('.ral-color-name-value');
      if (colorNameField) {
        colorNameField.style.backgroundImage = '';
        colorNameField.style.backgroundClip = '';
      }
      if (!swatchField) return;

      if (hex) {
        swatchField.style.backgroundColor = hex;
      } else {
        swatchField.style.backgroundColor = '';
      }
    },

    isTemporaryRalPriceRequestArticle() {
      return TEMPORARY_RAL_PRICE_REQUEST_ARTICLE_IDS.has(Number(this.selectedArticle));
    },
    isRalNachWahlSelected() {
      const root = this.$refs.dynamicContent;
      if (!root) return false;

      return Array.from(root.querySelectorAll('select.select')).some(select => {
        const step = select.closest('[id^="s_"]');
        if (step && this.isStepHidden(step)) return false;

        const label = this.getConfiguratorFieldLabel(select);
        if (!label.includes('oberfläche') && !label.includes('oberflaeche')) {
          return false;
        }

        const selectedOption = this.getSelectedOption(select);
        const selectedValue = (selectedOption?.value || select.value || '').toString().trim();
        const selectedText = this.getSelectOptionText(selectedOption);

        return selectedValue === RAL_NACH_WAHL_OPTION_VALUE
          || selectedText.includes('ral nach wahl');
      });
    },
    shouldUseTemporaryRalPriceRequest() {
      return this.isTemporaryRalPriceRequestArticle() && this.isRalNachWahlSelected();
    },
    getAccessoryElement() {
      const keyword = this.getSelectedArticleKeyword().toLowerCase();
      return Array.from(this.$refs.dynamicContent?.querySelectorAll('[data-accessory-price]') || [])
        .find(element => element.dataset.accessoryKeyword?.toLowerCase() === keyword) || null;
    },
    validateAccessoryLength(showRequired = false) {
      const input = this.getAccessoryElement()?.querySelector('.accessory_length_value');
      if (!input) return true;

      const raw = input.value.trim();
      const value = Number(raw.replace(',', '.'));
      const valid = /^(?:\d+(?:[.,]\d+)?|[.,]\d+)$/.test(raw) && Number.isFinite(value) && value > 0;
      const showError = !valid && (showRequired || raw !== '');
      input.classList.toggle('input-error', showError);
      input.setAttribute('aria-invalid', String(showError));
      input.closest('.input-container')?.querySelector('.error-tooltip-container')
        ?.classList.toggle('hidden-visibility', !showError);
      return valid;
    },
    calculateAccessoryPrice(accessory) {
      if (!this.validateAccessoryLength()) return 0;
      const lengthInput = accessory.querySelector('.accessory_length_value');
      const length = lengthInput ? Number(lengthInput.value.trim().replace(',', '.')) : 1;
      const unitPrice = Number(accessory.dataset.accessoryPrice);
      const surface = this.$refs.dynamicContent.querySelector('.accessory_surface_value');
      const surcharge = Number(this.getSelectedOption(surface)?.dataset.accessorySurcharge || 0);
      const price = unitPrice * length * (1 + surcharge / 100);
      return Number.isFinite(price) ? Math.round((price + Number.EPSILON) * 100) / 100 : 0;
    },
    async calculatePriceFromScratch() {
      // this.addedItems = [];
      this.price = 0.0;
      this.currentRalPricing = null;
      this.priceListPriceElements = [];
      this.clearRasterDimensionErrors();
      let xInputElement = null;
      let yInputElement = null;
      let valueX = null;
      let valueY = null;
      // Bei Stulp werden hier beide Listenpreise draufgerechnet.
      // Später für die Berechnung von Typ 1 (% - Berechnungen)
      let summedListPrice = 0.0;
      
      try {
        // Eingaben überprüfen und Steps ausschalten
        this.calculatePendelAuflagen();
        this.updateStulpBrushProfileDefaults();
        this.filterStepsByStepRules();
        if (!this.validateIndependentWingWidths() || !this.validateConfiguredDimensionLimits() || !this.validateKaempferMasse() || !this.validateGangfluegelBreite()) {
          return;
        }
        const accessory = this.getAccessoryElement();
        if (accessory) {
          this.currentRalPricing = null;
          // Die RAL-Felder müssen nach einer geänderten Oberflächenauswahl sichtbar sein.
          await this.$nextTick();
          // RAL-Stammdaten wie bei Beschlägen anzeigen, ohne deren Farbkosten zu übernehmen.
          this.updateSelectedRalSwatch();
          this.price = this.getVisiblePowderNumber() ? 0 : this.calculateAccessoryPrice(accessory);
          return;
        }
        if (this.shouldUseTemporaryRalPriceRequest()) {
          this.updateSelectedRalSwatch();
          this.price = 0;
          return;
        }
        
        // Maße
        if (this.filteredStepItems.length > 0) {
          let priceFilteredStepItem = this.filteredStepItems[0];
          if (this.filteredStepItems[0].name === 'Lichtes Maß') {
            // Den Maßschritt verwenden, auch wenn Auflagen zwischen LM und ZAM stehen.
            priceFilteredStepItem = this.filteredStepItems.slice(1).find(step => {
              const element = this.$refs.dynamicContent?.querySelector(`#s_${step.id}`);
              return element?.querySelector('.x_value') && element?.querySelector('.y_value');
            }) || this.filteredStepItems[1];
          }
          else if (this.filteredStepItems[0].name === 'RAM Maß') { 
            // ZAM Maß
            priceFilteredStepItem = this.filteredStepItems[1];
          }
          var filteredStepItemElement = document.getElementById("s_"+priceFilteredStepItem.id);
          if (filteredStepItemElement != null) {
            let parentElement = document.getElementById("s_"+priceFilteredStepItem.id);
            // this.price = await this.getPriceListPriceValue(parentElement);
            const priceDimensions = this.getPriceDimensionElements(parentElement);
            xInputElement = priceDimensions.xInputElement;
            yInputElement = priceDimensions.yInputElement;
            const priceDimensionOptions = { aggregateYInputs: priceDimensions.aggregateYInputs };
            const parentForFValues = parentElement?.parentElement || parentElement;
            const fLeftElement = parentForFValues ? parentForFValues.querySelector(".f_l_value") : null;
            const fRightElement = parentForFValues ? parentForFValues.querySelector(".f_r_value") : null;
            const hasLeft = fLeftElement && (fLeftElement.value ?? '').toString().trim() != '';
            const hasRight = fRightElement && (fRightElement.value ?? '').toString().trim() != '';
            const gangfluegel = this.$refs.dynamicContent?.querySelector('[data-price-wing-split]');

            if (gangfluegel && xInputElement && yInputElement) {
              const totalWidth = this.getNumericInputValue(xInputElement);
              if (totalWidth === null) return;
              const gangWidth = this.getNumericInputValue(gangfluegel) ?? totalWidth / 2;
              for (const widthValue of [gangWidth, totalWidth - gangWidth]) {
                this.priceListPriceElements.push({
                  priceListPrice: await this.getPriceListPriceValue(gangfluegel, yInputElement, {
                    ...priceDimensionOptions,
                    widthValue,
                  }),
                  xField: gangfluegel,
                  yField: yInputElement,
                });
              }
            } else if (hasLeft && hasRight) {
              this.priceListPriceElements.push({
                priceListPrice: await this.getPriceListPriceValue(fLeftElement, yInputElement, priceDimensionOptions),
                xField: fLeftElement,
                yField: yInputElement
              });
              this.priceListPriceElements.push({
                priceListPrice: await this.getPriceListPriceValue(fRightElement, yInputElement, priceDimensionOptions),
                xField: fRightElement,
                yField: yInputElement
              });
            } else if (xInputElement && yInputElement) {
              this.priceListPriceElements.push({
                priceListPrice: await this.getPriceListPriceValue(xInputElement, yInputElement, priceDimensionOptions),
                xField: xInputElement,
                yField: yInputElement
              });
            }
          }
          if (this.rasterDimensionError) {
            this.price = 0;
            return;
          }
          for (let i = 0; i < this.priceListPriceElements.length; ++i) {
            this.price += this.priceListPriceElements[i].priceListPrice;
            summedListPrice += this.priceListPriceElements[i].priceListPrice;
          }

          // XL-Aufpreise müssen bereits im summedListPrice enthalten sein,
          // damit prozentuale Aufpreise (Typ 1) korrekt darauf aufbauen.
          let xlExtraCharge = 0.0;
          for (let i = 0; i < this.filteredExtraChargeItems.length; ++i) {
            const extraChargeItem = this.filteredExtraChargeItems[i];
            if (extraChargeItem.name.includes('XL') && this.isXLVariant) {
              const parsed = Number(extraChargeItem.inhalt);
              if (!isNaN(parsed)) {
                xlExtraCharge += parsed;
              }
            }
          }
          if (xlExtraCharge !== 0) {
            this.price += xlExtraCharge;
            summedListPrice += xlExtraCharge;
          }

          // Vorlauf: alle Aufpreise vom Typ 9999 addieren, damit prozentuale Aufpreise die korrekte Basis haben.
          for (let i = 1; i < this.stepLists.length; ++i) {
            var preStepDiv = document.getElementById("s_" + this.stepLists[i].id);
            if (preStepDiv!= null && this.isStepHidden(preStepDiv) && !preStepDiv.querySelector(".hidden_price")) {
              continue;
            }

            // feste Aufpreise, die direkt an den Step gebunden sind
            let preSelectedStepPrice = null;
            for (let k = 0; k < this.stepPrices.length; ++k) {
              if (this.stepPrices[k].schritt_id == this.stepLists[i].id) {
                preSelectedStepPrice = this.stepPrices[k];
                break;
              }
            }
            var preChargePrice = null;
            if (preSelectedStepPrice != null) {
              for (let j = 0; j < this.chargePrices.length; ++j) {
                if (this.chargePrices[j].id == preSelectedStepPrice.aufpreis_id) {
                  preChargePrice = this.chargePrices[j];
                  break;
                }
              }
            }
            if (preChargePrice != null && preChargePrice.type == 9999) {
              var preExtraElement = preStepDiv ? preStepDiv.querySelector(".extra") : null;
              var preHiddenPrice = preStepDiv ? preStepDiv.querySelector(".hidden_price") : null;
              if (preExtraElement != null && preExtraElement.checked) {
                const addVal = Number(preChargePrice.inhalt);
                if (!isNaN(addVal)) {
                  this.price += addVal;
                  summedListPrice += addVal;
                }
              } else if (preHiddenPrice != null) {
                const addVal = Number(preChargePrice.inhalt);
                if (!isNaN(addVal)) {
                  this.price += addVal;
                  summedListPrice += addVal;
                }
              }
            }

            // Select-gebundene Aufpreise vom Typ 9999
            if (preStepDiv != null) {
              var preSelectElement = preStepDiv.querySelector(".select");
              if (preSelectElement != null && !preSelectElement.matches('.gr_value')) {
                var preSelectedElement = this.getSelectChargePriceId(preSelectElement);
                var preSelectChargePrice = null;
                for (let j = 0; j < this.chargePrices.length; ++j) {
                  if (String(this.chargePrices[j].id) === String(preSelectedElement)) {
                    preSelectChargePrice = this.chargePrices[j];
                    break;
                  }
                }
                if (preSelectChargePrice != null && preSelectChargePrice.type == 9999) {
                  const addVal = Number(preSelectChargePrice.inhalt);
                  if (!isNaN(addVal)) {
                    this.price += addVal;
                    summedListPrice += addVal;
                  }
                }
              }
            }
          }

          const continueRal = this.applyRalSurcharge(summedListPrice);
          if (continueRal === false) {
            return;
          }

          for (let i = 1; i < this.stepLists.length; ++i) {
            // Überprüfung ob ein Textfeld mit der Klasse .no_price_value numerisch gefüllt ist
            var stepDiv = document.getElementById("s_" + this.stepLists[i].id);
            if (this.hasVisibleNoPriceValue(stepDiv)) {
              this.price = 0;
              return;
            }
            this.selectedStepId = this.stepLists[i].id;
            let selectedStepPrice = null;
            for (let k = 0; k < this.stepPrices.length; ++k) {
              // Ist es die gleiche Step Id, dann ist dies der Preis dazu
              if (this.stepPrices[k].schritt_id == this.selectedStepId) {
                selectedStepPrice = this.stepPrices[k];
                break;
              }
            }
            var chargePrice = null;
            // Aufpreise herausfinden. Bislang nur ein Aufpreis möglich
            if (selectedStepPrice != null) {
              for (let j = 0; j < this.chargePrices.length; ++j) {
                if (this.chargePrices[j].id == selectedStepPrice.aufpreis_id) {
                  chargePrice = this.chargePrices[j];
                  break;
                }
              }
            }
            if (chargePrice != null) {
              stepDiv = document.getElementById("s_"+this.selectedStepId);
              if (stepDiv != null) {
                var valueElement = stepDiv.querySelector(".value");
                var extraElement = stepDiv.querySelector(".extra");
                var hiddenPrice = stepDiv.querySelector(".hidden_price");
                // Einfaches InputFeld
                if (valueElement != null) {
                  // var value = valueElement.value;
                  // Typ 3 ist mit der Zahl aus dem Value Feld zu multiplizieren
                  // if (selectedStepPrice.regel_type == 3) {
                  //   if (valueElement.value.trim() !== '' && !isNaN(Number(valueElement.value))) {
                  //    this.price += Number(chargePrice.inhalt) * Number(valueElement.value)
                  //   }
                  // }
                }
                // Checkbox Aufpreise werden hier überprüft
                else if (extraElement != null) {
                  if(extraElement.checked){
                    if (chargePrice.type == 0) {
                      this.price += Number(chargePrice.inhalt);
                    } 
                    else if (chargePrice.type == 1) {
                      this.price += summedListPrice * Number(chargePrice.inhalt) / 100.0;
                    } 
                  }
                }
                else if(hiddenPrice != null) {
                  if (chargePrice.type == 0) {
                    this.price += Number(chargePrice.inhalt);
                  } 
                  else if (chargePrice.type == 1) {
                    this.price += summedListPrice * Number(chargePrice.inhalt) / 100.0;
                  } 
                }
              }
            }
            // Hier handelt es sich um eine Selectbox die mit einem anderen Teil des Codes verknüpft ist
            else {
              var selectChargePrice = null;
              var stepDivElse = document.getElementById("s_"+this.selectedStepId);
              if (this.isStepHidden(stepDivElse)) {
                continue;
              }
              if (stepDivElse != null) {
                var selectElement = stepDivElse.querySelector(".select");
                if (selectElement != null) {
                  // Wenn es SMass ist soll ebenfalls weiter gegangen werden, da die values nicht ids von Aufpreisen sind
                  if (selectElement.matches('.gr_value')) {
                    continue;
                  }
                  var selectedElement = this.getSelectChargePriceId(selectElement);
                  // Preis auf Anfrage, wenn Value auf -1, eine weitere Berechnung ist nicht notwendig
                  const selectedElementNumber = Number(selectedElement);
                  if (!isNaN(selectedElementNumber) && selectedElementNumber < 0.0) {
                    this.price = 0;
                    return;
                  }
                  // Durch die Aufpreise gehen
                  for (let j = 0; j < this.chargePrices.length; ++j) {
                    if (String(this.chargePrices[j].id) === String(selectedElement)) {
                      selectChargePrice = this.chargePrices[j];
                      break;
                    }
                  }
                }
                if (selectChargePrice != null) {
                  const parseGewebeObenUntenAufpreis = (inhalt) => {
                    const parts = String(inhalt).split(";").map(part => part.trim());
                    const fieldClasses = parts.length >= 5
                      ? parts.slice(1, 4)
                      : (parts[1] || "").split("/");

                    return {
                      stepIds: (parts[0] || "").split("/").map(stepId => stepId.trim()),
                      fieldClasses,
                      basePrice: Number(parts.length >= 5 ? parts[4] : parts[2])
                    };
                  };

                  const getNumericInputValue = (inputElement) => {
                    const rawValue = inputElement ? inputElement.value.trim() : "";
                    const numericValue = Number(rawValue.replace(",", "."));

                    return rawValue !== "" && !isNaN(numericValue) ? numericValue : null;
                  };

                  const getGewebeObenUntenStepValue = (stepId, fieldClass) => {
                    const stepElement = document.getElementById("s_" + stepId);
                    const normalizedFieldClass = String(fieldClass || "").trim().replace(/^\./, "");
                    const fieldElement = stepElement && normalizedFieldClass
                      ? stepElement.querySelector("." + normalizedFieldClass)
                      : null;

                    return getNumericInputValue(this.getPriceWidthInput(fieldElement));
                  };

                  const getGewebeObenUntenGesamthoehe = (gewebeObenUntenAufpreis) => {
                    const totalHeightValue = getGewebeObenUntenStepValue(
                      gewebeObenUntenAufpreis.stepIds[1],
                      gewebeObenUntenAufpreis.fieldClasses[1]
                    );

                    return totalHeightValue !== null ? totalHeightValue : getNumericInputValue(yInputElement);
                  };

                  const getGewebeObenUntenTeilungshoehe = (gewebeObenUntenAufpreis) => {
                    const totalHeightValue = getGewebeObenUntenGesamthoehe(gewebeObenUntenAufpreis);
                    if (Number(gewebeObenUntenAufpreis.stepIds[2]) === 0) {
                      return totalHeightValue !== null ? totalHeightValue / 2.0 : null;
                    }

                    const teilungshoeheValue = getGewebeObenUntenStepValue(
                      gewebeObenUntenAufpreis.stepIds[2],
                      gewebeObenUntenAufpreis.fieldClasses[2]
                    );

                    return teilungshoeheValue !== null
                      ? teilungshoeheValue
                      : (totalHeightValue !== null ? totalHeightValue / 2.0 : null);
                  };

                  // Type 3 ist Quadratmeter und wird mit einem anderen Step verglichen
                  if (selectChargePrice.type == 0) {
                    this.price += Number(selectChargePrice.inhalt);
                  }
                  else if (selectChargePrice.type == 1) {
                    this.price += summedListPrice * Number(selectChargePrice.inhalt) / 100.0; 
                  }
                  else if (selectChargePrice.type == 3) {
                    var splittedString = selectChargePrice.inhalt.split(";");
                    if (xInputElement != null && yInputElement != null) {
                      valueX = xInputElement;
                      valueY = yInputElement;
                      if (valueX.value.trim() !== '' && !isNaN(Number(valueX.value))
                      && valueY.value.trim() !== '' && !isNaN(Number(valueY.value))) {
                        this.price += Number(valueX.value) / 1000.0 * Number(valueY.value) / 1000.0 * Number(splittedString[3]); 
                      }
                    }
                  }
                  else if(selectChargePrice.type == 5) {
                    if (xInputElement != null && yInputElement != null) {
                      valueX = xInputElement;
                      valueY = yInputElement;

                      const [baseStr, yCountStr, xCountStr] = String(selectChargePrice.inhalt).split(";");
                      const basePrice = Number(baseStr);
                      const yCount = Number(yCountStr || 0);
                      const xCount = Number(xCountStr || 0);

                      const hasY = valueY.value.trim() !== '' && !isNaN(Number(valueY.value));
                      const hasX = valueX.value.trim() !== '' && !isNaN(Number(valueX.value));

                      if (!isNaN(basePrice) && (hasY || hasX)) {
                        const heightMeters = hasY ? Number(valueY.value) / 1000.0 : 0;
                        const widthMeters = hasX ? Number(valueX.value) / 1000.0 : 0;
                        const totalLength = (yCount * heightMeters) + (xCount * widthMeters);
                        this.price += totalLength * basePrice;
                      }
                    }
                  }
                  // Sonderfall Gewebe oben
                  // x_value von id1 * (y_value id2 - Griffkämpferhöhe von unten)
                  else if(selectChargePrice.type == 8888) {
                    const gewebeObenUntenAufpreis = parseGewebeObenUntenAufpreis(selectChargePrice.inhalt);
                    const widthValue = getGewebeObenUntenStepValue(
                      gewebeObenUntenAufpreis.stepIds[0],
                      gewebeObenUntenAufpreis.fieldClasses[0]
                    );
                    const totalHeightValue = getGewebeObenUntenGesamthoehe(gewebeObenUntenAufpreis);
                    const lowerHeightValue = getGewebeObenUntenTeilungshoehe(gewebeObenUntenAufpreis);

                    if (!isNaN(gewebeObenUntenAufpreis.basePrice) && widthValue !== null && totalHeightValue !== null && lowerHeightValue !== null) {
                      if (lowerHeightValue < 0 || lowerHeightValue > totalHeightValue) {
                        this.price = 0;
                        return;
                      }

                      const widthMeters = widthValue / 1000.0;
                      const heightMeters = Math.max(totalHeightValue - lowerHeightValue, 0) / 1000.0;

                      this.price += widthMeters * heightMeters * gewebeObenUntenAufpreis.basePrice;
                    }

                  }
                  // Sonderfall Gewebe unten
                  // x_value von id1 * Griffkämpferhöhe von unten
                  else if (selectChargePrice.type == 8889) {
                    const gewebeObenUntenAufpreis = parseGewebeObenUntenAufpreis(selectChargePrice.inhalt);
                    const widthValue = getGewebeObenUntenStepValue(
                      gewebeObenUntenAufpreis.stepIds[0],
                      gewebeObenUntenAufpreis.fieldClasses[0]
                    );
                    const totalHeightValue = getGewebeObenUntenGesamthoehe(gewebeObenUntenAufpreis);
                    const lowerHeightValue = getGewebeObenUntenTeilungshoehe(gewebeObenUntenAufpreis);

                    if (!isNaN(gewebeObenUntenAufpreis.basePrice) && widthValue !== null && totalHeightValue !== null && lowerHeightValue !== null) {
                      if (lowerHeightValue < 0 || lowerHeightValue > totalHeightValue) {
                        this.price = 0;
                        return;
                      }

                      const widthMeters = widthValue / 1000.0;
                      const heightMeters = Math.max(lowerHeightValue, 0) / 1000.0;

                      this.price += widthMeters * heightMeters * gewebeObenUntenAufpreis.basePrice;
                    }

                  }
                }
              }
            }
          }

          // Extra Aufpreise die nicht in Steps stehen
          // for (let i = 0; i < this.filteredExtraChargeItems.length; ++i) {
          //   const extraChargeItem = this.filteredExtraChargeItems[i];
          //   // XL-Variante wird oben bereits zu summedListPrice hinzugefügt
          //   if (extraChargeItem.name.includes('XL') && this.isXLVariant) {
          //     continue;
          //   }
          // }

          setTimeout(() => this.setKaempferVisibilityXLVersion(), 1000);
        }
      } catch (error) {
        console.error('Fehler bei calculatePriceFromScratch:', error);
        // Fallback: Setze Preis auf "Preis auf Anfrage"
        this.price = 0;
      }
    },
    refreshPriceList() {
      this.updatePlisseeRailNotice();
      this.schedulePriceCalc('refresh');
      this.refreshConfiguredArticle();
      this.debouncedImageLoad();
    },
    debouncedImageLoad() {
      if (this.imageLoadDebounce) {
        clearTimeout(this.imageLoadDebounce);
      }
      
      this.imageLoadDebounce = setTimeout(() => {
        this.loadImagesForArticleIfNeeded();
      }, 500); // 500ms debounce für Bilder
    },
    // Safe version of price calculation that prevents race conditions
    async calculatePriceFromScratchSafe() {
      try {
        while (this.isCalculatingPrice) {
          await new Promise(resolve => setTimeout(resolve, 50));
        }
        
        this.isCalculatingPrice = true;       

        await this.calculatePriceFromScratch();
      } catch (error) {
        console.error('Fehler bei der Preisberechnung:', error);
      } finally {
        this.isCalculatingPrice = false;
      }
    },
    async loadImagesForArticleIfNeeded() {
      if (!this.selectedArticle) return;
      
      // Aktuelle Konfiguration erstellen
      const currentConfig = this.getCurrentImageConfig();
      
      // Vergleiche mit letzter Konfiguration
      if (this.lastImageLoadConfig && 
          JSON.stringify(currentConfig) === JSON.stringify(this.lastImageLoadConfig)) {
        return; // Keine Änderung, keine neuen Bilder laden
      }
      
      // Speichere aktuelle Konfiguration und lade Bilder
      this.lastImageLoadConfig = currentConfig;
      await this.loadImagesForArticle();
    },
    getCurrentImageConfig() {
      const filteredStepListItems = this.filteredStepItems;
      let kaempferRechts = false;
      let kaempferHoehe = false;
      let kaempferWaagerecht = false;
      let kaempferSenkrecht = false;
      
      // Kämpfer-Status ermitteln
      for (let i = 0; i < filteredStepListItems.length; ++i) {
        if (filteredStepListItems[i].id == 37 && !filteredStepListItems[i].isHiddenByRule) {
          kaempferRechts = true;
        }
        if (filteredStepListItems[i].id == 38 && !filteredStepListItems[i].isHiddenByRule) {
          kaempferHoehe = true;
        }
      }
      
      // XL-Checkbox-Status ermitteln
      if (this.$refs.dynamicContent) {
        const allCheckboxes = this.$refs.dynamicContent.querySelectorAll('input[type="checkbox"]');
        allCheckboxes.forEach(checkbox => {
          const checkboxClasses = Array.from(checkbox.classList);
          const isXLCheckbox = checkboxClasses.some(cls => cls.toLowerCase().includes('xl'));
          
          if (isXLCheckbox && checkbox.checked) {
            const parentStep = checkbox.closest('[id^="s_"]');
            if (parentStep) {
              const stepId = parentStep.id.replace('s_', '');
              if (stepId == '37') kaempferWaagerecht = true;
              if (stepId == '38') kaempferSenkrecht = true;
            }
          }
        });
      }
      
      return {
        articleId: this.selectedArticle,
        articleName: this.selectedArticleName,
        kaempferRechts,
        kaempferHoehe,
        kaempferWaagerecht,
        kaempferSenkrecht,
        priorityFolders: this.buildPriorityParam(),
        isXLVariant: this.isXLVariant
      };
    },
    calculateSMASSInput() {
      this.calculateSMASS(true);
    },
    calculateSMASSSelectBox() {
      this.calculateSMASS();
    },
    calculateSMASS(isInputTypeIn = false) {
      const smVField = this.$refs.dynamicContent.querySelectorAll('.sm_value');
      const smkVField = this.$refs.dynamicContent.querySelectorAll('.smk_value');
      const smkDifField = this.$refs.dynamicContent.querySelectorAll('.dif');
      const gr1Field = this.$refs.dynamicContent.querySelectorAll('.gr1');
      const gr2Field = this.$refs.dynamicContent.querySelectorAll('.gr2');
      const gr3Field = this.$refs.dynamicContent.querySelectorAll('.gr3');
      const gr4Field = this.$refs.dynamicContent.querySelectorAll('.gr4');
      const famVField = this.$refs.dynamicContent.querySelectorAll('.fam_value');
      const grVSelect = this.$refs.dynamicContent.querySelectorAll('.gr_value');

      if (smVField.length > 0) {
        const smkDifValue = parseFloat(smkDifField[0].innerHTML);
        const groessenText = grVSelect[0].options[grVSelect[0].selectedIndex].text;
        const smValue = parseFloat(smVField[0].value);
        let groessenValue = parseFloat(grVSelect[0].value);

        // Helper to parse the semicolon separated min/switch/max triplets
        const parseGroupValues = (fieldRef) => {
          if (fieldRef.length === 0) return [];
          const content = fieldRef[0].innerHTML || fieldRef[0].textContent || '';
          if (content.trim() === '') return [];
          return content
            .split(';')
            .map(val => parseFloat(val.trim()))
            .filter(val => !isNaN(val));
        };

        const gr1Values = parseGroupValues(gr1Field);
        const gr2Values = parseGroupValues(gr2Field);
        const gr3Values = parseGroupValues(gr3Field);
        const gr4Values = parseGroupValues(gr4Field);

        // Falls keinerlei Werte vorliegen, kann keine Berechnung erfolgen
        if (
          gr1Values.length === 0 &&
          gr2Values.length === 0 &&
          gr3Values.length === 0 &&
          gr4Values.length === 0
        ) {
          return;
        }

        let actualMin = null;
        let actualMax = null; 
        let actualSwitch = null;

        if (groessenText.includes("1") && gr1Values.length >= 3) {
          actualMin = gr1Values[0];
          actualSwitch = gr1Values[1];
          actualMax = gr1Values[2];
        } else if (groessenText.includes("2") && gr2Values.length >= 3) {
          actualMin = gr2Values[0];
          actualSwitch = gr2Values[1];
          actualMax = gr2Values[2];
        } else if (groessenText.includes("3") && gr3Values.length >= 3) {
          actualMin = gr3Values[0];
          actualSwitch = gr3Values[1];
          actualMax = gr3Values[2];
        } else if (groessenText.includes("4") && gr4Values.length >= 3) {
          actualMin = gr4Values[0];
          actualSwitch = gr4Values[1];
          actualMax = gr4Values[2];
        }

        const firstAvailableMin = [gr1Values[0], gr2Values[0], gr3Values[0], gr4Values[0]]
        .find(val => typeof val === 'number' && !isNaN(val));
        
        // Referenz ist immer Gruppe 1
        if (Number.isFinite(smValue)) {
          // S-Maß (Klammer)
          smkVField[0].value = (smkDifValue + smValue);

          // FA-Maß: Gruppenwert minus (S - BasisMin)
          const fa = (groessenValue - (smkDifValue + smValue));
          famVField[0].value = Number.isFinite(fa) ? String(fa) : "";
        } else {
          famVField[0].value = "";
          smkVField[0].value = "";
          smVField[0].classList.add('input-error');
          return;
        }

        smVField[0].classList.remove('input-error');
        smVField[0].classList.remove('input-warning');

        // Eingabefeld pruefen ob über oder unter den Grenzen
        // Damit nicht angezeigt wird, dass actualMin nicht benutzt wird
        if (isInputTypeIn) {
            // Wenn das Input-Feld aktualisiert wird, soll die Abfrage erfolgen
            // und ggf geswitched werden
            const select = grVSelect[0];
            if (
              Number.isFinite(actualSwitch) && Number.isFinite(actualMax) &&
              (smValue >= actualSwitch || smValue > actualMax)
            ) {
              if (select && select.selectedIndex < select.options.length - 1) {
                  select.selectedIndex += 1;
                  groessenValue = parseFloat(select.value)
                  if (!isNaN(smValue)) {
                    smkVField[0].value = (smkDifValue + smValue);
                    famVField[0].value = (groessenValue - (smkDifValue + smValue));
                    this.calculateSMASS(true);
                    return;
                  }
              }              
            }

            if (Number.isFinite(actualMin) && smValue < actualMin && select.selectedIndex > 0) {
              select.selectedIndex -= 1;
              this.calculateSMASS(true);
              groessenValue = parseFloat(select.value)
              if (!isNaN(smValue)) {
                smkVField[0].value = (smkDifValue + smValue);
                famVField[0].value = (groessenValue - (smkDifValue + smValue));
                this.calculateSMASS(true);
                return;
              }
            }
        }

        if (Number.isFinite(firstAvailableMin) && Number.isFinite(actualMax)) {
          if (smValue < firstAvailableMin || smValue > actualMax) {
            smVField[0].classList.add('input-error');
          } else if (Number.isFinite(actualSwitch) && smValue >= actualSwitch) {
            // Auf Switch prüfen
            smVField[0].classList.add('input-warning');
          }
        }
      }
    },
    bindPendelAuflagenListeners() {
      const root = this.$refs.dynamicContent;
      root?.querySelectorAll('.pendel-auflage-value').forEach(input => {
        input.removeEventListener('input', this.calculateRAM);
        input.removeEventListener('change', this.calculateRAM);
        input.addEventListener('input', this.calculateRAM);
        input.addEventListener('change', this.calculateRAM);
      });
      this.calculatePendelAuflagen();
    },
    getPendelZamValue(kind) {
      const root = this.$refs.dynamicContent;
      const selectors = kind === 'B'
        ? ['.lm_b_value', '.auflage-links-value', '.auflage-rechts-value']
        : ['.lm_h_value', '.auflage-oben-value', '.auflage-unten-value'];
      const values = selectors.map(selector => this.getNumericInputValue(root?.querySelector(selector)));
      const additionElement = root?.querySelector(kind === 'B' ? '.rm_b_add_value' : '.rm_h_add_value');
      const addition = Number((additionElement?.textContent || additionElement?.value || '0').trim().replace(',', '.'));
      if (!values.every(value => value !== null) || !Number.isFinite(addition)) return null;

      return Number(this.formatDichtbandNumber(values.reduce((sum, value) => sum + value, addition)));
    },
    calculatePendelAuflagen() {
      const root = this.$refs.dynamicContent;
      const container = root?.querySelector('[data-pendel-auflagen]');
      if (!container) return false;

      const lmWidth = root.querySelector('.lm_b_value');
      const lmHeight = root.querySelector('.lm_h_value');
      const hasLM = [lmWidth, lmHeight].every(input => input?.value.trim());
      container.querySelectorAll('.pendel-auflage-value').forEach(input => {
        let value = this.getNumericInputValue(input);
        const max = Number(input.dataset.maxValue);
        if (value !== null && value > max && !input.classList.contains('auflage-unten-value')) {
          input.value = String(max);
          value = max;
        }
        const invalid = hasLM && input.value.trim() !== ''
          && (value === null || value < Number(input.dataset.minValue) || value > max);
        this.setDimensionInputError(input, invalid);
        if (!hasLM) input.classList.remove('input-error');
      });

      const dimensions = [
        ['B', '.rm_b_value'],
        ['H', '.rm_h_value'],
      ];
      dimensions.forEach(([kind, zamSelector]) => {
        const zam = root.querySelector(zamSelector);
        if (!zam) return;
        zam.readOnly = Boolean(hasLM || this.isSelectedProjectReadOnly);
        if (hasLM) {
          const value = this.getPendelZamValue(kind);
          zam.value = value !== null ? String(value) : '';
          zam.dataset.pendelCalculated = '1';
        } else if (zam.dataset.pendelCalculated === '1') {
          zam.value = '';
          delete zam.dataset.pendelCalculated;
          this.setDimensionInputError(zam, false);
          zam.classList.remove('input-error');
        }
      });
      this.filterStepsByStepRules();
      return true;
    },
    calculateRAM() {
      if (this.calculatePendelAuflagen()) {
        this.schedulePriceCalc('pendel-auflagen');
        return;
      }
      const lmb = this.$refs.dynamicContent.querySelector('.lm_b_value');
      const lmh = this.$refs.dynamicContent.querySelector('.lm_h_value');
      const rmb = this.$refs.dynamicContent.querySelector('.rm_b_value');
      const rmh = this.$refs.dynamicContent.querySelector('.rm_h_value');
      const rmbAdd = this.$refs.dynamicContent.querySelector('.rm_b_add_value');
      const rmhAdd = this.$refs.dynamicContent.querySelector('.rm_h_add_value');

      // --- BREITE ---
      if (lmb && rmb && rmbAdd) {
        const lmB = parseFloat(lmb.value);
        const addB = parseFloat((rmbAdd.textContent || rmbAdd.value || '').trim());
        const stdB = (!isNaN(lmB) && !isNaN(addB)) ? lmB + addB : null;

        this.ramBStandardValue = stdB;
        if (stdB != null) {
          rmb.value = String(stdB);                // überschreibt immer
          rmb.classList.remove('input-error', 'out-of-bounds-error');
          this.showRamDeviation({ kind: 'B', show: false });
        }
      }

      // --- HÖHE ---
      if (lmh && rmh && rmhAdd) {
        const lmH = parseFloat(lmh.value);
        const addH = parseFloat((rmhAdd.textContent || rmhAdd.value || '').trim());
        const stdH = (!isNaN(lmH) && !isNaN(addH)) ? lmH + addH : null;

        this.ramHStandardValue = stdH;
        if (stdH != null) {
          rmh.value = String(stdH);                // überschreibt immer
          rmh.classList.remove('input-error', 'out-of-bounds-error');
          this.showRamDeviation({ kind: 'H', show: false });
        }
      }

      this.schedulePriceCalc('ram-auto');
    },

    /**
     * Erlaubt die Rückrechnung von RAM aus eingegebenen ZAM-Werten.
     * Breite: ZAM - Z-Add = RAM
     */
    handleZamBManualChange(e) {
      const root = this.$refs.dynamicContent;
      if (!root) return;

      const zmb = e?.target || root.querySelector('.zm_z_b_value');
      const zmbAdd = root.querySelector('.zm_z_b_add_value');
      const rmb = root.querySelector('.rm_z_b_value');

      if (!(zmb && zmbAdd && rmb)) return;

      const zamB = parseFloat((zmb.value || '').replace(',', '.'));
      const addB = parseFloat((zmbAdd.textContent || zmbAdd.value || '').trim().replace(',', '.'));
      if (Number.isNaN(zamB) || Number.isNaN(addB)) return;

      const ramB = zamB - addB;
      rmb.value = String(ramB);
      rmb.classList.remove('input-error', 'out-of-bounds-error');

      this.schedulePriceCalc('zam-to-ram');
    },
    parseZBrushValue(select) {
      if (!select) return 0;

      const option = select.options && select.selectedIndex >= 0
        ? select.options[select.selectedIndex]
        : null;
      const valueRaw = (select.value || '').toString().trim().replace(',', '.');
      const textRaw = (option?.textContent || option?.innerText || '').toString().trim().replace(',', '.');

      if (`${valueRaw} ${textRaw}`.toLowerCase().includes('ohne')) return 0;

      const valueMatch = valueRaw.match(/-?\d+(?:\.\d+)?\s*mm/i);
      const textMatch = textRaw.match(/\/\s*(-?\d+(?:\.\d+)?)\s*mm/i)
        || textRaw.match(/-?\d+(?:\.\d+)?\s*mm/i);
      const fallbackMatch = valueRaw.match(/-?\d+(?:\.\d+)?/);
      const numericText = valueMatch?.[0] || textMatch?.[1] || textMatch?.[0] || fallbackMatch?.[0];
      const numeric = parseFloat((numericText || '').replace(',', '.').replace(/[^0-9.-]/g, ''));

      return Number.isFinite(numeric) ? numeric : 0;
    },
    sumZBrushValues(root, selector) {
      if (!root) return 0;

      return Array.from(root.querySelectorAll(selector)).reduce((sum, select) => {
        return sum + this.parseZBrushValue(select);
      }, 0);
    },
    getRamHeightDeduction(root = this.$refs.dynamicContent) {
      if (!root) return 0;

      return Array.from(root.querySelectorAll('select[data-ram-height-deduction]')).reduce((sum, select) => {
        const step = select.closest('[id^="s_"]');
        if (step && this.isStepHidden(step)) {
          return sum;
        }

        const triggerValue = (select.dataset.ramHeightDeductionWhenValue || '').toString().trim();
        if (triggerValue && (select.value || '').toString().trim() !== triggerValue) {
          return sum;
        }

        const deduction = parseFloat((select.dataset.ramHeightDeduction || '0').toString().trim().replace(',', '.'));
        return Number.isFinite(deduction) ? sum + deduction : sum;
      }, 0);
    },

    handleRmZBrushChange() {
      const root = this.$refs.dynamicContent;
      if (!root) return;

      const zmh = root.querySelector('.zm_z_h_value');
      if (zmh && (zmh.value || '').toString().trim() !== '') {
        this.handleZamHManualChange({ target: zmh });
        return;
      }

      this.calculateZAM();
    },
    handleRamHeightDeductionChange() {
      const root = this.$refs.dynamicContent;
      if (!root) return;

      const zmh = root.querySelector('.zm_z_h_value');
      if (zmh && (zmh.value || '').toString().trim() !== '') {
        this.handleZamHManualChange({ target: zmh });
        return;
      }

      this.calculateZAM();
    },

    /**
     * Erlaubt die Rückrechnung von RAM aus eingegebenen ZAM-Werten.
     * Höhe: ZAM - Z-Add - Bürsten - Zusatzabzüge = RAM
     */
    handleZamHManualChange(e) {
      const root = this.$refs.dynamicContent;
      if (!root) return;

      const zmh = e?.target || root.querySelector('.zm_z_h_value');
      const zmhAdd = root.querySelector('.zm_z_h_add_value');
      const brushAdd = this.sumZBrushValues(root, '.zm_z_buerste_value')
        + this.sumZBrushValues(root, '.rm_z_buerste_value');
      const ramHeightDeduction = this.getRamHeightDeduction(root);
      const rmh = root.querySelector('.rm_z_h_value');

      if (!(zmh && rmh)) return;

      const zamH = parseFloat((zmh.value || '').replace(',', '.'));
      const addH = parseFloat((zmhAdd?.textContent || zmhAdd?.value || '').trim().replace(',', '.'));
      const safeAddH = Number.isNaN(addH) ? 0 : addH;
      if (Number.isNaN(zamH)) return;

      const ramH = zamH - safeAddH - brushAdd - ramHeightDeduction;
      rmh.value = String(ramH);
      rmh.classList.remove('input-error', 'out-of-bounds-error');

      this.schedulePriceCalc('zam-to-ram');
    },

    calculateZAM() {
      const rmb = this.$refs.dynamicContent.querySelector('.rm_z_b_value');
      const rmh = this.$refs.dynamicContent.querySelector('.rm_z_h_value');
      const zmb = this.$refs.dynamicContent.querySelector('.zm_z_b_value');
      const zmh = this.$refs.dynamicContent.querySelector('.zm_z_h_value');
      const zmbAdd = this.$refs.dynamicContent.querySelector('.zm_z_b_add_value');
      const zmhAdd = this.$refs.dynamicContent.querySelector('.zm_z_h_add_value');
      const zmhBrushAdd = this.sumZBrushValues(this.$refs.dynamicContent, '.zm_z_buerste_value')
        + this.sumZBrushValues(this.$refs.dynamicContent, '.rm_z_buerste_value');
      const ramHeightDeduction = this.getRamHeightDeduction(this.$refs.dynamicContent);

      // --- BREITE ---
      if (rmb && zmb && zmbAdd) {
        const rmB = parseFloat(rmb.value);
        const addB = parseFloat((zmbAdd.textContent || zmbAdd.value || '').trim());
        const stdB = (!isNaN(rmB) && !isNaN(addB)) ? rmB + addB : null;
        this.zamBStandardValue = stdB;
        if (stdB != null) {
          zmb.value = String(stdB);                // überschreibt immer
          zmb.classList.remove('input-error', 'out-of-bounds-error');
          // this.showZamDeviation({ kind: 'B', show: false });
        }
      }

      // --- HÖHE ---
      if (rmh && zmh && zmhAdd) {
        const rmH = parseFloat(rmh.value);
        const addH = parseFloat((zmhAdd.textContent || zmhAdd.value || '').trim());
        const safeAddH = !isNaN(addH) ? addH : 0;
        const stdH = (!isNaN(rmH)) ? rmH + safeAddH + zmhBrushAdd + ramHeightDeduction : null;
        this.zamHStandardValue = stdH;
        if (stdH != null) {
          zmh.value = String(stdH);                // überschreibt immer
          zmh.classList.remove('input-error', 'out-of-bounds-error');
          // this.showZamDeviation({ kind: 'H', show: false });
        }
      }

      this.schedulePriceCalc('zam-auto');
    },
    toggleProductFilter(key) {
      const filter = this.productSearchFilters.find(item => item.key === key);
      if (!filter) return;
      if (this.activeProductFilters.includes(key)) {
        this.activeProductFilters = this.activeProductFilters.filter(activeKey => activeKey !== key);
      } else {
        this.activeProductFilters = this.activeProductFilters.concat(key);
      }
      this.highlightedIndex = -1;
      this.openProductSearch();
    },
    resetProductFilters() {
      this.activeProductFilters = [];
      this.highlightedIndex = -1;
      this.openProductSearch();
    },
    openProductSearch() {
      if (this.isSelectedProjectReadOnly) return;
      this.isProductSearchOpen = true;
      this.$nextTick(() => this.$refs.searchInput?.focus());
    },
    closeProductSearch() {
      this.isProductSearchOpen = false;
      this.highlightedIndex = -1;
    },
    isArticleInSearchFilters(articleId) {
      return this.activeProductFilters.length === 0 || this.productSearchArticleIds.has(Number(articleId));
    },
    onSearchInput(event) {
      this.searchTextArticle = (event?.target?.value ?? '').toString();
      this.selectedArticle = null;
      this.selectedPrice = null;
      this.selectedArticleId = -1;
      this.highlightedIndex = -1;
      this.isProductSearchOpen = true;
    },

    async changeArticleByText({ ignoreProductFilters = false, articleId = null } = {}) {
      // Normalize to avoid null/undefined issues from loaded configs or external callers
      const rawSearchText = (this.searchTextArticle ?? '').toString();
      const trimmedSearchText = rawSearchText.trim();
      this.minArticleWidth = null;
      this.minArticleHeight = null;
      this.maxArticleWidth = null;
      this.maxArticleHeight = null;

      if (trimmedSearchText === '') {
        this.selectedArticle = null;
      } else {
        const tmpFilteredArticleItems = this.filteredArticleItems.filter(article => (
          (articleId == null || String(article.id) === String(articleId))
          && (ignoreProductFilters || this.isArticleInSearchFilters(article.id))
        ));
        if (tmpFilteredArticleItems.length > 0) {
          // Wenn nur ein Artikel gefunden wurde, setze diesen als ausgewählten Artikel
          if (tmpFilteredArticleItems.length === 1) {
            this.selectedArticle = tmpFilteredArticleItems[0].id;
            this.minArticleWidth = tmpFilteredArticleItems[0].min_width;
            this.minArticleHeight = tmpFilteredArticleItems[0].min_height;
            this.maxArticleWidth = tmpFilteredArticleItems[0].max_width;
            this.maxArticleHeight = tmpFilteredArticleItems[0].max_height;
            this.isXLVariant = rawSearchText.includes('-XL');
            this.isHeightForKaempfer = false;
            this.isWidthForKaempfer = false;
            this.isHeightGreaterThanWidth = false;
            // Reset image cache bei Artikelwechsel
            this.lastImageLoadConfig = null;
            
            let tmpFilteredPriceListItems = this.filteredPriceListItems;
            if (tmpFilteredPriceListItems.length > 0) {
              this.selectedPrice = tmpFilteredPriceListItems[0].id;
            }
            this.selectedArticleProperties();
          } else {
            // Mehrere Artikel-Keywords gefunden, daher den ausgewählten Artikel zurücksetzen
            this.selectedArticle = null;
          }
        } else {
          // Keine Artikel gefunden, daher den ausgewählten Artikel zurücksetzen
          this.selectedArticle = null;
        }
      }
      this.isArticleRefreshed = true;
      if (this.selectedArticle != null) this.closeProductSearch();
      
      // Force immediate price calculation after article change
      // Die neuen Schritte müssen bereits gerendert sein, auch bei Zubehör ohne Maßeingabe.
      await this.$nextTick();
      await this.calculatePriceFromScratchSafe();
      this.refreshConfiguredArticle();
      
      // Bilder sofort laden bei Artikelwechsel
      if (this.selectedArticle) {
        await this.loadImagesForArticle();
      }
    },
    async navigateSearchResults(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        this.closeProductSearch();
        return;
      }
      if (event.key === 'Enter' && !event.isComposing) {
        event.preventDefault();
        if (this.isProductSearchOpen || this.selectedArticle == null) {
          const matches = this.filterAllArticleKeywords;
          const articleText = matches[this.highlightedIndex]
            || (matches.length === 1 ? matches[0] : null);
          if (articleText) {
            await this.selectArticle(articleText);
          } else if (this.selectedArticle == null) {
            await this.changeArticleByText();
          }
        }
        this.closeProductSearch();

        if (this.selectedArticle != null) {
          await this.$nextTick();
          this.focusNextConfiguratorField(this.$refs.searchInput);
        }
        return;
      }

      if (!['ArrowDown', 'ArrowUp'].includes(event.key)) return;
      event.preventDefault();
      this.isProductSearchOpen = true;
      await this.$nextTick();
      const items = this.$refs.searchResults? this.$refs.searchResults.querySelectorAll('li') : [];
      if (items.length === 0) return;
      if (event.key === 'ArrowDown') {
        this.highlightedIndex = (this.highlightedIndex + 1) % items.length;
      } else if (event.key === 'ArrowUp') {
        this.highlightedIndex = (this.highlightedIndex - 1 + items.length) % items.length;
      }

      this.highlightItem(items, this.highlightedIndex);
    },
    highlightItem(items, index) {
      items.forEach((item, i) => {
        item.classList.toggle('highlighted', i === index);
      });

       // Scrollen, wenn das hervorgehobene Element außerhalb des sichtbaren Bereichs liegt
       const container = this.$refs.searchResults;
      const highlightedItem = items[index];
      if (highlightedItem) {
        const itemOffsetTop = highlightedItem.offsetTop;
        const itemHeight = highlightedItem.offsetHeight;
        const containerScrollTop = container.scrollTop;
        const containerHeight = container.offsetHeight;

        if (itemOffsetTop < containerScrollTop) {
          // Scrollen nach oben
          container.scrollTop = itemOffsetTop;
        } else if (itemOffsetTop + itemHeight > containerScrollTop + containerHeight) {
          // Scrollen nach unten
          container.scrollTop = itemOffsetTop + itemHeight - containerHeight;
        }
      }
    },
    async getPriceListPriceValue(xInputElement, yInputElement, options = {}) {
      let rasterInputs = [];
      let requestIsCurrent = () => true;
      try {
        xInputElement = this.getPriceWidthInput(xInputElement);
        // const xInputElement = parentElement.querySelector(".x_value");
        // const yInputElement = parentElement.querySelector(".y_value");
        this.isHeightGreaterThanWidth = false;
        this.isHeightForKaempfer = false;
        this.isWidthForKaempfer = false;

        if (!(xInputElement && yInputElement)) return 0.0;

        const aggregateYInputs = Array.isArray(options.aggregateYInputs)
          ? options.aggregateYInputs.filter(Boolean)
          : [];
        rasterInputs = [xInputElement, ...(aggregateYInputs.length > 0 ? aggregateYInputs : [yInputElement])];
        this.setRasterDimensionError(rasterInputs, false);
        let xValue = options.widthValue ?? this.getNumericInputValue(xInputElement);
        let yValue = aggregateYInputs.length > 0
          ? this.getAggregateInputSum(aggregateYInputs)
          : this.getNumericInputValue(yInputElement);

        if (xValue === null || yValue === null) {
          if (aggregateYInputs.length > 0) {
            this.setAggregateDimensionError(aggregateYInputs, false);
          }
          return 0.0;
        }

        // Mindestwert-Prüfung für min_value-Felder, vor allgemeinem Tooltip-Reset
        const xHasMin = xInputElement.classList.contains('min_value');
        const yHasMin = yInputElement.classList.contains('min_value');
        const xMinOk = !xHasMin || this.validateMinValue(xInputElement);
        const yMinOk = aggregateYInputs.length > 0
          ? this.validateAggregateHeightValue(aggregateYInputs, yValue)
          : (!yHasMin || this.validateMinValue(yInputElement));
        if (!xMinOk || !yMinOk) {
          return 0.0;
        }

        // Sicht-/Grenzprüfungen wie gehabt (lassen wir intakt)
        const xTooltipContainer = xInputElement.parentElement.querySelector('.error-tooltip-container');
        if (xTooltipContainer) {
          xTooltipContainer.classList.add("hidden-visibility");
          const maxWidth = this.getMaxDimensionValue(xInputElement, 'width');
          if (maxWidth != null && xValue > maxWidth) {
            xInputElement.classList.add('out-of-bounds-error');
            xTooltipContainer.classList.remove("hidden-visibility");
          }
        }

        if (aggregateYInputs.length > 0) {
          this.validateAggregateHeightValue(aggregateYInputs, yValue);
        } else {
          const yTooltipContainer = yInputElement.parentElement.querySelector('.error-tooltip-container');
          if (yTooltipContainer) {
            yTooltipContainer.classList.add("hidden-visibility");
            const maxHeight = this.getMaxDimensionValue(yInputElement, 'height');
            if (maxHeight != null && yValue > maxHeight) {
              yInputElement.classList.add('out-of-bounds-error');
              yTooltipContainer.classList.remove("hidden-visibility");
            }
          }
        }

        // Kämpfer-Flags wie gehabt
        if (yValue > xValue) this.isHeightGreaterThanWidth = true;
        if (yValue > 1500) this.isHeightForKaempfer = true;
        if (xValue > 1500) this.isWidthForKaempfer = true;

        if (!this.selectedPrice) return 0.0;

        const priceListId = this.selectedPrice;
        requestIsCurrent = () => this.selectedPrice === priceListId
          && (options.widthValue ?? this.getNumericInputValue(xInputElement)) === xValue
          && (aggregateYInputs.length > 0
            ? this.getAggregateInputSum(aggregateYInputs)
            : this.getNumericInputValue(yInputElement)) === yValue;

        // --- Request-Koordinierung ---
        const key = this.makePriceKey(xValue, yValue, this.selectedPrice);

        // 1) Wenn Ergebnis identisch wie letztes Key -> Cache nutzen
        if (this.lastPriceKey === key && typeof this.lastPriceValue === 'number') {
          return this.lastPriceValue;
        }

        // 2) Wenn identischer In-Flight-Request existiert -> denselben Promise warten
        if (this.inFlightPriceKey === key && this.inFlightPricePromise) {
          return await this.inFlightPricePromise;
        }

        // 3) Mindestabstand zwischen API-Calls (global, reduziert 429-Risiko)
        const now = Date.now();
        const since = now - this.lastApiCallAt;
        if (since < this.minApiIntervalMs) {
          // kurze Verzögerung, um Calls zusammenzulegen
          await new Promise(r => setTimeout(r, this.minApiIntervalMs - since));
        }

        // 4) Vorherigen Call zu demselben Endpunkt abbrechen (dein AbortController)
        if (this.priceRequestAbortController) {
          this.priceRequestAbortController.abort();
        }
        this.priceRequestAbortController = new AbortController();

        // 5) Request setzen + merken
        this.inFlightPriceKey = key;
        this.inFlightPricePromise = (async () => {
          const res = await this.configuratorApi.lookupRasterPrice(
            { preislisten_id: priceListId, x: xValue, y: yValue },
            { signal: this.priceRequestAbortController.signal }
          );
          const price = Number(res.data.preis);
          if (!requestIsCurrent()) return 0.0;
          if (price < 0) {
            const error = new Error(RASTER_DIMENSION_ERROR);
            error.rasterDimensionUnavailable = true;
            throw error;
          }
          this.lastPriceKey = key;
          this.lastPriceValue = price;
          this.lastApiCallAt = Date.now();
          return price;
        })();

        try {
          const price = await this.inFlightPricePromise;
          return price;
        } finally {
          // In-Flight Slot freigeben (aber Cache behalten)
          this.inFlightPriceKey = null;
          this.inFlightPricePromise = null;
        }
      } catch (error) {
        if (!requestIsCurrent()) return 0.0;
        if (error.rasterDimensionUnavailable || error.response?.data?.errors?.dimensions) {
          this.lastPriceKey = null;
          this.lastPriceValue = null;
          this.setRasterDimensionError(rasterInputs, true);
          this.price = 0;
          return 0.0;
        }
        // Abgebrochen -> stiller 0.0 Fallback
        if (api.isCancel?.(error) || error?.name === 'CanceledError' || error?.message?.includes('aborted')) {
          return 0.0;
        }
        if (this.isExternal) this.showError('Der Rasterpreis konnte nicht geladen werden. Bitte Maße und Verbindung prüfen.');
        else console.error('Error in getPriceListPriceValue:', error);
        return 0.0;
      }
    },
    async getPriceListPrice(pointerEvent) {
      if (this.isCalculatingPrice) {
        return; // Prevent concurrent price calculations
      }
      
      var parentElement = pointerEvent.target.parentElement;
      try {
        var xInputElement = parentElement.querySelector(".x_value");
        var yInputElement = parentElement.querySelector(".y_value");
        if (xInputElement && yInputElement) {
          var xValue = xInputElement.value;
          var yValue = yInputElement.value;
          if (xValue && xValue.trim() !== '' && !isNaN(Number(xValue))
          && yValue && yValue.trim() !== '' && !isNaN(Number(yValue))) {

            const response = await this.configuratorApi.lookupRasterPrice({
              preislisten_id: this.selectedPriceList,
              x: xValue,
              y: yValue
            });
            var index = Number(parentElement.parentElement.parentElement.querySelector(".category-index").innerHTML);
            this.prices[index + 1] = Number(response.data.preis);
            this.schedulePriceCalc('manual-price');
            this.refreshConfiguredArticle();
          }
        }
      } catch (error) {
        if (this.isExternal) this.showError('Der Rasterpreis konnte nicht geladen werden. Bitte Maße und Verbindung prüfen.');
        else console.error(error);
      }
    },
    async setConstPrice(pointerEvent) {
      if (this.isCalculatingPrice) {
        return; // Prevent concurrent price calculations
      }
      
      var parentElement = pointerEvent.target.parentElement;
      try {
        var xInputElement = parentElement.querySelector(".x_value");
        if (xInputElement) {
          var xValue = xInputElement.value;
          if (xValue && xValue.trim() !== '' && !isNaN(Number(xValue))) {

            var index = Number(parentElement.parentElement.parentElement.querySelector(".category-index").innerHTML);
            this.prices[index + 1] = Number(xValue);
            this.schedulePriceCalc('manual-price');
            this.refreshConfiguredArticle();
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    async setPercPrice(pointerEvent) {
      if (this.isCalculatingPrice) {
        return; // Prevent concurrent price calculations
      }
      
      var parentElement = pointerEvent.target.parentElement;
      try {
        var xInputElement = parentElement.querySelector(".x_value");
        if (xInputElement) {
          var xValue = xInputElement.value;
          if (xValue && xValue.trim() !== '' && !isNaN(Number(xValue))) {

            var index = Number(parentElement.parentElement.parentElement.querySelector(".category-index").innerHTML);
            var sumPrices = 0.0;
            for(let i = 0; i < this.prices.length; ++i) {
              sumPrices = sumPrices + this.prices[i];
            }
            this.prices[index + 1] = sumPrices * Number(xValue) / 100.0;
            this.schedulePriceCalc('manual-price');
            this.refreshConfiguredArticle();
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    isGriffkaempferHoeheInput(input) {
      const container = input?.closest('.input-container');
      const labelText = (container?.querySelector('.container-input-label')?.textContent || '').toLowerCase();

      return labelText.includes('kämpfer') && labelText.includes('höhe');
    },
    isKaempferMassInput(input) {
      const label = this.getConfiguratorFieldLabel(input).replace(/\s+/g, ' ');

      return label.includes('kämpfer') && (
        label.includes('höhe') || label.includes('von links')
        || label.includes('von rechts') || label.includes('senkrecht')
      );
    },
    getKaempferBaseMeasurements(axis) {
      const fields = Array.from(this.$refs.dynamicContent?.querySelectorAll('input') || [])
        .filter(input => {
          const step = input.closest('[id^="s_"]');
          const style = getComputedStyle(input);
          return !['checkbox', 'radio', 'hidden'].includes(input.type)
            && !this.isKaempferMassInput(input)
            && !this.isEndrasterwunschhoeheInput(input)
            && !this.isStepHidden(step || input)
            && style.display !== 'none' && style.visibility !== 'hidden';
        })
        .map(input => {
          const name = (input.closest('.input-container')?.querySelector('.container-input-label')?.textContent || '')
            .normalize('NFKC').replace(/\s*:\s*$/, '').trim();
          const label = name.toLowerCase().replace(/-/g, ' ').replace(/\s+/g, ' ');
          const isWing = input.matches('.wing_l_value, .wing_r_value, .f_l_value, .f_r_value');
          const isSourceDimension = /\b(?:zam|lm)\b/.test(label)
            || input.matches('.zam_b_value, .zam_h_value, .lm_b_value, .lm_h_value, .zm_z_b_value, .zm_z_h_value');
          const isRam = !isSourceDimension && (
            /\bram\b/.test(label)
            || input.matches('.rm_b_value, .rm_h_value, .rm_z_b_value, .rm_z_h_value')
            || /\bram\b/.test(this.getConfiguratorFieldLabel(input))
          );
          const matchesAxis = axis === 'width'
            ? isWing || label.includes('breite') || (!label && input.matches('.x_value, [class*="_b_value"]'))
            : !isWing && !label.includes('breite')
              && (label.includes('höhe') || (!label && input.matches('.y_value, [class*="_h_value"]')));

          return { input, name: name || (axis === 'width' ? 'Breite' : 'Höhe'), isWing, isRam, isSourceDimension, matchesAxis };
        })
        .filter(field => field.matchesAxis);

      const wings = axis === 'width' ? fields.filter(field => field.isWing) : [];
      const ramFields = fields.filter(field => field.isRam);
      const regularFields = fields.filter(field => !field.isSourceDimension);
      const selectedFields = wings.length ? wings
        : ramFields.length ? ramFields : regularFields.length ? regularFields : fields;

      return selectedFields.map(field => ({ ...field, value: this.getNumericInputValue(field.input) }));
    },
    validateKaempferMasse() {
      const inputs = Array.from(this.$refs.dynamicContent?.querySelectorAll('input.x_value, input.y_value') || []);
      let isValid = true;

      inputs.forEach(input => {
        if (!this.isKaempferMassInput(input)) {
          return;
        }

        const step = input.closest('[id^="s_"]');
        const value = this.getNumericInputValue(input);
        const active = !input.disabled && !this.isStepHidden(step) && value !== null;
        const axis = this.getConfiguratorFieldLabel(input).includes('höhe') ? 'height' : 'width';
        const tooHigh = active && value > MAX_KAEMPFER_MASS;
        const invalidRemainder = active
          ? this.getKaempferBaseMeasurements(axis).find(field => (
            field.value !== null && field.value > value + MAX_KAEMPFER_MASS
          )) : null;
        const hasError = tooHigh || !!invalidRemainder;
        this.setDimensionInputError(input, hasError);

        const warning = this.ensureRamWarningElement(input, 'kaempfer-mass');
        if (warning) {
          const messages = [];
          if (tooHigh) messages.push(`Dieses Kämpfermaß darf maximal ${MAX_KAEMPFER_MASS} mm betragen.`);
          if (invalidRemainder) {
            messages.push(`Die Differenz zwischen ${invalidRemainder.name} und Kämpfermaß darf maximal ${MAX_KAEMPFER_MASS} mm betragen.`);
          }
          const text = messages.join(' ');
          const warningText = warning.querySelector('.ram-warning-text');
          if (warningText.textContent !== text) warningText.textContent = text;
          warning.style.display = hasError ? 'block' : 'none';
        }
        isValid = isValid && !hasError;
      });

      return isValid;
    },
    isEndrasterwunschhoeheInput(input) {
      const container = input?.closest('.input-container');
      const labelText = (container?.querySelector('.container-input-label')?.textContent || '').toLowerCase();

      return labelText.includes('endrasterwunschhöhe');
    },
    updateGriffkaempferHoeheSuffix(event = null) {
      const inputs = event?.target
        ? [event.target]
        : Array.from(this.$refs.dynamicContent?.querySelectorAll('.x_value') || []);

      inputs.forEach(input => {
        const isGriffkaempferHoehe = this.isGriffkaempferHoeheInput(input);
        const isEndrasterwunschhoehe = this.isEndrasterwunschhoeheInput(input);
        if (!isGriffkaempferHoehe && !isEndrasterwunschhoehe) {
          return;
        }

        const container = input.closest('.input-container');
        if (!container) {
          return;
        }

        let suffix = container.querySelector('.input-reference-suffix');
        if (!suffix) {
          suffix = document.createElement('span');
          suffix.className = 'input-reference-suffix';
          container.appendChild(suffix);
        }
        suffix.textContent = isEndrasterwunschhoehe ? 'v. unten' : 'v. UK RAM';

        const value = input.value.trim();
        const numericValue = Number(value.replace(',', '.'));
        suffix.style.display = value !== '' && !Number.isNaN(numericValue) ? 'block' : 'none';
      });
    },
    getConfiguratorFieldLabel(element) {
      const step = element?.closest?.('[id^="s_"]');
      const title = step?.querySelector('.category-title')?.textContent || '';
      const inputLabel = element?.closest?.('.input-container')?.querySelector('.container-input-label')?.textContent || '';

      return `${title} ${inputLabel}`
        .normalize('NFKC')
        .replace(/\u00A0/g, ' ')
        .trim()
        .toLowerCase();
    },
    getSelectOptionText(option) {
      return (option?.textContent || option?.innerText || option?.innerHTML || '')
        .normalize('NFKC')
        .replace(/\u00A0/g, ' ')
        .trim()
        .toLowerCase();
    },
    getSelectOptionDisplayText(option) {
      return (option?.textContent || option?.innerText || option?.innerHTML || '')
        .normalize('NFKC')
        .replace(/\u00A0/g, ' ')
        .trim();
    },
    getSelectedOption(select) {
      return select?.options && select.selectedIndex >= 0
        ? select.options[select.selectedIndex]
        : null;
    },
    getSelectChargePriceId(select) {
      const selectedOption = this.getSelectedOption(select);
      return (
        selectedOption?.dataset?.aufpreisId ||
        selectedOption?.dataset?.priceId ||
        selectedOption?.value ||
        select?.value ||
        ''
      ).toString().trim();
    },
    getStepSelects(containerElement) {
      if (!containerElement) return [];
      return Array.from(containerElement.querySelectorAll('select.s_value'));
    },
    getSelectSummaryLabel(select, fallbackIndex) {
      if (select?.hasAttribute?.('data-summary-label')) {
        return (select.dataset.summaryLabel || '').trim();
      }

      const labelText = (select?.closest('.input-container')?.querySelector('.container-input-label')?.textContent || '')
        .normalize('NFKC')
        .replace(/\u00A0/g, ' ')
        .replace(/:$/, '')
        .trim();

      return labelText || `Auswahl ${fallbackIndex + 1}`;
    },
    normalizeSelectDataValue(value) {
      return String(value || '')
        .normalize('NFKC')
        .replace(/\u00A0/g, ' ')
        .trim()
        .toLowerCase();
    },
    getConfiguredSelectDataValues(rawValues) {
      return String(rawValues || '')
        .split(';')
        .map(value => this.normalizeSelectDataValue(value))
        .filter(Boolean);
    },
    getSelectedComparableValues(select) {
      const selectedOption = this.getSelectedOption(select);
      return [
        select?.value,
        selectedOption?.value,
        this.getSelectOptionDisplayText(selectedOption),
      ]
        .map(value => this.normalizeSelectDataValue(value))
        .filter(Boolean);
    },
    selectMatchesConfiguredValues(select, rawValues) {
      const configuredValues = this.getConfiguredSelectDataValues(rawValues);
      if (!configuredValues.length) return false;

      const selectedValues = this.getSelectedComparableValues(select);
      return configuredValues.some(value => selectedValues.includes(value));
    },
    shouldSuppressMultiSelectDisplay(selects) {
      return selects.some(select => (
        this.selectMatchesConfiguredValues(select, select?.dataset?.summarySuppressGroupValues)
      ));
    },
    buildMultiSelectDisplayValue(selects) {
      if (this.shouldSuppressMultiSelectDisplay(selects)) {
        return 'ohne';
      }

      return selects
        .map((select, index) => {
          const optionText = this.getSelectOptionDisplayText(this.getSelectedOption(select));
          if (!optionText) return '';

          const label = this.getSelectSummaryLabel(select, index);
          return label ? `${label}: ${optionText}` : optionText;
        })
        .filter(Boolean)
        .join('\n');
    },
    extractMultiSelectDisplayParts(rawValue) {
      return String(rawValue || '')
        .split(/\s+\/\s+|\n+/)
        .map(part => part.replace(/^.*?:\s*/, '').trim())
        .filter(Boolean);
    },
    restoreMultiSelectDisplayValue(selects, rawValue) {
      const parts = this.extractMultiSelectDisplayParts(rawValue);

      selects.forEach((select, index) => {
        const wantedText = (parts[index] || '').toLowerCase();
        if (!wantedText) return;

        const option = Array.from(select.options || []).find(opt => (
          this.getSelectOptionDisplayText(opt).toLowerCase() === wantedText
        ));

        if (option) {
          select.selectedIndex = option.index;
        }
      });

      this.applyDependentSelectAvailability();
      this.applyExclusiveSelectGroups();

      selects.forEach(select => {
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    },
    getDependentSelects() {
      const root = this.$refs.dynamicContent;
      if (!root) return [];

      return Array.from(root.querySelectorAll('select[data-enable-when-select-index]'));
    },
    getSelectDependencySource(select) {
      const dependencyIndex = Number(select?.dataset?.enableWhenSelectIndex);
      if (!Number.isInteger(dependencyIndex)) return null;

      const container = select?.closest?.('.container');
      const selects = this.getStepSelects(container);

      return selects[dependencyIndex] || null;
    },
    shouldEnableDependentSelect(select) {
      const sourceSelect = this.getSelectDependencySource(select);
      if (!sourceSelect) return true;

      const enableWhenValues = select?.dataset?.enableWhenValues;
      if (enableWhenValues) {
        return this.selectMatchesConfiguredValues(sourceSelect, enableWhenValues);
      }

      const enableWhenValuesNot = select?.dataset?.enableWhenValuesNot;
      if (enableWhenValuesNot) {
        return !this.selectMatchesConfiguredValues(sourceSelect, enableWhenValuesNot);
      }

      return true;
    },
    applyDependentSelectAvailability() {
      this.getDependentSelects().forEach(select => {
        const shouldEnable = this.shouldEnableDependentSelect(select);
        select.disabled = !shouldEnable;

        if (shouldEnable) {
          select.removeAttribute('aria-disabled');
        } else {
          select.setAttribute('aria-disabled', 'true');
        }
      });
    },
    handleDependentSelectAvailabilityChange() {
      this.applyDependentSelectAvailability();
    },
    getExclusiveSelects() {
      const root = this.$refs.dynamicContent;
      if (!root) return [];

      return Array.from(root.querySelectorAll('select.select[data-exclusive-group]')).filter(select => {
        const step = select.closest('[id^="s_"]');
        return !step || !this.isStepHidden(step);
      });
    },
    shouldIgnoreExclusiveSelectValue(value) {
      const normalized = String(value || '').trim().toLowerCase();
      return normalized === '' || normalized === 'ohne';
    },
    getExclusiveSelectValue(select) {
      return (this.getSelectedOption(select)?.value || select?.value || '').toString().trim();
    },
    resetExclusiveSelect(select) {
      const fallbackOption = Array.from(select.options || []).find(option => (
        this.shouldIgnoreExclusiveSelectValue(option.value) && !option.disabled
      )) || Array.from(select.options || []).find(option => !option.disabled);

      if (fallbackOption) {
        select.selectedIndex = fallbackOption.index;
      }
    },
    syncExclusiveSelectGroup(selects, changedSelect = null) {
      selects.forEach(select => {
        Array.from(select.options || []).forEach(option => {
          option.disabled = false;
          option.removeAttribute('aria-disabled');
        });
      });

      const orderedSelects = changedSelect
        ? [changedSelect, ...selects.filter(select => select !== changedSelect)]
        : selects;
      const keptValues = new Set();

      orderedSelects.forEach(select => {
        const value = this.getExclusiveSelectValue(select);
        if (this.shouldIgnoreExclusiveSelectValue(value)) return;

        if (keptValues.has(value)) {
          this.resetExclusiveSelect(select);
          return;
        }

        keptValues.add(value);
      });

      const activeValues = new Set(
        selects
          .map(select => this.getExclusiveSelectValue(select))
          .filter(value => !this.shouldIgnoreExclusiveSelectValue(value))
      );

      selects.forEach(select => {
        const ownValue = this.getExclusiveSelectValue(select);

        Array.from(select.options || []).forEach(option => {
          const optionValue = String(option.value || '').trim();
          const shouldDisable = !this.shouldIgnoreExclusiveSelectValue(optionValue)
            && optionValue !== ownValue
            && activeValues.has(optionValue);

          option.disabled = shouldDisable;
          if (shouldDisable) {
            option.setAttribute('aria-disabled', 'true');
          } else {
            option.removeAttribute('aria-disabled');
          }
        });
      });
    },
    applyExclusiveSelectGroups(changedSelect = null) {
      const groups = new Map();

      this.getExclusiveSelects().forEach(select => {
        const groupName = (select.dataset.exclusiveGroup || '').trim();
        if (!groupName) return;

        if (!groups.has(groupName)) {
          groups.set(groupName, []);
        }
        groups.get(groupName).push(select);
      });

      groups.forEach(selects => {
        this.syncExclusiveSelectGroup(
          selects,
          selects.includes(changedSelect) ? changedSelect : null
        );
      });
    },
    handleExclusiveSelectChange(event) {
      this.applyExclusiveSelectGroups(event?.target || null);
    },
    updateStulpBrushProfileDefaults() {
      const fields = this.$refs.dynamicContent?.querySelectorAll('.stulp-profile-clearance');
      if (!fields?.length) return;

      const bottomBrush = this.getStulpVariantBlockingSelects().find(select => (
        /b(?:ü|ue)rste nach unten/.test(this.getConfiguratorFieldLabel(select))
      ));
      const hasBottomBrush = bottomBrush && this.selectHasBlockingStulpVariantValue(bottomBrush);
      fields.forEach(input => {
        const defaultValue = input.dataset.stulpProfileSide === 'unten' && hasBottomBrush ? '0' : '30';
        input.dataset.defaultValue = defaultValue;
        input.placeholder = defaultValue;
      });
    },
    getStulpVersatzSelects() {
      const root = this.$refs.dynamicContent;
      if (!root) return [];

      return Array.from(root.querySelectorAll('select.select')).filter(select => (
        this.getConfiguratorFieldLabel(select).includes('stulp-versatz')
      ));
    },
    getStulpVariantBlockingSelects() {
      const root = this.$refs.dynamicContent;
      if (!root) return [];

      return Array.from(root.querySelectorAll('select.select')).filter(select => {
        const label = this.getConfiguratorFieldLabel(select);
        return label.includes('bürste nach oben')
          || label.includes('bürste nach unten')
          || label.includes('buerste nach oben')
          || label.includes('buerste nach unten')
          || label.includes('trittschutz');
      });
    },
    selectHasBlockingStulpVariantValue(select) {
      const step = select?.closest?.('[id^="s_"]');
      if (step && this.isStepHidden(step)) return false;

      const option = select?.options?.[select.selectedIndex];
      if (!option) return false;

      const value = (option.value || select.value || '').trim().toLowerCase();
      const text = this.getSelectOptionText(option);

      if (value === '' && text === '') return false;
      return value !== 'ohne' && !text.startsWith('ohne');
    },
    hasBlockingStulpVariantCondition() {
      return this.getStulpVariantBlockingSelects().some(select => (
        this.selectHasBlockingStulpVariantValue(select)
      ));
    },
    isStulpVariantAOption(option) {
      return this.getSelectOptionText(option).includes('stulpvariante-a');
    },
    applyStulpVariantAvailability() {
      const stulpSelects = this.getStulpVersatzSelects();
      if (!stulpSelects.length) return;

      const shouldBlockVariantA = this.hasBlockingStulpVariantCondition();

      stulpSelects.forEach(select => {
        let selectedBlockedOption = false;

        Array.from(select.options || []).forEach(option => {
          if (!this.isStulpVariantAOption(option)) return;

          option.disabled = shouldBlockVariantA;
          option.hidden = shouldBlockVariantA;
          option.style.display = shouldBlockVariantA ? 'none' : '';

          if (shouldBlockVariantA) {
            option.setAttribute('aria-disabled', 'true');
            option.title = 'Nicht auswählbar, wenn Bürste oder Trittschutz gesetzt ist.';
          } else {
            option.removeAttribute('aria-disabled');
            option.removeAttribute('title');
          }

          if (shouldBlockVariantA && option.selected) {
            selectedBlockedOption = true;
          }
        });

        if (selectedBlockedOption) {
          const fallbackOption = Array.from(select.options || []).find(option => (
            !option.disabled && (option.value || '').trim().toLowerCase() === 'ohne'
          )) || Array.from(select.options || []).find(option => !option.disabled);

          if (fallbackOption) {
            select.selectedIndex = fallbackOption.index;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });
    },
    handleStulpVariantAvailabilityChange() {
      this.applyStulpVariantAvailability();
    },
    refreshEventListener() {
      if (!this.$refs.dynamicContent) {
        return; // Exit if the reference is not defined
      }

      this.ensureRalColorNameFields();
      this.bindPendelAuflagenListeners();

      // Unset Eventlistener for Selectbox, Input-Feld und Checkbox
      this.$refs.dynamicContent.querySelectorAll('.select').forEach(selectbox => {
        selectbox.removeEventListener('change', this.refreshPriceList);
        selectbox.removeEventListener('change', this.handleDependentSelectAvailabilityChange);
      });
      this.$refs.dynamicContent.querySelectorAll('select.select[data-exclusive-group]').forEach(selectbox => {
        selectbox.removeEventListener('change', this.handleExclusiveSelectChange);
      });
      this.$refs.dynamicContent.querySelectorAll('.input').forEach(input => {
        input.removeEventListener('input', this.refreshPriceList);
      });
      this.$refs.dynamicContent.querySelectorAll('.input').forEach(checkbox => {
        checkbox.removeEventListener('change', this.refreshPriceList);
      });
      this.$refs.dynamicContent.querySelectorAll('.rn_value').forEach(el => {
        el.removeEventListener('input', this.refreshPriceList);
        el.removeEventListener('change', this.refreshPriceList);
      });
      this.$refs.dynamicContent.querySelectorAll('.input').forEach(input => {
        input.removeEventListener('input', this.handleRalLookupFieldChange);
        input.removeEventListener('change', this.handleRalLookupFieldChange);
      });
       // Refresh saved Values VueX
      this.$refs.dynamicContent.querySelectorAll('.select').forEach(selectbox => {
        selectbox.removeEventListener('change', this.refeshSavedValues);
      });
      this.$refs.dynamicContent.querySelectorAll('.input').forEach(input => {
        input.removeEventListener('input', this.refeshSavedValues);
      });
      this.$refs.dynamicContent.querySelectorAll('.input').forEach(checkbox => {
        checkbox.removeEventListener('change', this.refeshSavedValues);
      });
      this.$refs.dynamicContent.querySelectorAll('.input').forEach(checkbox => {
        checkbox.removeEventListener('change', this.additionalCheckBoxLogic);
      });
      this.getStulpVariantBlockingSelects().forEach(selectbox => {
        selectbox.removeEventListener('change', this.handleStulpVariantAvailabilityChange);
      });
      this.$refs.dynamicContent.querySelectorAll('.x_value').forEach(input => {
        input.removeEventListener('input', this.updateGriffkaempferHoeheSuffix);
        input.removeEventListener('change', this.updateGriffkaempferHoeheSuffix);
      });
      this.$refs.dynamicContent.querySelectorAll(KAEMPFER_DIMENSION_SELECTOR).forEach(input => {
        input.removeEventListener('input', this.validateKaempferMasse);
        input.removeEventListener('change', this.validateKaempferMasse);
      });
      
      // Remove spezielle Event-Listener für Breite/Höhe-Felder
      this.$refs.dynamicContent.querySelectorAll('.x_value, .y_value').forEach(input => {
        const isMinField = input.classList.contains('min_value');

        input.removeEventListener('input', this.debouncedPriceCalculation);
        input.removeEventListener('change', this.handleDimensionChange);
        input.removeEventListener('blur', this.handleDimensionChange);

        const runMinCheck = () => { if (isMinField) this.validateMinValue(input); };

        input.addEventListener('input', () => { runMinCheck(); this.schedulePriceCalc('dim-input'); });
        input.addEventListener('change', () => { runMinCheck(); this.scheduleCommittedPriceCalc(); });
        input.addEventListener('blur', () => { runMinCheck(); this.scheduleCommittedPriceCalc(); });
      });
      
      this.$refs.dynamicContent.querySelectorAll('.category-title').forEach(element => {
        element.removeEventListener('click', this.toggle);
      });
      if (this.isArticleRefreshed) {
        this.isArticleRefreshed = false;
        /*this.$refs.dynamicContent.querySelectorAll('.category-content').forEach(element => {
          element.style.maxHeight = '0px';
        });*/
      }

      // Set Eventlistener for Selectbox, Input-Feld und Checkbox
      this.$refs.dynamicContent.querySelectorAll('select.select[data-exclusive-group]').forEach(selectbox => {
        selectbox.addEventListener('change', this.handleExclusiveSelectChange);
      });
      this.$refs.dynamicContent.querySelectorAll('.select').forEach(selectbox => {
        selectbox.addEventListener('change', this.handleDependentSelectAvailabilityChange);
        selectbox.addEventListener('change', this.refreshPriceList);
      });
      this.$refs.dynamicContent.querySelectorAll('.input').forEach(input => {
        input.addEventListener('input', this.refreshPriceList);
      });
      this.$refs.dynamicContent.querySelectorAll('.input').forEach(checkbox => {
        checkbox.addEventListener('change', this.refreshPriceList);
      });
      this.$refs.dynamicContent.querySelectorAll('.rn_value').forEach(el => {
        el.addEventListener('input', this.refreshPriceList);
        el.addEventListener('change', this.refreshPriceList);
      });
      this.$refs.dynamicContent.querySelectorAll('.input').forEach(input => {
        input.addEventListener('input', this.handleRalLookupFieldChange);
        input.addEventListener('change', this.handleRalLookupFieldChange);
      });
      
      // Refresh saved Values VueX
      this.$refs.dynamicContent.querySelectorAll('.select').forEach(selectbox => {
        selectbox.addEventListener('change', this.refeshSavedValues);
      });
      this.$refs.dynamicContent.querySelectorAll('.input').forEach(input => {
        input.addEventListener('input', this.refeshSavedValues);
      });
      this.$refs.dynamicContent.querySelectorAll('.input').forEach(checkbox => {
        checkbox.addEventListener('change', this.refeshSavedValues);
      });
      this.$refs.dynamicContent.querySelectorAll('.input').forEach(checkbox => {
        checkbox.addEventListener('change', this.additionalCheckBoxLogic);
      });
      this.getStulpVariantBlockingSelects().forEach(selectbox => {
        selectbox.addEventListener('change', this.handleStulpVariantAvailabilityChange);
      });
      this.$refs.dynamicContent.querySelectorAll('.x_value').forEach(input => {
        if (this.isGriffkaempferHoeheInput(input) || this.isEndrasterwunschhoeheInput(input)) {
          input.addEventListener('input', this.updateGriffkaempferHoeheSuffix);
          input.addEventListener('change', this.updateGriffkaempferHoeheSuffix);
        }
      });
      this.$refs.dynamicContent.querySelectorAll(KAEMPFER_DIMENSION_SELECTOR).forEach(input => {
        input.addEventListener('input', this.validateKaempferMasse);
        input.addEventListener('change', this.validateKaempferMasse);
      });
      this.$refs.dynamicContent.querySelectorAll('.category-title').forEach(element => {
        element.addEventListener('click', this.toggle);
      });

      this.updateGriffkaempferHoeheSuffix();
      this.applyInputOverrideCheckboxes();
      this.applyDependentSelectAvailability();
      this.applyStulpVariantAvailability();
      this.updateStulpBrushProfileDefaults();
      this.applyExclusiveSelectGroups();

      this.validateKaempferMasse();

      // XL-Checkbox-Zustand beim Laden der Event-Listener überprüfen
      setTimeout(() => this.checkAndManageXLCheckboxes(), 100);
    },
    // Behandelt Änderungen in Breite/Höhe-Feldern
    async handleDimensionChange() {

      // Committed-Berechnung für Dimensionsänderungen
      this.scheduleCommittedPriceCalc();
      
      // XL-Checkbox-Zustand nach Dimensionsänderung überprüfen
      setTimeout(() => this.checkAndManageXLCheckboxes(), 100);
    },
    // Neue Methode zur Überprüfung und Verwaltung der XL-Checkbox-Zustände
    checkAndManageXLCheckboxes() {
      if (!this.$refs.dynamicContent) return;
      
      const allXLCheckboxes = this.$refs.dynamicContent.querySelectorAll('input[type="checkbox"]');
      let checkedXLCheckbox = null;
      
      // Erst alle unsichtbaren XL-Checkboxen deaktivieren
      allXLCheckboxes.forEach(checkbox => {
        const checkboxClasses = Array.from(checkbox.classList);
        const isXLCheckbox = checkboxClasses.some(cls => cls.toLowerCase().includes('xl'));
        
        if (isXLCheckbox) {
          // Prüfe ob die Checkbox oder ihr übergeordnetes Element (Kämpfer) sichtbar ist
          const parentStep = checkbox.closest('[id^="s_"]'); // Findet das übergeordnete Step-Element
          const isVisible = parentStep && this.isElementVisible(parentStep);
          
          if (!isVisible && checkbox.checked) {
            // Checkbox ist nicht sichtbar aber aktiviert - deaktiviere sie
            checkbox.checked = false;
            
            // Input-Feld zurücksetzen wenn Checkbox deaktiviert wird
            const xValueInput = parentStep.querySelector('.x_value');
            if (xValueInput && xValueInput.value === 'XL-Profil statt Kämpfer') {
              xValueInput.disabled = false;
              xValueInput.style.backgroundColor = '';
              xValueInput.style.color = '';
              xValueInput.value = xValueInput.dataset.originalValue || '';
              
              // Change-Event manuell auslösen
              const changeEvent = new Event('change', { bubbles: true });
              xValueInput.dispatchEvent(changeEvent);
              
              // Input-Event ebenfalls auslösen für Live-Updates
              const inputEvent = new Event('input', { bubbles: true });
              xValueInput.dispatchEvent(inputEvent);
            }
            
            // Auch den globalen XL-Zustand zurücksetzen wenn nötig
            const anyXLStillActive = Array.from(allXLCheckboxes).some(cb => {
              const cbClasses = Array.from(cb.classList);
              const isCbXL = cbClasses.some(cls => cls.toLowerCase().includes('xl'));
              const cbParentStep = cb.closest('[id^="s_"]');
              const isCbVisible = cbParentStep && this.isElementVisible(cbParentStep);
              return isCbXL && cb.checked && isCbVisible;
            });
            
            if (!anyXLStillActive) {
              this.isXLVariant = false;
            }
          }
        }
      });
      
      // Finde die erste aktivierte UND sichtbare XL-Checkbox
      allXLCheckboxes.forEach(checkbox => {
        const checkboxClasses = Array.from(checkbox.classList);
        const isXLCheckbox = checkboxClasses.some(cls => cls.toLowerCase().includes('xl'));
        
        if (isXLCheckbox && checkbox.checked && !checkedXLCheckbox) {
          const parentStep = checkbox.closest('[id^="s_"]');
          const isVisible = parentStep && this.isElementVisible(parentStep);
          
          if (isVisible) {
            checkedXLCheckbox = checkbox;
          }
        }
      });
      
      // Wenn eine sichtbare XL-Checkbox aktiviert ist, deaktiviere alle anderen sichtbaren
      allXLCheckboxes.forEach(checkbox => {
        const checkboxClasses = Array.from(checkbox.classList);
        const isXLCheckbox = checkboxClasses.some(cls => cls.toLowerCase().includes('xl'));
        
        if (isXLCheckbox) {
          const parentStep = checkbox.closest('[id^="s_"]');
          const isVisible = parentStep && this.isElementVisible(parentStep);
          
          if (isVisible) {
            if (checkedXLCheckbox && checkbox !== checkedXLCheckbox) {
              // Andere sichtbare XL-Checkbox deaktivieren
              checkbox.disabled = true;
              checkbox.style.opacity = '0.5';
              
              const parentLabel = checkbox.closest('label');
              if (parentLabel) {
                parentLabel.style.opacity = '0.5';
                parentLabel.style.pointerEvents = 'none';
              }
            } else if (!checkedXLCheckbox) {
              // Keine XL-Checkbox aktiv - alle sichtbaren aktivierbar machen
              checkbox.disabled = false;
              checkbox.style.opacity = '1';
              
              const parentLabel = checkbox.closest('label');
              if (parentLabel) {
                parentLabel.style.opacity = '1';
                parentLabel.style.pointerEvents = 'auto';
              }
            }
          }
        }
      });
    },    
    isElementVisible(element) {
      if (!element) return false;
      
      const style = window.getComputedStyle(element);
      return style.visibility !== 'hidden' && 
             style.display !== 'none' && 
             style.height !== '0px' &&
             element.offsetHeight > 0 &&
             element.offsetWidth > 0;
    },
    selectArticle(articleText) {
      const normalizedArticleText = (articleText ?? '').toString();
      this.closeProductSearch();
      const inputElement = this.$refs.searchInput;
      if (inputElement) {
          inputElement.value = normalizedArticleText;
          this.searchTextArticle = normalizedArticleText;
          return this.changeArticleByText();
      }
    },
    selectPositionContentFromCart() {
      this.$refs.positionInput.focus();
      this.$refs.positionInput.select();
      this.$refs.positionInput.scrollIntoView({ behavior: 'smooth' });
    },
    selectPositionContent() {
      this.$refs.positionInput.select();
    },
    selectInputContent() {
      this.$refs.searchInput.select();
      if (this.activeProductFilters.length > 0 || this.searchTextArticle?.trim()) {
        this.isProductSearchOpen = true;
      }
    },
    doesStepRuleMatch(rule) {
      const splittedStepRuleValue = (rule?.inhalt || '').split(";");
      const stepSelector = "#s_"+splittedStepRuleValue[0];
      const divElement = this.$refs.dynamicContent?.querySelector(stepSelector)
        || document.getElementById("s_"+splittedStepRuleValue[0]);
      if (divElement == null) return false;

      const targetElement = divElement.querySelector("."+splittedStepRuleValue[1]);
      const ruleValue = (splittedStepRuleValue[2] || '').toString().trim();
      // PG 450: Eine Mindestbreite ist erreicht, sobald einer der beiden Flügel sie erreicht.
      if ([10, 11, 12].includes(Number(this.selectedArticle))
        && rule.bool_type == 3 && targetElement?.matches('.wing_l_value')) {
        return ['.wing_l_value', '.wing_r_value'].some(selector => {
          const width = this.getNumericInputValue(divElement.querySelector(selector));
          return width !== null && width >= Number(ruleValue);
        });
      }

      const targetValue = (targetElement?.value || '').toString().trim();
      if (targetValue.length === 0) return false;

      const targetNumber = Number(targetValue);
      const ruleNumber = Number(ruleValue);
      const bothNumeric = !isNaN(targetNumber) && !isNaN(ruleNumber);

      // ==
      if (rule.bool_type == 0) {
        return bothNumeric
          ? targetNumber == ruleNumber
          : targetValue == ruleValue;
      }
      // <=
      if (rule.bool_type == 2 && bothNumeric) {
        return targetNumber <= ruleNumber;
      }
      // >=
      if (rule.bool_type == 3 && bothNumeric) {
        return targetNumber >= ruleNumber;
      }

      return false;
    },
    filterStepsByStepRules() {
      for (let i = 0; i < this.filteredStepItems.length; ++i) {
        const step = this.filteredStepItems[i];
        const rules = step.rules || [];
        const requirement = this.$refs.dynamicContent?.querySelector(`#s_${step.id} [data-requires-inputs]`);
        const missingInputs = requirement && requirement.dataset.requiresInputs.split(',')
          .some(selector => !this.$refs.dynamicContent.querySelector(selector.trim())?.value.trim());
        step.isHiddenByRule = Boolean(missingInputs)
          || (rules.length > 0 && !rules.some(rule => this.doesStepRuleMatch(rule)));
        if (requirement) requirement.hidden = step.isHiddenByRule;
      }
    },
    async setKaempferVisibilityXLVersion() {
      // ID 37 Kämpfer links
      // ID 38 Kämfper höhe
      const dynamicContent = this.$refs.dynamicContent;
      if (!dynamicContent) return;

      const kaempferLinks = dynamicContent.querySelector("#s_37");
      const kaempferHoehe = dynamicContent.querySelector("#s_38");

      // Ursprüngliche Styles zwischenspeichern (nur einmal)
      if (kaempferLinks && kaempferLinks.style.visibility != 'hidden' && !kaempferLinks.dataset.origStyle) {
        kaempferLinks.dataset.origStyle = kaempferLinks.getAttribute('style') || '';
      }
      if (kaempferHoehe && kaempferHoehe.style.visibility != 'hidden' && !kaempferHoehe.dataset.origStyle) {
        kaempferHoehe.dataset.origStyle = kaempferHoehe.getAttribute('style') || '';
      }

      // Standardmäßig beide anzeigen
      if (this.isHeightForKaempfer && kaempferHoehe) {
        kaempferHoehe.setAttribute('style', kaempferHoehe.dataset.origStyle || '');
      }
      if (this.isWidthForKaempfer && kaempferLinks) {
        kaempferLinks.setAttribute('style', kaempferLinks.dataset.origStyle || '');
      }
      
      // XL-Checkbox-Zustand nach Kämpfer-Änderungen überprüfen
      setTimeout(() => this.checkAndManageXLCheckboxes(), 50);

      // Bildcache zurücksetzen und Debounce-Ladevorgang starten (kein direktes Laden mehr)
      this.lastImageLoadConfig = null;
      this.debouncedImageLoad();
    },
    async setVisibilityOfXLValue(visibility) {
      const xlValueElements = this.$refs.dynamicContent.querySelectorAll(".xl_value");
      xlValueElements.forEach(xlValueElement => {
        const parent = xlValueElement.parentElement;
        if (!parent) return;
        parent.style.display = visibility ? 'block' : 'none';
      });
    },
    determinePriorityFolders() {
      if (this.$refs.dynamicContent?.querySelector('input.griffleiste_i_value:checked')) {
        return 'Griffleiste-I';
      }

      // Ermittelt den Prioritäts-Ordner abhängig von Kämpfer / XL Auswahl
      let kaempferRechts = false;
      let kaempferHoehe = false;
      let kaempferLinksXLFolder = '';
      let kaempferSenkrecht = false;
      let priorityFolders = 'ohne';
      let width = null;
      let height = null;

      const filteredStepListItems = this.filteredStepItems;
      for (let i = 0; i < filteredStepListItems.length; ++i) {
        if (filteredStepListItems[i].id == 37 && !filteredStepListItems[i].isHiddenByRule) kaempferRechts = true;
        if (filteredStepListItems[i].id == 38 && !filteredStepListItems[i].isHiddenByRule) kaempferHoehe = true;
      }

      if (this.$refs.dynamicContent) {
        const dimensionsStep = this.$refs.dynamicContent.querySelector('#s_1');
        width = dimensionsStep?.querySelector('.x_value')?.value ?? null;
        height = dimensionsStep?.querySelector('.y_value')?.value ?? null;

        const allCheckboxes = this.$refs.dynamicContent.querySelectorAll('input[type="checkbox"]');
        allCheckboxes.forEach(checkbox => {
          const checkboxClasses = Array.from(checkbox.classList);
          const isXL = checkboxClasses.some(cls => cls.toLowerCase().includes('xl'));
          if (isXL && checkbox.checked) {
            const configuredXLFolder = checkbox.dataset.imagePriority?.trim();
            if (configuredXLFolder) {
              kaempferLinksXLFolder = configuredXLFolder;
              return;
            }
            const parentStep = checkbox.closest('[id^="s_"]');
            if (parentStep) {
              const stepId = parentStep.id.replace('s_', '');
              if (stepId == '37' || parentStep.querySelector('.kaempfer_senkrecht_value')) {
                kaempferLinksXLFolder = getKaempferLinksXLFolder(stepId);
              }
              if (stepId == '38') kaempferSenkrecht = true;
            }
          }
        });
      }

      if (kaempferLinksXLFolder) {
        priorityFolders = kaempferLinksXLFolder;
      } else if (kaempferSenkrecht) {
        priorityFolders = shouldUseXLhochK29(width, height, true)
          ? 'XLhochK29'
          : 'XLhoch';
      } else {
        if (kaempferRechts && kaempferHoehe) priorityFolders = 'KK';
        else if (kaempferRechts)           priorityFolders = 'KS';
        else if (kaempferHoehe)            priorityFolders = 'KW';
      }

      return priorityFolders;
    },

    buildPriorityParam() {
      const base = this.determinePriorityFolders();

      // manuelle CSV-Eingabe (falls genutzt)
      const manualExtras = (this.priorityFolderExtras || '')
        .split(',')
        .map(s => s.trim())
        .filter(Boolean);

      // dynamisch aus Selects mit fld:-Prefix auslesen
      const dom = this.$refs.dynamicContent;
      const fldExtras = dom
        ? Array.from(dom.querySelectorAll('select.select'))
            .filter(sel => {
              const stepId = sel.closest('[id^="s_"]')?.id.slice(2);
              const step = this.filteredStepItems.find(item => String(item.id) === stepId);
              return !step?.isHiddenByRule && Number(step?.type) !== 3;
            })
            .map(sel => {
              const value = String(sel.value || '');
              if (value.startsWith('fld:')) return value.slice(4);

              const label = sel.closest('.input-container')?.querySelector('.container-input-label')?.textContent.trim();
              return label === 'Schieberichtung:'
                ? getSlidingDirectionFolder(sel.selectedOptions[0]?.textContent || value)
                : '';
            })
            .filter(Boolean)
        : [];

      const extras = [...manualExtras, ...fldExtras];
      let parts = [base, ...extras].filter(Boolean);

      // 'ohne' nur behalten, wenn sonst nichts gesetzt wurde
      if (parts.length > 1 && parts[0] === 'ohne') {
        parts = parts.slice(1);
      }

      return Array.from(new Set(parts)).join(',');
    },

    async selectedArticleProperties() {
      setTimeout(() => this.setVisibilityOfXLValue(false), 1000);
      for (let i = 0; i < this.filteredFittingProperties.length; ++i) {
        if (this.filteredFittingProperties[i].element_replace_html_id != null && this.filteredFittingProperties[i].element_replace_html_id.includes("beschlag-name")) {
          this.fittingNameHtml = this.filteredFittingProperties[i].html;
        } else if (this.filteredFittingProperties[i].element_replace_html_id != null && this.filteredFittingProperties[i].element_replace_html_id.includes("beschlag-bild")) {
          this.fittingImageHtml = this.filteredFittingProperties[i].html;
        } 
        else if (this.filteredFittingProperties[i].element_replace_html_id != null && this.filteredFittingProperties[i].element_replace_html_id.includes("beschlag-beschreibung")) {
          this.fittingDescriptionHtml = this.filteredFittingProperties[i].html;
        }
        else if (this.filteredFittingProperties[i].element_replace_html_id != null && this.filteredFittingProperties[i].element_replace_html_id.includes("xl-version")) {
          setTimeout(() => this.setVisibilityOfXLValue(true), 1000);
        }
      }
    },
    getLoggedInUser() {
      return this.configuratorContext ? this.configuratorContext.loggedInUser : this.$parent.getLoggedInUser();
    },
    getCompany() {
      return this.configuratorContext ? this.configuratorContext.company : this.$parent.getCompany();
    },
    async loadImagesForArticle() {
      if (this.isExternal && (this.selectedArticle == null || !this.searchTextArticle)) { this.images = []; return; }
      try {
        // Konfig-Schlüssel erstellen (macht Requests idempotent)
        const config = this.getCurrentImageConfig();
        const key = JSON.stringify(config);

        // Wenn identischer Request noch läuft, hänge dich dran
        if (this.inFlightImagesKey === key && this.inFlightImagesPromise) {
          await this.inFlightImagesPromise;
          return;
        }

        // Mindestabstand einhalten (gegen 429)
        const now = Date.now();
        const since = now - this.lastImagesCallAt;
        if (since < this.imagesMinIntervalMs) {
          await new Promise(r => setTimeout(r, this.imagesMinIntervalMs - since));
        }

        // Älteren Bild-Request abbrechen
        if (this.imageRequestAbortController) {
          this.imageRequestAbortController.abort();
        }
        this.imageRequestAbortController = new AbortController();

        // Flags setzen
        this.inFlightImagesKey = key;
        this.inFlightImagesPromise = (async () => {
          const priorityFolders = this.buildPriorityParam();

          // --- eigentlicher API-Call, jetzt abbrechbar und gedrosselt ---
          const res = await this.configuratorApi.loadProductImages(
            { articleId: Number(this.selectedArticle), variant: this.searchTextArticle, folder: this.selectedArticleName, priority: priorityFolders },
            {
              signal: this.imageRequestAbortController.signal,
              // Optional: kleines Server-Caching via If-None-Match/If-Modified-Since, falls implementiert
            }
          );

          const currentImage = this.images[this.currentImageIndex];
          const nextImages = res.data.images.map(img => this.configuratorApi.imageUrl(img));
          const preservedImageIndex = currentImage ? nextImages.indexOf(currentImage) : -1;

          this.images = nextImages;
          this.currentImageIndex = preservedImageIndex >= 0 ? preservedImageIndex : 0;
          this.lastImagesCallAt = Date.now();
        })();

        await this.inFlightImagesPromise;
      } catch (error) {
        // Abgebrochen? -> leise ignorieren
        if (api.isCancel?.(error) || error?.name === 'CanceledError' || error?.message?.includes('aborted')) {
          return;
        }
        if (!this.isExternal) console.error('Fehler beim Laden der Bilderliste:', error);
        this.images = [];
      } finally {
        // In-Flight Slot freigeben
        this.inFlightImagesKey = null;
        this.inFlightImagesPromise = null;
      }
    },
    prevImage() {
      if (this.images.length > 0) {
        this.currentImageIndex = (this.currentImageIndex - 1 + this.images.length) % this.images.length;
        this.resetImagePopupScroll();
      }
    },
    nextImage() {
      if (this.images.length > 0) {
        this.currentImageIndex = (this.currentImageIndex + 1) % this.images.length;
        this.resetImagePopupScroll();
      }
    }
  },
  computed: {
    configuratorContext() { return this.getConfiguratorContext?.() || null; },
    configuratorApi() { return this.configuratorContext?.api || createInternalConfiguratorApi(() => this.selectedProject); },
    isExternal() { return this.configuratorContext?.mode === EXTERNAL; },
    showPrices() { return !this.isExternal || this.configuratorContext.capabilities.showPrices; },
    teuerungszuschlagCompanyId() {
      return this.isExternal ? null : this.getCompany()?.id ?? null;
    },
    priceWithTeuerungszuschlag() {
      if (this.isExternal || this.teuerungszuschlagRate === null || this.isCalculatingPrice
          || this.rasterDimensionError || !(this.price > (this.getAccessoryElement() ? 0 : 1))) {
        return null;
      }

      const priceCents = Math.round(this.price * 100);
      const surchargeCents = Math.round(priceCents * this.teuerungszuschlagRate / 100);
      return (priceCents + surchargeCents) / 100;
    },
    availableProductSearchFilters() {
      if (!this.isExternal) return this.productSearchFilters;
      return this.productSearchFilters.filter(filter => filter.articleIds.some(id =>
        this.articleLists.some(article => Number(article.id) === id)));
    },
    formattedAnzahl() {
      if (this.isEmptyAnzahl(this.anzahl)) {
        return '';
      }

      return this.formatIntegerValue(this.anzahl);
    },
    isInternalAdmin() {
      if (this.isExternal) return false;
      const role = this.getLoggedInUser()?.role;
      return role === 'internal_admin' || role === 'admin';
    },
    isSelectedProjectOrdered() {
      return !!(
        this.selectedProject?.manual_offer_ordered_at ||
        this.selectedProject?.has_order ||
        this.selectedProject?.hasOrder ||
        this.selectedProject?.order_sent_at ||
        this.selectedProject?.orderSentAt
      );
    },
    isSelectedProjectRequestSent() {
      return !!(
        this.selectedProject?.has_request ||
        this.selectedProject?.hasRequest ||
        this.selectedProject?.request_sent_at ||
        this.selectedProject?.requestSentAt
      );
    },
    isSelectedProjectReadOnly() {
      return this.isSelectedProjectOrdered || (
        !this.isInternalAdmin && (
          this.isSelectedProjectRequestSent ||
          !!this.selectedProject?.internal_admin_edited_at
        )
      );
    },
    projectReadOnlyMessage() {
      if (this.isSelectedProjectOrdered) {
        return 'Dieses Projekt wurde bereits bestellt und ist nicht mehr bearbeitbar.';
      }

      if (this.isSelectedProjectRequestSent) {
        return 'Für dieses Projekt wurde bereits eine Anfrage gesendet. Es ist nicht mehr bearbeitbar.';
      }

      return `Dieses Projekt wurde von ${this.projectReadOnlyEditorLabel} bearbeitet und ist für Sie nur noch lesbar.`;
    },
    projectReadOnlyEditorLabel() {
      const editor = this.selectedProject?.internal_admin_edited_by;
      return this.userNameWithEmail(editor, 'Ansprechpartner/SB');
    },
    isImageZoomed() {
      return this.imageZoom > 100;
    },
    isImagePannable() {
      return this.isImageOverflowX || this.isImageOverflowY;
    },
    isImageOverflowX() {
      if (!this.imageBaseWidth || !this.imageViewportWidth) return this.isImageZoomed;

      return this.imageBaseWidth * (this.imageZoom / 100) > this.imageViewportWidth + 1;
    },
    isImageOverflowY() {
      if (!this.imageBaseHeight || !this.imageViewportHeight) return this.isImageZoomed;

      return this.imageBaseHeight * (this.imageZoom / 100) > this.imageViewportHeight + 1;
    },
    imagePopupImageStyle() {
      if (!this.imageBaseWidth || !this.imageBaseHeight) return {};

      return {
        width: `${this.imageBaseWidth * (this.imageZoom / 100)}px`,
        height: `${this.imageBaseHeight * (this.imageZoom / 100)}px`,
      };
    },
    visibleAddedItems() {
      return expandDimensionItems(this.addedItems || []).filter(item => !this.shouldHideAddedItem(item));
    },
    currentImageSrc() {
      return this.images[this.currentImageIndex] || productImageFallback;
    },
    productSearchArticleIds() {
      return new Set(this.productSearchFilters
        .filter(filter => this.activeProductFilters.includes(filter.key))
        .flatMap(filter => filter.articleIds));
    },
    productSearchFilterStatus() {
      if (this.activeProductFilters.length === 0) return 'Alle Produkte';
      if (this.activeProductFilters.length === 1) {
        return this.productSearchFilters.find(filter => filter.key === this.activeProductFilters[0])?.label || '';
      }
      return `${this.activeProductFilters.length} Bereiche aktiv`;
    },
    productSearchKeywords() {
      if (this.activeProductFilters.length === 0) return this.allArticleKeywords;
      return this.articleLists
        .filter(article => this.isArticleInSearchFilters(article.id))
        .flatMap(article => String(article.keywords || '').split(';'))
        .filter(keyword => keyword.trim());
    },
    filterAllArticleKeywords() {
      const needle = this.isProductSearchOpen && this.selectedArticle != null
        ? '' : (this.searchTextArticle ?? '').toString().toLowerCase();
      return this.productSearchKeywords
        .filter(articleKeyword => (articleKeyword ?? '').toString().toLowerCase().includes(needle));
    },
    filteredArticleItems() {
      const needle = (this.searchTextArticle ?? '').toString().toLowerCase();
      return this.articleLists.filter(item => {
        let keywordsString = (item.keywords ?? '').split(";");
        for (let i = 0; i < keywordsString.length; ++i) {
          if ((keywordsString[i] ?? '').toString().toLowerCase() == needle) {
            return true;
          }
        }
        return false;
      }
      );
    },
    filteredFittingProperties() {
      return this.fittingPropertyList.filter(item => {
        const rawSearch = (this.searchTextArticle ?? '').toString();
        let tmpSearchTextArticle = rawSearch;
        let tmpSearchTextArticleSplitted =  rawSearch.split(" - ");
        if (tmpSearchTextArticleSplitted.length > 0) {
          tmpSearchTextArticle = tmpSearchTextArticleSplitted[0];
          this.selectedArticleName = tmpSearchTextArticle;
        }

        const normalize = (s) =>
          (s || '')
            .normalize('NFKC')
            .replace(/[\u2010-\u2015]/g, '-') // verschiedene Dash-Typen auf Minus
            .replace(/\u00A0/g, ' ')           // geschützte Leerzeichen -> Space
            .trim()
            .toLowerCase();

        const needle = normalize(tmpSearchTextArticle);
        const keywordsArray = (item.keywords ?? '').split(';').map(normalize);
        for (let i = 0; i < keywordsArray.length; ++i) {
          if (keywordsArray[i] === needle) {
            return true;
          }
        }

        return false;
      }
      );
    },
    filteredStepItems() {
      const rawSearch = (this.searchTextArticle ?? '').toString();
      let tmpSearchTextArticle = rawSearch;
      let tmpSearchTextArticleSplitted = rawSearch.split(" - ");
      if (tmpSearchTextArticleSplitted.length > 0) {
        tmpSearchTextArticle = tmpSearchTextArticleSplitted[0];
      }

      let filteredStepLists = this.stepLists.filter(item => {
        if (item.artikel_id !== this.selectedArticle) {
          return false;
        }

        if (!item.keywords) {
          return true;
        }

        const normalize = (s) =>
          (s || '')
            .normalize('NFKC')
            .replace(/[\u2010-\u2015]/g, '-') // verschiedene Dash-Typen auf Minus
            .replace(/\u00A0/g, ' ')           // geschützte Leerzeichen -> Space
            .trim()
            .toLowerCase();

        const needle = normalize(tmpSearchTextArticle);
        const keywordsArray = (item.keywords ?? '').split(';').map(normalize);
        for (let i = 0; i < keywordsArray.length; ++i) {
          if (keywordsArray[i] === needle) {
            return true;
          }
        }

        return false;
      });

      return filteredStepLists;
    },
    filteredExtraChargeItems() {
      return this.chargePrices.filter(item => 
        item.artikel_id == this.selectedArticle
        && item.type == 4
      );
    },
    filteredPriceListItems() {
      return this.priceLists.filter(item => 
        item.artikel_id == this.selectedArticle
      );
    },
    formattedPosition() {
      return this.position < 10 ? `0${this.position}` : `${this.position}`;
    }
  },
  mounted() {
    this.observer = new MutationObserver(() => {
      if (this.rebindPending) return;
      this.rebindPending = true;
      // Einmal pro "Frame" alle Rebinds bündeln
      requestAnimationFrame(() => {
        try {
          if (!this.$refs.dynamicContent) {
            return;
          }

          this.bindRAMInputListeners();
          this.bindZAMInputListeners();
          this.bindSMASSInputListeners();
          this.bindSMASSSelectBoxListeners();
          this.bindDichtbandSMASSListeners();
          this.bindStulpListeners();
          this.refreshEventListener();
        } finally {
          this.rebindPending = false;
        }
      });
    });

    this.observer.observe(this.$refs.dynamicContent, {
      childList: true,
      subtree: true,
    });

    // Initial bind
    this.bindRAMInputListeners();
    this.bindZAMInputListeners();
    this.bindSMASSInputListeners();
    this.bindSMASSSelectBoxListeners(); 
    this.bindDichtbandSMASSListeners();
    this.bindStulpListeners();
    this.refreshEventListener();
  },
  beforeUnmount() {
    this.unlockPageScrollForImagePopup();

    // Cleanup debounce timer
    if (this.calcTimerId) {
      clearTimeout(this.calcTimerId);
      this.calcTimerId = null;
    }
    if (this.imageLoadDebounce) {
      clearTimeout(this.imageLoadDebounce);
    }
    
    // Disconnect mutation observer
    this.observer.disconnect();
    
    // Remove event listeners
    this.$refs.dynamicContent.querySelectorAll('.select').forEach(selectbox => {
      selectbox.removeEventListener('change', this.refreshPriceList);
    });
    this.$refs.dynamicContent.querySelectorAll('select.select[data-exclusive-group]').forEach(selectbox => {
      selectbox.removeEventListener('change', this.handleExclusiveSelectChange);
    });
    this.$refs.dynamicContent.querySelectorAll('.input').forEach(input => {
      input.removeEventListener('input', this.refreshPriceList);
    });
    this.$refs.dynamicContent.querySelectorAll('.input').forEach(checkbox => {
      checkbox.removeEventListener('change', this.refreshPriceList);
    });
    this.$refs.dynamicContent.querySelectorAll('.category-title').forEach(element => {
      element.removeEventListener('click', this.toggle);
    });
  },
  async created() {
    try {
      const catalog = await this.configuratorApi.loadCatalog();
      this.articleLists = catalog.articles;
      this.allArticleKeywords = this.articleLists.flatMap(article => article.keywords.split(';'));
      this.stepRules = catalog.stepRules;
      this.stepLists = catalog.steps;
      this.stepLists.forEach(step => { step.rules = this.stepRules.filter(rule => rule.schritt_id == step.id); });
      this.stepPrices = catalog.stepPrices;
      this.chargePrices = catalog.surcharges;
      this.ralFarben = catalog.ralColors;
      this.priceLists = catalog.priceLists;
      this.fittingPropertyList = catalog.fittingProperties;
    } catch (error) {
      if (this.isExternal) this.showError('Die Konfiguratordaten konnten nicht geladen werden.');
      else throw error;
    }
  },
};
</script>

<style>
  @import '@/styles/MainComponent.css';
</style>
